import type { TranslationDictionary } from '@eliadmin/core/src/i18n/translation-snapshot-types';

export const GENERATED_TRANSLATIONS = Object.freeze({
  "text1": "Vyhledávání",
  "text2": "Vaše objednávka",
  "text3": "Čekání na platbu bankovním převodem",
  "text4": "Dobrý den",
  "text5": "Pro objednávku",
  "text6": "očekáváme platbu bankovním převodem.",
  "text7": "Objednávka doručena",
  "text8": "Vaše objednávka byla úspěšně doručena.",
  "text9": "Parametry",
  "text10": "Facebook",
  "text11": "Objednávka odeslána",
  "text12": "je na cestě k vám.",
  "text13": "Detailní pohyb Vaší zásilky můžete sledovat kliknutím na číslo zásilky.",
  "text14": "Sledovací číslo zásilky:",
  "text15": "děkujeme za Váš nákup",
  "text16": "Vaši objednávku registrujeme pod číslem",
  "text17": "Detail objednávky",
  "text18": "Vytvořena:",
  "text19": "Kód",
  "text20": "Produkt",
  "text21": "Jednotková cena",
  "text22": "Množství",
  "text23": "Celková cena",
  "text24": "Sleva",
  "text25": "Slevy",
  "text26": "Celková částka",
  "text27": "Platební údaje",
  "text28": "IBAN",
  "text29": "Finanční instituce",
  "text30": "Částka",
  "text31": "Variabilní symbol",
  "text32": "Doručovací adresa",
  "text33": "Jméno",
  "text34": "Příjmení",
  "text35": "E-mail",
  "text36": "Telefon",
  "text37": "Obchodní jméno",
  "text38": "Ulice",
  "text39": "Město",
  "text40": "PSČ",
  "text41": "Stát",
  "text42": "IČ",
  "text43": "DIČ",
  "text44": "DPH",
  "text45": "Fakturační adresa",
  "text46": "Objednávka zrušena",
  "text47": "bylo zrušeno.",
  "text48": "Platba přijata",
  "text49": "byla zaplacena.",
  "text50": "Stav objednávky může být sledován také po přihlášení k uživatelskému účtu.",
  "text51": "Přihlásit se k mému účtu",
  "text52": "Vrácená objednávka",
  "text53": "byla vrácena",
  "text54": "Vrácení peněz",
  "text55": "Pro objednávku",
  "text56": "Peníze vám byly vráceny.",
  "text57": "Poznámka",
  "text58": "Cena dopravy",
  "text59": "Cena platby",
  "text60": "Podobné produkty",
  "text61": "Oblíbené produkty",
  "text62": "Objednávka byla přijata",
  "text63": "Objednávka",
  "text64": "DPH",
  "text65": "č.",
  "text66": "je na cestě k vám.",
  "text67": "Registrace úspěšná",
  "text68": "Vaše registrace byla úspěšná.",
  "text69": "Vygenerované heslo:",
  "text70": "Po přihlášení doporučujeme změnit heslo.",
  "text71": "Ke svému účtu se můžete přihlásit v sekci",
  "text72": "Uživatelský účet",
  "text73": "nebo kliknutím na tlačítko přihlásit se",
  "text74": "Přihlásit se k mému účtu",
  "text75": "MŮJ EMAIL:",
  "text76": "ODKAZ NA LEVNĚJŠÍ PRODUKT:",
  "text77": "ODKAZ NA VÁŠ PRODUKT:",
  "text78": "Přejeme vše nejlepší k narozeninám.",
  "text79": "ODKAZ NA PRODUKT:",
  "text80": "Zpráva:",
  "text81": "Předmět",
  "text82": "Kontaktní formulář",
  "text83": "jako projev důvěry Vám zasíláme slevový kupón",
  "text84": "ve výši",
  "text85": "Platnost kupónu je od",
  "text86": "do",
  "text87": "Odběr novinek",
  "text88": "kliknutím na tlačítko níže potvrdíte odběr novinek.",
  "text89": "Potvrdit odběr novinek",
  "text90": "Potvrzení položek",
  "text91": "Vámi vrácené zboží jsme přijali. Děkujeme velmi pěkně. Peníze už jsou na cestě k Vám. Způsob vrácení peněz bude záviset na způsobu platby, kterou jste si v objednávce vybrali.",
  "text92": "Pokud váš produkt informace, které jste nahlásili z vašeho uživatele účtů, různé z vrácených produktů, pak si vyhrazujeme právo znovu naúčtovat již zaplacenou částku vaší kreditní karty.",
  "text93": "Vezměte prosím na vědomí, že každý vrácený balík je zpracován zvlášť. V případě, že jste odeslali další produkty v jiném balíku, obdržíte samostatné potvrzení o přijetí.",
  "text94": "Vrácené produkty:",
  "text95": "kliknutím níže na tlačítko obnovíte heslo.",
  "text96": "Obnovit heslo",
  "text97": "Platba objednávky neproběhla správně",
  "text98": "Vaši platbu můžete zopakovat",
  "text99": "Kliknutím na tento odkaz budete přesměrováni na platební bránu.",
  "text100": "Děkujeme za Vaši objednávku",
  "text101": "Otázka",
  "text102": "Otázka k produktu:",
  "text103": "Žádost o vrácení",
  "text104": "obdrželi jsme Vaši žádost na vrácení. Můžete začít chystat balíček.",
  "text105": "Peníze Vám vrátíme ihned po obdržení vráceného zboží, nejpozději však do 14 dnů.",
  "text106": "Objednávali jste si zboží s platbou předem? Pokud jste zboží ještě nezaplatili, my upravíme částku k úhradě, aby nezahrnovala Vámi vrácené zboží.",
  "text107": "Vracíte:",
  "text108": "Číslo objednávky",
  "text109": "Vaše reklamace byla zrušena",
  "text110": "Vaše reklamace nebyla schválena",
  "text111": "Důvod",
  "text112": "Vaši reklamaci zpracováváme",
  "text113": "Vystavoval",
  "text114": "Strana 1/1",
  "text115": "Změna hesla",
  "text116": "Faktura",
  "text117": "Dodavatel",
  "text118": "Provoz",
  "text119": "Kupující",
  "text120": "Tel.",
  "text121": "Datum vystavení",
  "text122": "Datum doručení",
  "text123": "Datum splatnosti",
  "text124": "Způsob platby",
  "text125": "Způsob dopravy",
  "text126": "SWIFT",
  "text127": "Platební poplatky",
  "text128": "Zboží / Kód",
  "text129": "Základní cena / sleva",
  "text130": "Sazba DPH",
  "text131": "Počet",
  "text132": "Celkem s DPH",
  "text133": "Jedn. cena s DPH",
  "text134": "Přepravní poplatky",
  "text135": "Daňový doklad k přijaté platbě.",
  "text136": "Celkem bez DPH",
  "text137": "Celkem DPH",
  "text138": "Celkem",
  "text139": "Konstantní symbol",
  "text140": "Částka k vrácení",
  "text141": "Dobropis",
  "text142": "k faktuře",
  "text143": "Dodací list",
  "text144": "Dodací list č.",
  "text145": "Prodal",
  "text146": "Převzal",
  "text147": "Datum",
  "text148": "Údaje o DPH (CZK)",
  "text149": "Sazba DPH",
  "text150": "Produkty",
  "text151": "Faktura č.",
  "text152": "Podrobnosti (CZK)",
  "text153": "Doprava",
  "text154": "Objednávky",
  "text155": "Číslo obj.",
  "text156": "Zákazník",
  "text157": "Adresa",
  "text158": "Platba",
  "text159": "Zálohová faktura č.",
  "text160": "Domů",
  "text161": "Blog",
  "text162": "Hledaný výraz...",
  "text163": "Nákupní košík",
  "text164": "Cena",
  "text165": "Celkem",
  "text166": "Aktualizace košíku",
  "text167": "Slevový kupón",
  "text168": "Odeslat objednávku",
  "text169": "Shrnutí objednávky",
  "text170": "Cena produktu",
  "text171": "Nákupní košík je prázdný",
  "text172": "Nakupovat",
  "text173": "produktů",
  "text174": "Filtrovat",
  "text175": "Výrobce",
  "text176": "Kategorie",
  "text177": "Nejlevnější",
  "text178": "Nejdražší",
  "text179": "Nejnovější",
  "text180": "Nejstarší",
  "text181": "Nejprodávanější",
  "text182": "Odebírat",
  "text183": "Vaše emailová adresa",
  "text184": "Zaregistrujte se k odběru našeho Newsletteru a využijte exkluzivní výhody!",
  "text185": "Odeslat",
  "text186": "Kontakt",
  "text187": "Změnit heslo",
  "text188": "Zapomněli jste heslo?",
  "text189": "Přihlásit se",
  "text190": "Přihlášení",
  "text191": "Heslo",
  "text192": "Registrovat se",
  "text193": "Ještě nemáte účet?",
  "text194": "Oops... stránka kterou hledáte neexistuje.",
  "text195": "Výrobci",
  "text196": "Zobrazit více produktů",
  "text197": "Můj účet",
  "text198": "Osobní údaje",
  "text199": "Firemní údaje",
  "text200": "Firma",
  "text201": "Uložit",
  "text202": "Staré heslo",
  "text203": "Nové heslo",
  "text204": "Změna hesla",
  "text205": "Celý článek",
  "text206": "Vaše objednávka byla přijata, bohužel platba neproběhla úspěšně. Prosím zkontrolujte Váš email pro více informací o stavu objednávky.",
  "text207": "Zaplatit objednávku",
  "text208": "Pokračovat v nákupu",
  "text209": "Mohlo by vás zajímat",
  "text210": "Koupit",
  "text211": "Vyhledávání",
  "text212": "Položka/y",
  "text213": "Vyhledávání",
  "text214": "Doručení do druhého dne",
  "text215": "V rámci České republiky",
  "text216": "Dárek zdarma",
  "text217": "Ke každé objednávce",
  "text218": "Garance doručení",
  "text219": "nepoškozeného zboží",
  "text220": "300 výdejních míst",
  "text221": "na území Slovenska a Česka",
  "text222": "Nejnovější produkty",
  "text223": "Top produkty",
  "text224": "Top články",
  "text225": "Cena s DPH",
  "text226": "Cena bez DPH",
  "text227": "Přidat do košíku",
  "text228": "Kód produktu:",
  "text229": "Sdílet",
  "text230": "Kategorie:",
  "text231": "Popis produktu",
  "text232": "Příslušenství",
  "text233": "Další informace",
  "text234": "Newsletter již odebíráte",
  "text235": "Pokračovat v nakupování",
  "text236": "Úspěšně jste se přihlásili k odběru newsletteru",
  "text237": "Dostupnost:",
  "text238": "Skladem",
  "text239": "K objednání",
  "text240": "O nás",
  "text241": "Filtr",
  "text242": "produktů",
  "text243": "Seřadit od:",
  "text244": "Vynulovat filtr",
  "text245": "Stav objednávky",
  "text246": "Zpět",
  "text247": "Velikost:",
  "text248": "ks",
  "text249": "CZE",
  "text250": "Změnit avatara",
  "text251": "Úspěšně jste se přihlásili",
  "text252": "Muž",
  "text253": "Žena",
  "text254": "Jiné",
  "text255": "Pohlaví",
  "text256": "Ahoj",
  "text257": "Mé objednávky",
  "text258": "Odhlásit se",
  "text259": "Zadejte Váš email",
  "text260": "Trvalé přihlášení",
  "text261": "Registrace",
  "text262": "Registrace nového účtu",
  "text263": "Zopakovat heslo",
  "text264": "Souhlasím s",
  "text265": "obchodními podmínkami",
  "text266": "Už mám účet a chci se přihlásit",
  "text267": "Informace o cookies",
  "text268": "Kliknutím na tlačítko Souhlasím se vším se uloží technické, analytické a marketingové soubory cookie, abychom vám mohli umožnit pohodlné používání stránek, měřit funkčnost našich stránek a cílit na vás reklamu. Své preference můžete jednoduše upravit kliknutím na Nastavení souborů cookie.",
  "text269": "Souhlasím se vším",
  "text270": "Nastavení cookies",
  "text271": "Uložit nastavení",
  "text272": "Zavřít",
  "text273": "Cookies",
  "text274": "Popis",
  "text275": "Používáme cookies",
  "text276": "Soubory cookie používáme k analýze údajů o našich návštěvnících, ke zlepšení našich webových stránek, zobrazení personalizovaného obsahu a k tomu, abychom vám poskytli skvělý zážitek z webu. Používáním tohoto webu s tímto používáním souhlasíte.",
  "text277": "Technické cookies",
  "text278": "Tyto soubory cookie jsou nezbytné pro fungování webových stránek, není tedy možné je zakázat. Obvykle se nastavují v reakci na akci, kterou na webu sami provedete, jako je nastavení zabezpečení, přihlášení a vyplňování formulářů. Svůj prohlížeč můžete nastavit tak, aby blokoval soubory cookie nebo o nich zasílal upozornění. Mějte na paměti, že některé stránky nebudou bez těchto souborů fungovat. Tyto soubory cookie neukládají žádné informace, které lze přiřadit konkrétní osobě. Tyto soubory cookie můžeme nastavit my nebo poskytovatelé třetích stran, jejichž služby na webu využíváme. Tyto soubory cookie neukládají žádné informace, které lze přiřadit konkrétní osobě.",
  "text279": "Vaše nastavení cookies z tohoto dialogu",
  "text280": "Analytické cookies",
  "text281": "Tyto soubory cookie se používají ke zlepšení fungování webových stránek. Umožňují nám rozpoznat a sledovat počet návštěvníků a sledovat, jak návštěvníci web používají. Pomáhají nám zlepšovat způsob, jakým webové stránky fungují, například tím, že uživatelům umožňují snadno nalézt to, co hledají. Tyto soubory cookie neshromažďují informace, které by vás mohly identifikovat. Pomocí těchto nástrojů analyzujeme a pravidelně zlepšujeme funkčnost našich webových stránek. Získané statistiky můžeme využít ke zlepšení uživatelského komfortu a k tomu, aby byla návštěva Webu pro vás jako uživatele zajímavější.",
  "text282": "Google Analytics - ukládá a počítá počet zobrazení stránek a chování webu",
  "text283": "Google Tag Manager - propojení konverzí",
  "text284": "Incomaker - ukládá a počítá zobrazení stránek a konverze",
  "text285": "Marketingové cookies",
  "text286": "Používají se ke sledování preferencí webu uživatele za účelem zacílení reklamy, tj. zobrazování marketingových a reklamních sdělení (i na stránkách třetích stran), které mohou návštěvníka webu zajímat, v souladu s těmito preferencemi. Marketingové cookies využívají nástroje externích společností. Tyto marketingové soubory cookie budou použity pouze s vaším souhlasem.",
  "text287": "Facebook Pixel - zobrazování reklam a předávání informací do Facebooku",
  "text288": "Nahrát",
  "text289": "Výměna zboží",
  "text290": "Vrácení peněz",
  "text291": "Údaje zákazníka",
  "text292": "Číslo faktury",
  "text293": "Bankovní údaje",
  "text294": "IBAN",
  "text295": "SWIFT",
  "text296": "Důvod vrácení",
  "text297": "Vyberte položku ze seznamu, kterou chcete vrátit.",
  "text298": "E-shop",
  "text299": "Kamenný obchod",
  "text300": "E-shop + Kamenný obchod",
  "text301": "Obdrželi jsme Vaši žádost na vrácení. Můžete začít chystat balíček.",
  "text302": "Peníze Vám vrátíme okamžitě po obdržení Vámi vráceného zboží, nejpozději do 14 dnů.",
  "text303": "Objednávali jste si zboží s platbou předem? Pokud jste zboží ještě nezaplatili, my upravíme částku k úhradě, aby nezahrnovala Vámi vrácené zboží.",
  "text304": "Vracíte:",
  "text305": "Číslo objednávky:",
  "text306": "Vámi vrácené zboží jsme přijali. Děkujeme velmi pěkně. Peníze už jsou na cestě k Vám. Způsob vrácení peněz bude záviset na způsobu platby, kterou jste si v objednávce vybrali.",
  "text307": "Pokud by se Vaše údaje o produktech, které jste nahlásili ze svého uživatelského účtu, lišily od vrácených produktů, pak si vyhrazujeme právo opět zatížit Vaši kreditní kartu již uhrazenou částkou.",
  "text308": "Vezměte prosím na vědomí, že každý vrácený balík je zpracován zvlášť. V případě, že jste odeslali další produkty v jiném balíku, obdržíte samostatné potvrzení o přijetí.",
  "text309": "Vrácené produkty:",
  "text310": "Nová",
  "text311": "Schváleno",
  "text312": "Zamítnuta",
  "text313": "Zrušeno",
  "text314": "V procesu",
  "text315": "Žádost o vrácení",
  "text316": "Potvrzení položek",
  "text317": "Vaše reklamace byla zrušena",
  "text318": "Vaši reklamaci zpracováváme",
  "text319": "Vaše reklamace nebyla schválena",
  "text320": "Vaše žádost nebyla zpracována",
  "text321": "Odběr novinek",
  "text322": "/vymena-a-vraceni-zbozi",
  "text323": "Výměna a vrácení zboží",
  "text324": "Údaje firmy",
  "text325": "Doména Vašeho eshopu",
  "text326": "Přidat další doménu",
  "text327": "Další domény",
  "text328": "Název firmy",
  "text329": "Přidat adresu provozu",
  "text330": "Adresa provozu",
  "text331": "Název obchodu",
  "text332": "Přihlašovací jméno",
  "text333": "Přílohy",
  "text334": "Výpis z obchodního rejstříku",
  "text335": "Vyberte přílohu",
  "text336": "Souhlasím s obchodními podmínkami",
  "text337": "Podkategorie",
  "text338": "Zobrazit více",
  "text339": "Dostupnost",
  "text340": "Cena",
  "text341": "Filtrovat podle",
  "text342": "Vámi zvolený produkt byl přidán do košíku.",
  "text343": "Košík",
  "text344": "Cena platby",
  "text345": "Cena dopravy",
  "text346": "Zvolte způsob dopravy",
  "text347": "Číslo kupónu",
  "text348": "Zvolte způsob platby",
  "text349": "Zdarma",
  "text350": "Shrnutí objednávky",
  "text351": "Cena zboží",
  "text352": "Objednávka byla odeslána",
  "text353": "Vaše objednávka č.",
  "text354": "byla zaznamenána a aktuálně ji vyřizujeme. Prosím zkontrolujte si Váš email",
  "text355": "pro více informací o objednávce",
  "text356": "Potvrdit heslo",
  "text357": "Přihlaste se",
  "text358": "Máte účet?",
  "text359": "Dodací údaje",
  "text360": "Kontaktní údaje",
  "text361": "Nákup na firmu",
  "text362": "Vytvořte si účet a využívejte výhod registrovaného zákazníka.",
  "text363": "Souhlasím s obchodními podmínkami.",
  "text364": "Souhlasím s ochranou osobních údajů.",
  "text365": "Dodací adresa je jiná než fakturační",
  "text366": "Dropshipping",
  "text367": "Adresa provozu",
  "text368": "Nastavení osobních údajů",
  "text369": "Změnit adresu dodání",
  "text370": "Pokračovat do pokladny",
  "text371": "Odebírat novinky a dostávat aktuální informace o akcích",
  "text372": "Vrátit zboží",
  "text373": "Vrácené zboží",
  "text374": "Co si přejete vrátit?",
  "text375": "Za posledních 30 dní jste si nic neobjednali.",
  "text376": "Potvrdit vrácení produktů",
  "text377": "Zrušit",
  "text378": "muj-ucet-vracene-zbozi",
  "text379": "muj-ucet-vratit-zbozi-1",
  "text380": "muj-ucet-vratit-zbozi-2",
  "text381": "muj-ucet-vratit-zbozi-3",
  "text382": "Slovensko",
  "text383": "Česko",
  "text384": "Maďarsko",
  "text385": "Přihlašovací údaje",
  "text386": "Číst",
  "text387": "Ve vašem košíku",
  "text388": "Pro obnovu zapomenutého hesla zadejte Váš email",
  "text389": "Datum narození",
  "text390": "Použít",
  "text391": "/vseobecne-obchodni-podminky",
  "text392": "/ochrana-osobnich-udaju",
  "text393": "Datum objednávky",
  "text394": "Číslo objednávky",
  "text395": "Vyberte důvod",
  "text396": "Zboží neodpovídá popisu",
  "text397": "Obdržel jsem nesprávný produkt",
  "text398": "Tato položka se mi nelíbí",
  "text399": "Položka je příliš velký",
  "text400": "Produkt je poškozen",
  "text401": "Produkt přišel pozdě",
  "text402": "Produkt je příliš malý",
  "text403": "Produkt je příliš drahý",
  "text404": "Žádné podrobnosti",
  "text405": "Vrátit",
  "text406": "předmět/y společnosti",
  "text407": "Předměty, které vracíte společnosti",
  "text408": "Zaslali jsme Vám přehled Vámi vrácených produktů na",
  "text409": "Vaše produkty jsou připraveny k vrácení",
  "text410": "Co dál?",
  "text411": "Připravte balíček",
  "text412": "Nyní stačí balík odeslat",
  "text413": "Získejte zpět své peníze",
  "text414": "Zabalte požadované produkty, přibalte štítek pro vrácení zboží a na balík nalepte zpětnou adresu. A věděli jste, že zboží, které Vám přišlo v několika balíčcích, můžete vrátit společně v jednom balení? Jednoduše přibalte štítky o vrácení zboží z každé objednávky",
  "text415": "Balík odneste do nejbližšího logistického centra, které jste zvolili ve formuláři",
  "text416": "Peníze Vám vrátíme okamžitě po obdržení Vámi vráceného zboží, nejpozději do 14 dnů poté. Objednávali jste zboží s platbou předem? Pokud jste zboží ještě nezaplatili, upravíme částku k úhradě tak, aby nezahrnovala Vámi vrácené zboží",
  "text417": "Počet produktů",
  "text418": "Vrátit společnosti",
  "text419": "Stav",
  "text420": "Vytvořeno dne",
  "text421": "Nemáte žádné vrácené zboží.",
  "text422": "Nastavte si IBAN i SWIFT v nastavení účtu.",
  "text423": "Nemáte nastavené bankovní údaje",
  "text424": "Nakupte ještě za",
  "text425": "a dopravu máte",
  "text426": "ZDARMA",
  "text427": "Gratulujeme, dopravu máte",
  "text428": "Vaše zpráva byla úspěšně odeslána!",
  "text429": "Chyba, Vaše zpráva nebyla odeslána!",
  "text430": "",
  "text431": "Email existuje; použijte prosím jiný.",
  "text432": "Registrace úspěšná.",
  "text433": "Kód varianty",
  "text434": "muj-ucet-vratit-zbozi-1",
  "text435": "Prodejní jednotka",
  "text436": "zásady ochrany osobních údajů",
  "text437": "Štítky",
  "text438": "Číslo ulice",
  "text439": "Načítám",
  "text440": "Vybrat odběrné místo",
  "text441": "Zvolte variantu",
  "text442": "Přidat mezi oblíbené",
  "text443": "bez DPH",
  "text444": "Cena je orientační",
  "text445": "Žádné položky",
  "text446": "Zeptat se na výrobek",
  "text447": "Recenze",
  "text448": "Doplňkové služby",
  "text449": "Balíčky",
  "text450": "Odeslat",
  "text451": "Video",
  "text452": "Celý popis",
  "text453": "Omlouváme se, tento produkt máme skladem pouze v množství",
  "text454": "do košíku již nemůžete přidat kusy.",
  "text455": "OK",
  "text456": "Přejít do košíku",
  "text457": "",
  "text458": "Váš nákupní košík čeká",
  "text459": "Při poslední návštěvě jste nedokončili objednávku. Zboží, které jste si vybrali, na vás čeká v košíku. Nenechte si ho ujít a dokončete nákup nyní.",
  "text460": "Vaše objednávka byla úspěšně přijata. Zkontrolujte si prosím emailovou schránku.",
  "text461": "Vaše zpráva byla úspěšně odeslána!",
  "text462": "Email je povinný údaj.",
  "text463": "Zadaná emailová adresa není platná.",
  "text464": "Email může mít max. 255 znaků.",
  "text465": "Zadaný email je již zaregistrován.",
  "text466": "Heslo je povinný údaj.",
  "text467": "Heslo musí mít nejméně 6 znaků.",
  "text468": "Hesla se neshodují.",
  "text469": "Souhlas s obchodními podmínkami je povinný údaj.",
  "text470": "Zkontrolujte captcha formulář.",
  "text471": "Přejděte do nápovědy online",
  "text472": "Zobrazit témata otázek a odpovědí",
  "text473": "Skrýt témata otázek a odpovědí",
  "text474": "Přejít na blog",
  "text475": "Poradenská místnost",
  "text476": "Zeptejte se přímo našeho lékárníka",
  "text477": "Žádné možnosti",
  "text478": "Vyberte kategorie",
  "text479": "pro objednávky nad",
  "text480": "Zpět do obchodu",
  "text481": "Cena / ks včetně DPH",
  "text482": "Celková cena",
  "text483": "Cena / ks bez DPH",
  "text484": "",
  "text485": "Číslo domu",
  "text486": "Profil",
  "text487": "Změnit údaje",
  "text488": "Zabezpečení",
  "text489": "Změnit místo",
  "text490": "Načíst další",
  "text491": "Moje údaje",
  "text492": "Sledujte nás",
  "text493": "Nejprodávanější",
  "text494": "Všechny produkty",
  "text495": "Nedostupné",
  "text496": "Výběr varianty",
  "text497": "",
  "text498": "",
  "text499": "",
  "text500": "",
  "text501": "",
  "text502": "Celé jméno",
  "text503": "Potvrďte nové heslo",
  "text504": "Prosím, potvrďte souhlas s podmínkami o ochraně osobních údajů.",
  "text505": "Zadaná e-mailová adresa je již přihlášena k odběru novinek.",
  "text506": "Prosím, zkontrolujte e-mailovou schránku.",
  "text507": "Výdejní místo",
  "text508": "Zeptat se na produkt",
  "text509": "Dotaz na dostupnost zboží",
  "text510": "Speciální nabídka",
  "text511": "Šířka",
  "text512": "Délka",
  "text513": "Výška",
  "text514": "Váha",
  "text515": "Hodnoceno dne",
  "text516": "Oblíbené",
  "text517": "Vrátit se na hlavní stránku",
  "text518": "Stav produktu",
  "text519": "Země",
  "text520": "Dodací a fakturační údaje",
  "text521": "Už jste u nás nakupovali?",
  "text522": "Zpět do košíku",
  "text523": "Slevový kupón",
  "text524": "Přidat k objednávce",
  "text525": "Obsah nákupního košíku",
  "text526": "Pokračovat v objednávce",
  "text527": "Sdílet produkt",
  "text528": "Skrýt popis",
  "text529": "Celý popis",
  "text530": "Došlo k chybě, zkuste to za chvíli znovu.",
  "text531": "Přidat mezi oblíbené",
  "text532": "Odebrat z oblíbených",
  "text533": "Detail",
  "text534": "Nová rezervace",
  "text535": "Rezervace úspěšně vytvořena",
  "text536": "Sleva pro platbu",
  "text537": "Odhlásit se z odběru",
  "text538": "Vybrat termín",
  "text539": "Odběrné místo",
  "text540": "Termín",
  "text541": "Sleva pro zákazníka",
  "text542": "Sumární expedovaná objednávka č.",
  "text543": "Objednávka č.",
  "text544": "Nepřihlášený uživatel",
  "text545": "Kupón je platný",
  "text546": "Kupón neexistuje, vypršela jeho platnost nebo nejsou splněny podmínky pro aplikování kupónu",
  "text547": "Kupón je neplatný",
  "text548": "Kupón byl přidán",
  "text549": "Odpověď",
  "text550": "Na otázku odpověděl",
  "text551": "Zeptat se dotaz",
  "text552": "Název",
  "text553": "Pro napsání vlastní otázky do poradny musíte být přihlášen",
  "text554": "Nenašli jsme žádné vyhovující záznamy",
  "text555": "Dnes má jmeniny",
  "text556": "Oznámení",
  "text557": "Nesprávné přihlašovací údaje",
  "text558": "Původní heslo neodpovídá",
  "text559": "Zájem o práci",
  "text560": "Nový žadatel",
  "text561": "Děkujeme vám za vaši objednávku, kterou začneme vyřizovat, jakmile bude uhrazena.",
  "text562": "Úspěšná platba.",
  "text563": "Platba se nezdařila.",
  "text564": "Ověření Captcha selhalo.",
  "text565": "Žádné parametry",
  "text566": "Filtr produktu",
  "text567": "Potřebuji poradit",
  "text568": "Kontakt a podpora",
  "text569": "Napište nám",
  "text570": "Sledujte nás na sociálních sítích",
  "text571": "Doprava a platba",
  "text572": "Věrnostní program",
  "text573": "Při přihlašování k odběru newsletteru došlo k chybě",
  "text574": "Přihlášení k odběru novinek e-mailem",
  "text575": "Chcete být mezi prvními, kdo bude informován o akcích a slevách? Stačí zadat svou e-mailovou adresu.",
  "text576": "Děkujeme, že jste se přihlásili k odběru našeho zpravodaje. Na vaši e-mailovou adresu bylo zasláno potvrzení o odběru.",
  "text577": "Články",
  "text578": "Online chat",
  "text579": "Online poradenství",
  "text580": "Produktové poradenství",
  "text581": "Často kladené otázky",
  "text582": "Osobní sbírka",
  "text583": "Zprávy",
  "text584": "Akce",
  "text585": "Napsat recenzi",
  "text586": "Recenze",
  "text587": "Hodnocení",
  "text588": "Zobrazit další články",
  "text589": "Témata",
  "text590": "Hledat článek",
  "text591": "Přečtěte si celý článek",
  "text592": "Vydal",
  "text593": "Pro napsání recenze musíte být přihlášeni.",
  "text594": "Něco se pokazilo",
  "text595": "Zkuste to znovu",
  "text596": "Skrýt odpověď",
  "text597": "Zobrazit odpověď",
  "text598": "Oblíbené články",
  "text599": "Filtrování kategorií",
  "text600": "Zpět na stránku s blogy",
  "text601": "Najděte si práci svých snů!",
  "text602": "Země dodání",
  "text603": "V předchozím kroku můžete změnit zemi doručení.",
  "text604": "Zobrazit méně",
  "text605": "",
  "text606": "maximum",
  "text607": "Vybrali jsme pro vás",
  "text608": "Žádne recenze",
  "text609": "Chci dostávat e-maily s novinkami o aktuálních trendech, propagačních akcích a slevových kupónech. Z odběru se můžete kdykoli bezplatně odhlásit.",
  "text610": "Odběr novinek",
  "text611": "Potřebujete poradit?",
  "text612": "Kontaktujte nás",
  "text613": "Souhlasím se",
  "text614": "zpracováním osobních údajů",
  "text615": "Zpráva",
  "text616": "Obchodní údaje",
  "text617": "Údaje o provozu",
  "text618": "Obchodní rejstřík",
  "text619": "Název banky",
  "text620": "Pokud jste u nás ještě nenakupovali a nemáte svůj účet,",
  "text621": "vytvořte si ho zde",
  "text622": "Zapomněl jsem heslo",
  "text623": "Máte už svůj účet?",
  "text624": "Přihlaste se.",
  "text625": "Registrací účtu souhlasíte s našimi",
  "text626": "podmínkami používání.",
  "text627": "Přečtěte si naše",
  "text628": "Zásady ochrany osobních údajů.",
  "text629": "Ano, chci dostávat příležitostné e-maily se speciálními nabídkami. Své přihlášení mohu kdykoli zrušit. (Nepovinné)",
  "text630": "Heslo musí obsahovat alespoň 8 znaků.",
  "text631": "Přidáno do košíku",
  "text632": "Vyčistit",
  "text633": "Všechny blogy",
  "text634": "Zobrazit výsledky",
  "text635": "Napsat dotaz",
  "text636": "Zobrazit odpověď od specialisty",
  "text637": "V této kategorii se zatím nenacházejí žádné dotazy",
  "text638": "Zpět na hlavní stránku poradny",
  "text639": "Projekt vytvořil",
  "text640": "Všechna práva vyhrazena",
  "text641": "Doprava a způsob platby",
  "text642": "Váš dotaz se zobrazí po schválení administrátorem",
  "text643": "Děkujeme",
  "text644": "nebo napište na",
  "text645": "Aktivovat slevový kód",
  "text646": "Kód kuponu",
  "text647": "Uplatnit slevový kód",
  "text648": "Recenze byla přidána",
  "text649": "Heslo bylo úspěšně změněno",
  "text650": "Nepodařilo se změnit heslo",
  "text651": "Nastala chyba při obnovení hesla",
  "text652": "Obdrželi jste e-mail k obnovení hesla",
  "text653": "Při registraci nastala chyba",
  "text654": "Úspěšně jste se registrovali",
  "text655": "Při přihlášení nastala chyba",
  "text656": "Byl jste přihlášen",
  "text657": "Nastala chyba při odesílání kontaktního formuláře",
  "text658": "Kontaktní formulář byl úspěšně odeslán",
  "text659": "Vaše otázka byla úspěšně odeslána",
  "text660": "Nastala chyba při odesílání otázky",
  "text661": "Nastala chyba při vytvoření recenze",
  "text662": "Cena / ks",
  "text663": "Celkem",
  "text664": "Dárek",
  "text665": "Sledujte nás na instagramu",
  "text666": "Zobrazit instagram",
  "text667": "Barva je v nesprávném formátu.",
  "text668": "více..",
  "text669": "Koupit",
  "text670": "Zobrazit všechny produkty",
  "text671": "Blogy",
  "text672": "Žádné štítky",
  "text673": "Žádné blogy",
  "text674": "Žádné kategorie",
  "text675": "Mezisoučet",
  "text676": "Už jste u nás nakupovali?",
  "text677": "Pokud jste u nás již nakupovali, přihlaste se do svého konta pro automatické doplnění údajů k objednávce a zrychlení procesu dokončení objednávky.",
  "text678": "Jsem nový zákazník",
  "text679": "Fakturační údaje",
  "text680": "Poškozený produkt",
  "text681": "Nevhodný dárek",
  "text682": "Nechci uvést",
  "text683": "Vyberte důvod",
  "text684": "Kurýr",
  "text685": "Vrácených produktů:",
  "text686": "Zrušit vrácení",
  "text687": "Potvrdit vrácení produktu",
  "text688": "Firemní adresa",
  "text689": "Údaje o firmě",
  "text690": "Otevírací hodiny",
  "text691": "Ověřit dostupnost",
  "text692": "E-recept",
  "text693": "Rezervace e-recept",
  "text694": "Věrnostní karta",
  "text695": "Chci kartu",
  "text696": "Mám kartu",
  "text697": "Rodné číslo",
  "text698": "Telefon je nezbytný pro informování o stavu rezervace",
  "text699": "Vaše rodné číslo potřebujeme pro ověření receptu",
  "text700": "Odeslat rezervaci receptu",
  "text701": "Vyberte město",
  "text702": "Číslo věrnostní karty",
  "text703": "Název produktu",
  "text704": "Zadejte název produktu/číslo čárového kódu",
  "text705": "Vyhledávání podle názvu nebo čárového kódu - číslice pod čárovým kódem produktu",
  "text706": "Produkt na míru",
  "text707": "Napište věnování...",
  "text708": "Vyberte datum doručení",
  "text709": "Zobrazit více podkategorií",
  "text710": "Skrýt podkategorie",
  "text711": "Mám papírový recept",
  "text712": "Nastavte si IBAN i SWIFT v nastavení účtu",
  "text713": "Vrácení jsme úspěšně zaevidovali",
  "text714": "Vrácené objednávky",
  "text715": "Vrácení zboží",
  "text716": "Datum vrácení",
  "text717": "Stáhnout",
  "text718": "Dodavatelé",
  "text719": "Informace o produktu",
  "text720": "Cena produktu",
  "text721": "Přejít do obchodu",
  "text722": "Změna stavu reklamace",
  "text723": "Může obsahovat pouze formát, kde se nacházejí maximálně 4 čísla před desetinnou čárkou a 8 po desetiné čárce.",
  "text724": "Kde všude jsme už byli",
  "text725": "Pokračovat na hlavní stránku",
  "text726": "Zadejte číslo objednávky a email",
  "text727": "Odkaz",
  "text728": "Lokalita dodavatele",
  "text729": "Minimální počet znaků je",
  "text730": "Maximální počet znaků je",
  "text731": "Toto pole nemůže být prázdné",
  "text732": "Emailová adresa musí být platná",
  "text733": "Telefonní číslo musí být platné",
  "text734": "Toto pole je povinné",
  "text735": "Datum musí být platné",
  "text736": "Zadaný vstup musí být číslo",
  "text737": "Zadaný vstup musí být celé číslo",
  "text738": "Zadaný vstup musí být desetinné číslo",
  "text739": "Hesla se neshodují",
  "text740": "Musíte souhlasit s GDPR",
  "text741": "Musíte souhlasit s podmínkami používání",
  "text742": "Musíte vybrat alespoň jeden produkt",
  "text743": "Vyplňte údaje o benefitní kartě nebo své jméno",
  "text744": "Související produkty",
  "text745": "Přihlášen jako",
  "text746": "Vyhledávat",
  "text747": "Klíčové slovo",
  "text748": "Vzdálenost",
  "text749": "Kategorie",
  "text750": "Povinná políčka",
  "text751": "Kontaktujte nás kdykoliv, pokud máte nějaký zvláštní požadavek nebo pokud máte nějaké otázky.",
  "text752": "Žádné výsledky",
  "text753": "Zvolené dny jsou nedostupné",
  "text754": "Upravit",
  "text755": "Smazat účet",
  "text756": "Podnikání",
  "text757": "Pro případ, že bychom Vás potřebovali kontaktovat ohledně Vaší objednávky.",
  "text758": "Vytvořit účet",
  "text759": "Žádní dodavatelé se ve vybrané vzdálenosti nenacházejí",
  "text760": "Vyberte dodavatele",
  "text761": "Vyberte město",
  "text762": "Vyplňte svou fakturační adresu, abyste to nemuseli dělat u každé objednávky.",
  "text763": "Pro vyplnění velkoobchodního formuláře je třeba být přihlášen.",
  "text764": "Velkoobchod",
  "text765": "Gratulujeme! Už jste registrován jako velkoobchod.",
  "text766": "Typ firmy a dómeny",
  "text767": "Kontaktní informace",
  "text768": "Maximální velikost souboru 2MB",
  "text769": "Dropshipping",
  "text770": "Objednávka na sklad",
  "text771": "Adresa dropship doručení",
  "text772": "Osobní a kontaktní údaje",
  "text773": "Adresa doručení zboží",
  "text774": "Váš formulář byl úspěšně odeslán. V co nejkratší době Vás budeme kontaktovat ohledně velkoobchodních podmínek.",
  "text775": "Povolte získávání polohy",
  "text776": "Je třeba vybrat datum doručení",
  "text777": "Je třeba vybrat konkrétní výdejní místo",
  "text778": "Cena balíčku je vyšší než povolená hodnota.",
  "text779": "Balíček obsahuje",
  "text780": "Balíček nemá maximální cenu",
  "text781": "Zadejte PSČ",
  "text782": "Zadejte Město",
  "text783": "Vypočítat cenu",
  "text784": "Poslat do útulku",
  "text785": "Značka",
  "text786": "Otázka pro lékárníka",
  "text787": "Na otázku odpověděla",
  "text788": "Pracovní ponuky",
  "text789": "Online poradna",
  "text790": "Skrýt témata otázek a odpovědí",
  "text791": "Zobrazit témata otázek a odpovědí",
  "text792": "Zjistit více",
  "text793": "Zobrazit všechny nabídky",
  "text794": "Detail nabídky",
  "text795": "Místo výkonu práce",
  "text796": "Hrubá mzda",
  "text797": "Pracovní poměr",
  "text798": "Nástup",
  "text799": "Více referencí",
  "text800": "Zavolejte nám",
  "text801": "Jsme k dispozici",
  "text802": "O společnosti",
  "text803": "Kontaktní údaje",
  "text804": "Dokumenty k objednávce",
  "text805": "Nejsou dostupné žádné dokumenty pro tuto objednávku",
  "text806": "Vyberte útulek",
  "text807": "Prohlédnout detail",
  "text808": "Mám zájem o realizaci",
  "text809": "z",
  "text810": "nabídek",
  "text811": "od",
  "text812": "v hrubém",
  "text813": "Mám zájem o pracovní pozici",
  "text814": "Nahrát životopis",
  "text815": "Odeslat zájem",
  "text816": "Splátková kalkulačka",
  "text817": "Prohlédnout nabídku",
  "text818": "Konfigurátor",
  "text819": "Všechny realizace",
  "text820": "Kde nás najdete",
  "text821": "Obchodní oddělení",
  "text822": "Obchodní zástupci",
  "text823": "Právní poznámka",
  "text824": "Prohlédnout technické parametry",
  "text825": "Prosím vyberte místo doručení",
  "text826": "Varianty",
  "text827": "Jmeniny má",
  "text828": "Pro stažení",
  "text829": "Najděte si práci",
  "text830": "Populární kategorie",
  "text831": "Najděte typ práce, který vám vyhovuje! Práce začíná ihned po zakoupení a poskytnutí požadavků.",
  "text832": "otevřené pozice",
  "text833": "Vytvořit životopis",
  "text834": "„Vytvořte si svůj profil a najděte tisíce pracovních míst, vybudujte si svoji kariéru a",
  "text835": "zaměstnání!\"",
  "text836": "Najděte typ práce, který vám vyhovuje! Práce začíná ihned po zakoupení a poskytnutí požadavků.",
  "text837": "Poslat životopis",
  "text838": "/ měsíčně",
  "text839": "Je třeba vybrat útulek",
  "text840": "Útulky, které s námi můžete podpořit",
  "text841": "Mám více než 18 let",
  "text842": "Obsah této stránky není vhodný pro osoby",
  "text843": "mladší 18 let.",
  "text844": "Vše",
  "text845": "Pouze nové",
  "text846": "Pouze použité",
  "text847": "Typ",
  "text848": "Rok",
  "text849": "Model",
  "text850": "Mé životopisy",
  "text851": "Náhled CV",
  "text852": "Vymazání účtu",
  "text853": "Po vymazání účtu nebude možné vaše údaje obnovit.",
  "text854": "Vymazat účet",
  "text855": "Nastavení",
  "text856": "Mám zájem o zasílání pracovních nabídek e-mailem",
  "text857": "Preferovaný jazyk",
  "text858": "Přejít na všechny pracovní nabídky",
  "text859": "Životopis",
  "text860": "Krok",
  "text861": "Základní údaje",
  "text862": "Fotografie",
  "text863": "Pracovní zkušenosti",
  "text864": "Vzdělání",
  "text865": "Znalosti",
  "text866": "Jazyky",
  "text867": "Doplňující části",
  "text868": "Závěrečná nastavení",
  "text869": "Vyhledejte podle klíčového slova, názvu firmy",
  "text870": "Obec, okres, kraj",
  "text871": "Vyhledat",
  "text872": "Ulice a číslo",
  "text873": "Nahrajte vaši fotografii",
  "text874": "Fotografie není povinná, ale životopis s fotkou působí osobněji a personalisty zaujme\n  více.",
  "text875": "Věděli jste, že personalistovi stačí v průměru 7 vteřin na první proskenování životopisu? Vzpomeňte proto jen relevantní zkušenosti a popište je v odrážkách nebo v krátkých odstavcích.",
  "text876": "Název pozice, společnost",
  "text877": "Město nebo PSČ",
  "text878": "Jaké máte vzdělání?",
  "text879": "Dejte zaměstnavatelům vědět, jaké je vaše vzdělání",
  "text880": "Přidat vzdělání",
  "text881": "Nabídka práce",
  "text882": "Aktivní nabídky",
  "text883": "Zaměření",
  "text884": "Vysoká škola",
  "text885": "Střední škola",
  "text886": "Kurz nebo certifikát",
  "text887": "Mám zájem o práci",
  "text888": "Vaše dovednosti a znalosti",
  "text889": "Zadejte, jaké dovednosti a znalosti ovládáte, a na jaké úrovni.",
  "text890": "Profese",
  "text891": "Jazyk který ovládáte",
  "text892": "Uvádět akademický titul u jména",
  "text893": "Plat",
  "text894": "Druh pracovního poměru",
  "text895": "Reakce na pracovní nabídku",
  "text896": "Informace k profesi",
  "text897": "Jsem OSVČ (samostatně výdělečně činná osoba)",
  "text898": "Nepovinné přílohy",
  "text899": "Životopis, Motivační dopis, Vyhlášky, certifikáty, jiné... (max. 10MB)",
  "text900": "Jazyk který ovládáte",
  "text901": "Vyberte jazyk",
  "text902": "Titul",
  "text903": "Kraj",
  "text904": "Vyberte zemi",
  "text905": "Vyberte kraj",
  "text906": "Maximální velikost souboru je 10MB",
  "text907": "Přidat přílohu",
  "text908": "Počet příloh",
  "text909": "Řidičský průkaz",
  "text910": "Jaká vlastníte řidičská oprávnění?",
  "text911": "Jak si rádi vyplňujete volný čas?",
  "text912": "Zájmy nebo koníčky",
  "text913": "Krátce a výstižně popište, jak rádi trávíte volný čas.",
  "text914": "Obsah životopisu máte hotový. Doplňte si ještě tyto údaje, které Vám pomohou při hledání práce na www.pracaslovensko.sk",
  "text915": "Pracovní pozice",
  "text916": "V jaké oblasti nebo na jaké konkrétní pozici byste chtěli pracovat?",
  "text917": "Pracovní oblast",
  "text918": "Vyberte pracovní oblast",
  "text919": "Místo práce",
  "text920": "V jaké lokalitě hledáte práci?",
  "text921": "Druh pracovního poměru",
  "text922": "Označte, jaký typ pracovního úvazku by vám vyhovoval",
  "text923": "Termín nástupu",
  "text924": "Uveďte termín možného nástupu",
  "text925": "Očekávaný minimální plat (v hrubém)",
  "text926": "Uveďte Vaši představu o minimálním platu (v hrubém).",
  "text927": "Preferované pracovní změny",
  "text928": "Uveďte Vaše preference pro pracovní změny",
  "text929": "Zdravotní znevýhodnění",
  "text930": "Jste pracovně znevýhodněni?",
  "text931": "Pracovní nabídky e-mailem?",
  "text932": "Chcete, abychom vám vyhovující pracovní nabídky posílali na e-mail?",
  "text933": "Město/Obec",
  "text934": "Ihned",
  "text935": "Dohodou",
  "text936": "Částka od (EUR)",
  "text937": "Mám zájem io zaměstnání, ve kterém bych pracoval io víkendech",
  "text938": "Mám zájem io práci v noci",
  "text939": "Mám pracovní invaliditu",
  "text940": "41% - 70%",
  "text941": "Více než 70%",
  "text942": "Doplňující informace",
  "text943": "Mám zájem o zasílání pracovních nabídek e-mailem",
  "text944": "Osobní shrnutí",
  "text945": "Napište o sobě krátké shrnutí ve 2 – 3 větách.",
  "text946": "Doplňující informace",
  "text947": "Chcete ještě něco doplnit? Napište to sem.",
  "text948": "Vložte soubory nebo přemístěte sem",
  "text949": "PNG, JPG, GIF",
  "text950": "Vybrat soubor",
  "text951": "Přidat zaměstnání",
  "text952": "Časové odbobí",
  "text953": "Popis práce",
  "text954": "Krátce a výstižně popište vaši náplň práce.",
  "text955": "Přidání zaměstnání",
  "text956": "Název pracovní pozice",
  "text957": "Zaměstnavatel",
  "text958": "Město/obec",
  "text959": "Země",
  "text960": "Časové období",
  "text961": "Aktuálně zde pracuji",
  "text962": "Od měsíce",
  "text963": "Od roku",
  "text964": "Do měsíce",
  "text965": "Do roku",
  "text966": "Popis práce",
  "text967": "Krátce a výstižně popište vaši náplň práce.",
  "text968": "Vysoká škola",
  "text969": "Fakulta",
  "text970": "Odbor",
  "text971": "Střední škola",
  "text972": "Název kurzu",
  "text973": "Popis studia",
  "text974": "Krátce a výstižně popište vaše studium",
  "text975": "Úplný začátečník",
  "text976": "Základy",
  "text977": "Mírně pokročilý",
  "text978": "Pokročilý",
  "text979": "Expert",
  "text980": "Přidat jazyk",
  "text981": "Přidat znalost",
  "text982": "Úplný začátečník (A1)",
  "text983": "Začátečník (A2)",
  "text984": "Mírně pokročilý (B1)",
  "text985": "Středně pokročilý (B2)",
  "text986": "Pokročilý (C1)",
  "text987": "Expert (C2)",
  "text988": "Přidání jazyka",
  "text989": "Jazyk",
  "text990": "Úroveň jazyka",
  "text991": "Nemáte přidáno žádné vzdělání",
  "text992": "dnes",
  "text993": "Kurz nebo certifikát",
  "text994": "Tato webstránka používá soubory cookies",
  "text995": "Pro přizpůsobení obsahu a reklam, poskytování funkcí sociálních médií a analýzu návštěvnosti používáme soubory cookie. Informace o tom, jak používáte naše webové stránky, poskytujeme také našim partnerům v oblasti sociálních médií, inzerce a analýzy. Tito partneři mohou příslušné informace zkombinovat s dalšími údaji, které jste jim poskytli nebo které od vás získali, když jste používali jejich služby.",
  "text996": "Povolit vše",
  "text997": "Odmítnout",
  "text998": "Přizpůsobit",
  "text999": "Nastavení cookies",
  "text1000": "Služby",
  "text1001": "Vaše možnosti ochrany soukromí",
  "text1002": "V této části můžete vyjádřit některé preference týkající se zpracování vašich osobních údajů. Můžete kdykoli prozkoumat a změnit vyjádřené volby tím, že znovu zobrazíte tento panel prostřednictvím poskytnutého odkazu. Chcete-li odmítnout svůj souhlas se specifickými činnostmi zpracování popsanými níže, přepínače přepněte na vypnuté nebo použijte tlačítko „Odmítnout vše“ a potvrďte, že chcete uložit své volby.",
  "text1003": "Potřebné",
  "text1004": "Potřebné soubory cookie pomáhají vytvářet použitelné webové stránky tak, že umožňují základní funkce, jako je navigace stránky a přístup k chráněným oblastem webových stránek. Webové stránky nemohou řádně fungovat bez těchto souborů cookies.",
  "text1005": "Statistiky a analýzy",
  "text1006": "Statistické soubory cookies pomáhají majitelům webových stránek, aby pochopili, jak komunikovat s návštěvníky webových stránek prostřednictvím shromažďování a hlášení informací anonymně.",
  "text1007": "Tabulka souborů cookies",
  "text1008": "Cookie",
  "text1009": "Doména",
  "text1010": "Marketing",
  "text1011": "Marketingové soubory cookies se používají ke sledování návštěvníků na webových stránkách. Záměrem je zobrazovat reklamy, které jsou relevantní a poutavé pro jednotlivé uživatele, a tím cennější pro vydavatele a inzerenty třetích stran.",
  "text1012": "Chci vědět více",
  "text1013": "Pro získání informací o zpracování osobních údajů a vašich právech v souvislosti s ochranou osobních údajů, nás můžete kontaktovat",
  "text1014": "zde.",
  "text1015": "Funkční",
  "text1016": "Funkční soubory cookie pomáhají provádět určité funkce, jako je sdílení obsahu webové stránky na platformách sociálních médií, sbírání zpětné vazby a další funkce třetích stran.",
  "text1017": "Uložit nastavení",
  "text1018": "Nemáte přidáno žádné pracovní zkušenosti",
  "text1019": "Nemáte přidáno žádné znalosti",
  "text1020": "Typ dovednosti a znalosti",
  "text1021": "Úroveň dovednosti a znalosti",
  "text1022": "Přidání znalosti a dovednosti",
  "text1023": "Jaké jazyky ovládáte?",
  "text1024": "Zadejte jazyky, které ovládáte a jejich úroveň",
  "text1025": "Nemáte přidáno žádné jazyky",
  "text1026": "Zpět",
  "text1027": "Pokračovat",
  "text1028": "Uložit",
  "text1029": "Hodnota musí být z rozsahu",
  "text1030": "Přidání vzdělání",
  "text1031": "Stále studuji",
  "text1032": "Popis studia",
  "text1033": "Titul",
  "text1034": "Technické informace",
  "text1035": "Technické vlastnosti",
  "text1036": "Máte dotaz k produktu? Zašlete nám jí a rádi Vám jí zodpovíme.",
  "text1037": "Název produktu",
  "text1038": "Odeslat dotaz",
  "text1039": "Souhlasím se zpracováním osobních údajů",
  "text1040": "Váš dotaz",
  "text1041": "Odeslat",
  "text1042": "Vaše otázka byla úspěšně odeslána",
  "text1043": "Otázku se nepodařilo odeslat",
  "text1044": "Vaše jméno",
  "text1045": "Řezy",
  "text1046": "Tento produkt je dostupný ve více variantách",
  "text1047": "Sdílet na Facebooku",
  "text1048": "Minimálni výška",
  "text1049": "Minimálni šířka",
  "text1050": "Maximálni výška",
  "text1051": "Maximálni šířka",
  "text1052": "Barevné provedení",
  "text1053": "Leden",
  "text1054": "Únor",
  "text1055": "Březen",
  "text1056": "Duben",
  "text1057": "Květen",
  "text1058": "Červen",
  "text1059": "Červenec",
  "text1060": "Srpen",
  "text1061": "Září",
  "text1062": "Říjen",
  "text1063": "Listopad",
  "text1064": "Prosinec",
  "text1065": "Délka kurzu",
  "text1066": "Počet kapitol",
  "text1067": "Zadejte originálni název náhradní součastky",
  "text1068": "Způsob platby",
  "text1069": "S účtem můžete sledovat své objednávky a spravovat faktury",
  "text1070": "Pouze nové",
  "text1071": "Pouze staré",
  "text1072": "Použité díly",
  "text1073": "Články na blogu, rady a tipy",
  "text1074": "Zůstaňte v obraze",
  "text1075": "Více o projektu",
  "text1076": "Detail akce",
  "text1077": "Do konce akce",
  "text1078": "Do začátku akce",
  "text1079": "Předchozí lekce",
  "text1080": "Ukončeno",
  "text1081": "Krokov",
  "text1082": "Úspěšnost kurzů",
  "text1083": "Otevřít celou diskusi",
  "text1084": "Připojte se k diskusi",
  "text1085": "Délka kurzu",
  "text1086": "Seznam kapitol",
  "text1087": "Popis kurzu",
  "text1088": "Často kladené otázky",
  "text1089": "Diskuse",
  "text1090": "Koupit kurz",
  "text1091": "Odkazy",
  "text1092": "Označit jako splněné",
  "text1093": "Zahájení kurzu",
  "text1094": "Ukončení kurzu",
  "text1095": "Další lekce",
  "text1096": "Gratulujeme",
  "text1097": "Úspěšně jste dokončili kurz",
  "text1098": "Bez",
  "text1099": "Mezera",
  "text1100": "Dot",
  "text1101": "Řádek",
  "text1102": "Neznámej",
  "text1103": "Nové heslo se musí lišit od starého.",
  "text1104": "Účet",
  "text1105": "Vytvořené",
  "text1106": "Mezisoučet",
  "text1107": "Účet zákazníka není platný.",
  "text1108": "Potvrzení hesla",
  "text1109": "Zakoupené školení",
  "text1110": "Otevřít",
  "text1111": "Trenér",
  "text1112": "Mohlo by se vám líbit",
  "text1113": "Soukromá osoba",
  "text1114": "Přidat adresu",
  "text1115": "Přidat do košíku",
  "text1116": "Zpět na videonávody",
  "text1117": "Cenová nabídka",
  "text1118": "Zaslat poptávku",
  "text1119": "Doručit komplet",
  "text1120": "Externí číslo objednávky",
  "text1121": "Vývoz výrobků dokončen",
  "text1122": "s DPH",
  "text1123": "Nový uživatel",
  "text1124": "Nová objednávka",
  "text1125": "Nový komentář k úkolu",
  "text1126": "Změna stavu úlohy",
  "text1127": "Doprava zdarma",
  "text1128": "Garance ceny",
  "text1129": "Bezplatná konzultace",
  "text1130": "Zákaznická podpora",
  "text1131": "Více než 2000 produktů na skladě",
  "text1132": "Doručení do 4 dnů",
  "text1133": "Značky",
  "text1134": "Můj profil",
  "text1135": "Zadejte název společnosti",
  "text1136": "Zadejte prosím registrační číslo",
  "text1137": "Zadejte adresu své společnosti",
  "text1138": "Místo realizace",
  "text1139": "Mám zájem o",
  "text1140": "V blízkosti potoka",
  "text1141": "Kolik lidí bude čističku využívat?",
  "text1142": "Mám svažitý pozemek?",
  "text1143": "",
  "text1144": "Navrhněte si svůj produkt přesně podle svých představ. S naším konfigurátorem je vytvoření perfektního produktu snadné a rychlé.",
  "text1145": "Vytvořte si svou ideální konfiguraci",
  "text1146": "Zobrazit všechny v podkategorii",
  "text1147": "Fotonávod",
  "text1148": "Přečtěte si článek",
  "text1149": "Nejčtenější články",
  "text1150": "Tagy",
  "text1151": "Plánujete projekt?\nSetkáme se s vámi a poradíme vám.",
  "text1152": "zdarma",
  "text1153": "Kontaktovat",
  "text1154": "Spočítat",
  "text1155": "Sdílet článek",
  "text1156": "Odkaz byl zkopírován do schránky",
  "text1157": "Rozpočet",
  "text1158": "Věrnostní body nebylo možné použít",
  "text1159": "Vaše věrnostní body",
  "text1160": "Každá věrnost má svou hodnotu",
  "text1161": ", čímž získáte celkovou slevu",
  "text1162": "na váš nákup.",
  "text1163": "Nemáte žádné věrnostní body",
  "text1164": "Uplatnění věrnostních bodů",
  "text1165": "Počet bodů, které je třeba uplatnit",
  "text1166": "Počet uplatněných věrnostních bodů",
  "text1167": "Uplatněná sleva",
  "text1168": "Maximální počet bodů, které lze uplatnit na jednu objednávku, je",
  "text1169": "Sídlo",
  "text1170": "více o službě",
  "text1171": "Ozvěte se nám",
  "text1172": "Kancelář",
  "text1173": "Sídlo firmy",
  "text1174": "Pokračuj dále",
  "text1175": "Proces a postup realizace",
  "text1176": "Náhled obrazovek univerzálního e-shopu",
  "text1177": "Vybraný čas nelze rezervovat",
  "text1178": "Vybraná možnost",
  "text1179": "Pokoje",
  "text1180": "Oblast",
  "text1181": "Kreslení výkresů nábytku",
  "text1182": "Seznam prvků vybavení",
  "text1183": "Celé jméno zákazníka",
  "text1184": "Název stavu stížnosti",
  "text1185": "Jméno osoby, která bude rezervaci vyřizovat",
  "text1186": "Rezervováno na celý den",
  "text1187": "Pokud již u nás máte účet, prosím.",
  "text1188": "Název společnosti",
  "text1189": "Adresa sídla společnosti",
  "text1190": "Vyberte zemi",
  "text1191": "Přiřazené karty do této sekce nepatří",
  "text1192": "Vodorovně",
  "text1193": "Svisle",
  "text1194": "Vnítřní",
  "text1195": "Vnější",
  "text1196": "Práce, zaměstnání a kariérní příležitosti",
  "text1197": "Oblíbené pozice",
  "text1198": "Aktualizace košíku",
  "text1199": "Upravit položku",
  "text1200": "Číslo smlouvy",
  "text1201": "Pozáruční servis",
  "text1202": "Přihlašovací formulář",
  "text1203": "Přihlašovací jméno (e-mail)",
  "text1204": "Přihlášení",
  "text1205": "Nesprávné heslo",
  "text1206": "Zadejte heslo virtuálního produktu, které jste obdrželi po zaplacení objednávky.",
  "text1207": "Heslo naleznete ve své e-mailové adrese.",
  "text1208": "Položka v košíku byla upravena.",
  "text1209": "Klíč API není správný",
  "text1210": "Podpis smlouvy a úhrada faktury",
  "text1211": "Kontaktní údaje a specifikace práce",
  "text1212": "Řízení dat a přístupu",
  "text1213": "Grafický design",
  "text1214": "Podpis přejímacího protokolu - návrh",
  "text1215": "Instalace systému na doménu - server",
  "text1216": "Vizuální implementace a připojení k systému",
  "text1217": "Přejímací protokol - Provedení návrhu a připojení k systému",
  "text1218": "Obsah projektu",
  "text1219": "Migrace do výroby",
  "text1220": "Potvrzení závěrečného projektu",
  "text1221": "Smlouva o dílo nebyla podepsána.",
  "text1222": "Faktura nebyla uhrazena.",
  "text1223": "Smlouva byla úspěšně podepsána.",
  "text1224": "Faktura byla uhrazena.",
  "text1225": "Ke stažení na",
  "text1226": "Do obchodu",
  "text1227": "Stáhnout doklad",
  "text1228": "Mé faktury",
  "text1229": "Doklad",
  "text1230": "Fakturovaná částka",
  "text1231": "Uhrazená částka",
  "text1232": "Zbýva doplatiť",
  "text1233": "Mena",
  "text1234": "Dátum pořízení",
  "text1235": "Odsouhlaseno",
  "text1236": "Vyřízeno klientem",
  "text1237": "Typ dokladu",
  "text1238": "Datum zdanitelného plnění",
  "text1239": "Mé poptávky",
  "text1240": "Zadejte svou e-mailovou adresu, prostřednictvím které budeme komunikovat",
  "text1241": "Dátum přijetí",
  "text1242": "Více o nás",
  "text1243": "Mám zájem",
  "text1244": "Izolace",
  "text1245": "Použitím",
  "text1246": "Podle materiálu",
  "text1247": "Všechny odkazy",
  "text1248": "Vybrané projekty",
  "text1249": "Máte zájem o realizaci projektu nebo máte dotazy? Kontaktujte nás",
  "text1250": "Jméno a příjmení",
  "text1251": "Projekt podporovaný Evropskou unií",
  "text1252": "Zásady ochrany osobních údajů",
  "text1253": "Přehled produktů",
  "text1254": "Zobrazit produkt",
  "text1255": "Technické údaje",
  "text1256": "Poraďte se s",
  "text1257": "Číslo účtu",
  "text1258": "Telefonní číslo",
  "text1259": "Při komunikaci s klientem upřednostňujeme komunikaci prostřednictvím projektové skupiny v aplikaci \"Whatsapp\". Zadejte číslo, prostřednictvím kterého vás přidáme do projektové skupiny.",
  "text1260": "Telefonní číslo na Whatsapp (+421 ... ...)",
  "text1261": "Whatsapp",
  "text1262": "Specifikace práce",
  "text1263": "Druh práce (podle dohody a smlouvy)",
  "text1264": "Eshop",
  "text1265": "Prezentační webové stránky",
  "text1266": "Webová aplikace",
  "text1267": "Mobilní aplikace",
  "text1268": "Systém CRM",
  "text1269": "PPC kampaně (Google, Facebook)",
  "text1270": "Optimalizace SEO",
  "text1271": "Typ designu",
  "text1272": "Design e-shopu - Eliadmin universal",
  "text1273": "Design e-shopu - design na míru",
  "text1274": "Návrh webu / návrh aplikace / návrh systému",
  "text1275": "Preferovaný kód barvy (ve formátu HEX)",
  "text1276": "Smíchat ji můžete na tomto odkazu.",
  "text1277": "Grafické a obsahové dokumenty",
  "text1278": "Grafické dokumenty",
  "text1279": "Mám (např. design manuál, logo, banner...)",
  "text1280": "Nemám",
  "text1281": "Podkladový obsah pro webové stránky (popisy, názvy kategorií, fotografie atd...)",
  "text1282": "Přiložte podpůrné soubory (design manuál, logo, bannery, ...).",
  "text1283": "Pro vektorové logo použijte vektorový formát svg, ai nebo pdf.",
  "text1284": "Nahrajte až 10 podporovaných souborů. Maximální velikost 100 MB/soubor.",
  "text1285": "VYHLEDAT SOUBOR",
  "text1286": "Doména a hosting",
  "text1287": "Zakoupil jsem",
  "text1288": "Název domény (www.vasadomena.sk)",
  "text1289": "Název domény",
  "text1290": "Název poskytovatele domény",
  "text1291": "Název poskytovatele",
  "text1292": "Vaše přihlašovací jméno",
  "text1293": "Vaše přihlašovací heslo",
  "text1294": "Poznámka nutná pro instalaci systému (urychlí práci a vlastní předání produktu, pokud ji nemáte, můžeme ji zajistit).",
  "text1295": "Rezervační formulář",
  "text1296": "Výběr služby",
  "text1297": "Výběr holiče",
  "text1298": "Vyberte termín",
  "text1299": "Zadejte svůj kontakt",
  "text1300": "Aktuální volné termíny",
  "text1301": "Nerozhodnuto",
  "text1302": "Pondělí",
  "text1303": "Úterý",
  "text1304": "Středa",
  "text1305": "Čtvrtek",
  "text1306": "Pátek",
  "text1307": "Sobota",
  "text1308": "Neděle",
  "text1309": "Týden",
  "text1310": "Žádné termíny nejsou k dispozici",
  "text1311": "Souhrn",
  "text1312": "Jméno holiče",
  "text1313": "Služba",
  "text1314": "Doba trvání",
  "text1315": "minuty",
  "text1316": "Odeslat rezervaci",
  "text1317": "Rezervace byla úspěšná",
  "text1318": "Je nutné zvolit datum",
  "text1319": "Výhradu nebylo možné stanovit. Zkontrolujte, zda je formulář správně vyplněn, a zkuste rezervaci vytvořit znovu.",
  "text1320": "Došlo k nečekané chybě.",
  "text1321": "Více informací",
  "text1322": "Podívejte se na další projekty",
  "text1323": "Detail projektu",
  "text1324": "V případě zájmu nás kontaktujte\npro profesionály ve vašem oboru!",
  "text1325": "Projekty",
  "text1326": "Zobrazit projekty",
  "text1327": "Název projektu",
  "text1328": "Rok realizace",
  "text1329": "Umístění",
  "text1330": "Referenční dopis",
  "text1331": "Údaje o společnosti",
  "text1332": "Banka",
  "text1333": "Volejte",
  "text1334": "Vložení tokenu",
  "text1335": "Rezervace",
  "text1336": "Přejít do kategorie",
  "text1337": "Navigace na stránkách",
  "text1338": "Zůstaňte v obraze přihlášením se k odběru našeho newsletteru!",
  "text1339": "Zadáním své e-mailové adresy potvrzujete souhlas se zpracováním svých osobních údajů a zároveň se přihlašujete k odběru newsletteru společnosti Spaceplan.",
  "text1340": "Rezervovat nyní",
  "text1341": "Mám věrnostní kartu",
  "text1342": "Chyba při záznamu rezervace",
  "text1343": "Rezervovat vybrané produkty",
  "text1344": "Více o naší společnosti",
  "text1345": "Naše služby",
  "text1346": "Spojte se s námi",
  "text1347": "Úspěšně jste se odhlásili z odběru newsletteru",
  "text1348": "Vytvoření nového",
  "text1349": "Zrušit a vyřadit",
  "text1350": "Chcete zrušit vytvoření životopisu? Všechna data budou ztracena.",
  "text1351": "Odevzdejte svůj životopis",
  "text1352": "Pokračovat v tvorbě",
  "text1353": "Chyba výběru atributu.",
  "text1354": "Kontakt nejpozději do",
  "text1355": "Online výpočet ceny",
  "text1356": "Vyberte produkty, o jejichž ceny máte zájem:",
  "text1357": "Zobrazit citaci",
  "text1358": "Vybrané produkty pro výpočet:",
  "text1359": "Přidat produkt",
  "text1360": "Přečtěte si více",
  "text1361": "Mám zájem o produkt",
  "text1362": "Máte zájem o tento produkt? Vyplňte formulář a my vás budeme co nejdříve kontaktovat s nabídkou.",
  "text1363": "V předchozím kroku je nutné vybrat produkt.",
  "text1364": "Bez konfigurace",
  "text1365": "Vyplňte přiložený formulář a my se vám co nejdříve ozveme. I v tomto kroku se pro vás jedná o nezávaznou nabídku.",
  "text1366": "Projekt",
  "text1367": "Kontakt nejpozději do",
  "text1368": "Odeslat nezávaznou poptávku na individuální nabídku",
  "text1369": "Stáhnout citát",
  "text1370": "Procházet",
  "text1371": "Tento produkt nemá žádné nastavení.",
  "text1372": "Nezávazná poptávka po individuální nabídce byla úspěšně odeslána.",
  "text1373": "Výkonný ředitel",
  "text1374": "Obchod a služby",
  "text1375": "Máte dotaz? Napište nám",
  "text1376": "Pokud máte dotaz a potřebujete se s námi spojit, zkuste nám zavolat nebo poslat e-mail, případně můžete vyplnit kontaktní formulář.",
  "text1377": "Zobrazit projekt",
  "text1378": "Zajímají vás produkty a služby?",
  "text1379": "Návrhář",
  "text1380": "Použít filtr",
  "text1381": "Nemáte žádné oblíbené produkty",
  "text1382": "Smazat seznam přání",
  "text1383": "Opravdu chcete vymazat svůj seznam přání?",
  "text1384": "Ano, vymazat",
  "text1385": "Ne, neodstraňujte",
  "text1386": "Neplatné telefonní číslo",
  "text1387": "Neplatná telefonní předvolba",
  "text1388": "Všechny vlastnosti",
  "text1389": "Prodej",
  "text1390": "Pronájem",
  "text1391": "Koupit",
  "text1392": "Zobrazit nabídku",
  "text1393": "Umělci",
  "text1394": "Odeslat objednávku s povinností platby",
  "text1395": "Chci prodat",
  "text1396": "Chci si koupit",
  "text1397": "Chci si pronajmout",
  "text1398": "Nejsou k dispozici žádná místa dodání",
  "text1399": "Vybavení",
  "text1400": "Zpět na nemovitosti",
  "text1401": "Zobrazit všechny fotografie",
  "text1402": "Vidíme, že jste si přidali produkty do oblíbených, i když jste nebyli přihlášeni. Chcete si produkty přidat do oblíbených?",
  "text1403": "Přidat",
  "text1404": "Nepřijímejte",
  "text1405": "Zákazníka nelze přiřadit.",
  "text1406": "Vyhledat produkt",
  "text1407": "Umístění",
  "text1408": "Umístění nemovitosti",
  "text1409": "Typ nemovitosti",
  "text1410": "Vyberte",
  "text1411": "Zadejte klíčové slovo",
  "text1412": "Vyberte cenové rozpětí",
  "text1413": "Nemovitosti",
  "text1414": "Rozpočty",
  "text1415": "Sídlo společnosti",
  "text1416": "Mám zájem o",
  "text1417": "Ano",
  "text1418": "Pouze nové budovy",
  "text1419": "Žádné nemovitosti",
  "text1420": "nemovitosti v nabídce",
  "text1421": "Seřadit podle",
  "text1422": "Chci prodat",
  "text1423": "Majetek",
  "text1424": "Nemovitosti",
  "text1425": "nabízené nemovitosti",
  "text1426": "nabízené vlastnosti",
  "text1427": "Z",
  "text1428": "Kontakt",
  "text1429": "Vyberte si, jaký typ účtu si u nás chcete vytvořit.",
  "text1430": "Uživatel",
  "text1431": "Student",
  "text1432": "Společnost",
  "text1433": "Škola",
  "text1434": "webové stránky společnosti",
  "text1435": "Adresa sídla společnosti",
  "text1436": "Registrace společnosti",
  "text1437": "Pokud již u nás máte účet, prosím.",
  "text1438": "přihlásit se.",
  "text1439": "Provoz společnosti se liší od sídla společnosti",
  "text1440": "Kontaktní údaje odpovědné osoby",
  "text1441": "Heslo musí obsahovat minimálně 8 znaků.",
  "text1442": "za účelem vytvoření účtu a kontaktování vás.",
  "text1443": "Všechny projekty",
  "text1444": "Nový",
  "text1445": "Další informace o produktu",
  "text1446": "Koupit produkt",
  "text1447": "Přílohy ke stažení",
  "text1448": "Cena celkem bez DPH",
  "text1449": "Cena za kus bez DPH",
  "text1450": "Cena zboží bez DPH",
  "text1451": "Celkem bez DPH",
  "text1452": "Náhled konfigurace",
  "text1453": "Rozbalit všechno",
  "text1454": "Konfigurace produktu",
  "text1455": "Povrchové úpravy",
  "text1456": "Povrchové úpravy zad",
  "text1457": "Provedení dvířek",
  "text1458": "Hrany",
  "text1459": "Úchytky",
  "text1460": "Panty",
  "text1461": "Ornamenty",
  "text1462": "Rozměry",
  "text1463": "Doplňujúci údaje",
  "text1464": "Zadejte počet kusů",
  "text1465": "Počet kusů",
  "text1466": "Vyčistit konfiguraci",
  "text1467": "Zavřít konfigurátor",
  "text1468": "Konfigurátor",
  "text1469": "Náhled",
  "text1470": "Konfigurovat",
  "text1471": "Neplatná konfigurace",
  "text1472": "Nastala chyba",
  "text1473": "Nastavte počet kusů",
  "text1474": "Pro přidání do košíku musíte nastavit počet kusů",
  "text1475": "Mé adresy",
  "text1476": "Registrace uživatele",
  "text1477": "Registrace studentů",
  "text1478": "Registrace do školy",
  "text1479": "Název školy",
  "text1480": "webové stránky školy",
  "text1481": "Adresa školy",
  "text1482": "Studijní obory na škole",
  "text1483": "Email zaměstnance školy",
  "text1484": "Oficiální školní e-mail",
  "text1485": "Přidat oddělení",
  "text1486": "Vyplňte pole",
  "text1487": "Konfigurace API pro službu Google Analytics není vyplněna.",
  "text1488": "Zahájení generování exportu",
  "text1489": "Generování exportu dokončeno",
  "text1490": "Hledáte práci? Vyplňte kontaktní formulář",
  "text1491": "Nenašli jste nabídku v aktuálně volných pracovních místech? Žádný problém, vyplňte kontaktní formulář, nahrajte svůj životopis a my se vám ozveme v případě, že se objeví volné místo.",
  "text1492": "Kariéra",
  "text1493": "Stručně popište pozici, o kterou byste měli zájem...",
  "text1494": "Důležité kontakty",
  "text1495": "Oblíbené nabídky",
  "text1496": "Oblast činnosti",
  "text1497": "Velikost podniku",
  "text1498": "Zajímavosti o společnosti",
  "text1499": "Popis společnosti",
  "text1500": "Přehled nabídek",
  "text1501": "Popis školy",
  "text1502": "Přehled studijních oborů",
  "text1503": "Datum přijímací zkoušky",
  "text1504": "Den otevřených dveří",
  "text1505": "Spolupráce / Odborná praxe",
  "text1506": "Neexistuje žádný záznam.",
  "text1507": "Kurzy",
  "text1508": "Upravit profil",
  "text1509": "Předchozí pracovní zkušenosti",
  "text1510": "Vzdělání a kvalifikace",
  "text1511": "Osobní dovednosti",
  "text1512": "Další dovednosti",
  "text1513": "Státní příslušnost",
  "text1514": "Místo výkonu práce",
  "text1515": "Jakou školu studujete?",
  "text1516": "Jaký typ práce hledáte?",
  "text1517": "Není vyplněno",
  "text1518": "Profil společnosti",
  "text1519": "Odstranění všech",
  "text1520": "Inzeráty",
  "text1521": "Profil školy",
  "text1522": "Hledané společnosti",
  "text1523": "Zobrazit profil",
  "text1524": "Nabídky práce v",
  "text1525": "Vyčistěte filtr",
  "text1526": "Informace o nabídce práce",
  "text1527": "Plat",
  "text1528": "Oddělení",
  "text1529": "Pozice",
  "text1530": "Počet volných pracovních míst",
  "text1531": "Platnost nabídky zaměstnání",
  "text1532": "Požadované dovednosti",
  "text1533": "Další informace",
  "text1534": "Vytvoření profilu",
  "text1535": "Předchozí pracovní zkušenosti",
  "text1536": "Vzdělání a kvalifikace",
  "text1537": "Uložit a pokračovat později",
  "text1538": "Zvolte pohlaví",
  "text1539": "Jaký je váš obor?",
  "text1540": "Základní údaje o společnosti",
  "text1541": "Logo",
  "text1542": "Zajímavosti o společnosti",
  "text1543": "Slogan společnosti",
  "text1544": "Stručně popište svou společnost a její činnost...",
  "text1545": "Napište sem zajímavost o vaší společnosti...",
  "text1546": "Napište slogan své společnosti...",
  "text1547": "Kontaktní údaje společnosti",
  "text1548": "Poskytujete studentům stáže?",
  "text1549": "Uvítali byste spolupráci se školami?",
  "text1550": "Ano",
  "text1551": "Ne",
  "text1552": "Odkaz na Facebook",
  "text1553": "Odkaz na Instagram",
  "text1554": "Odkaz na Linkedin",
  "text1555": "Oblast činnosti",
  "text1556": "Velikost společnosti",
  "text1557": "Vyberte velikost společnosti",
  "text1558": "Seznam referencí",
  "text1559": "Profil školy",
  "text1560": "Základní údaje o škole",
  "text1561": "Školní projekty",
  "text1562": "Adresa je ve špatném formátu",
  "text1563": "Vytvoření firemního profilu bude sloužit jako vaše vizitka.",
  "text1564": "Studijní obory na škole",
  "text1565": "Školy",
  "text1566": "Společnosti",
  "text1567": "Vyzkoušejte efektivní vyhledávání kandidátů",
  "text1568": "Jobiis Matching vám doporučí vhodného kandidáta.",
  "text1569": "Přidat nabídku",
  "text1570": "Kontaktní údaje školy",
  "text1571": "Studijní obory na škole",
  "text1572": "Stručný popis školy",
  "text1573": "Zajímavosti o škole",
  "text1574": "Stručně popište svou školu...",
  "text1575": "Zveřejněte svou nabídku práce a najděte vhodného kandidáta",
  "text1576": "Pomocí našeho portálu můžete zveřejnit nabídku práce a v krátké době najít kandidáta, který splňuje vaše kritéria.",
  "text1577": "Spojte se s firmami a najděte partnera pro učňovskou praxi nebo stáž pro své studenty.",
  "text1578": "Jobiis vám usnadní přístup k možnostem pracovních zkušeností nebo stáží pro vaše studenty.",
  "text1579": "Měli byste zájem o uspořádání přednášky s odborníkem na vaší škole?",
  "text1580": "Pomůžeme vám uspořádat přednášku s odborníkem z vašeho oboru bez poplatku!",
  "text1581": "Najděte svůj protějšek.",
  "text1582": "Přidat oddělení",
  "text1583": "Objednávka",
  "text1584": "Nahrát logo",
  "text1585": "Spolupráce škol",
  "text1586": "Projekty, do kterých je škola zapojena",
  "text1587": "Datum otevřených dveří",
  "text1588": "Datum přijímací zkoušky",
  "text1589": "Vyberte datum",
  "text1590": "Vyberte typ členství",
  "text1591": "Pokud si od nás chcete objednat zboží do jiné země, napište nám na adresu.",
  "text1592": "a my vaši objednávku zpracujeme individuálně.",
  "text1593": "Přidání projektu",
  "text1594": "Přidat spolupráci",
  "text1595": "Popis společnosti",
  "text1596": "Vaše oblast činnosti",
  "text1597": "Sociální sítě",
  "text1598": "V jakém okruhu chcete pracovat",
  "text1599": "Jaký je váš obor?",
  "text1600": "Jaký typ práce hledáte?",
  "text1601": "Očekávaný plat v € (měsíčně)",
  "text1602": "Zahájení ihned",
  "text1603": "Pracovní doba",
  "text1604": "Název pozice",
  "text1605": "Stále přetrvává",
  "text1606": "Přidat další",
  "text1607": "Název Kvalifikace",
  "text1608": "Vzdělávací organizace",
  "text1609": "Trvalé vzdělávání",
  "text1610": "webová stránka organizace",
  "text1611": "Odstranit",
  "text1612": "Jazykové dovednosti",
  "text1613": "Mateřský jazyk",
  "text1614": "Ostatní jazyky",
  "text1615": "Digitální dovednosti",
  "text1616": "Jaké máte digitální dovednosti?",
  "text1617": "Jakou kategorii řidičského průkazu vlastníte?",
  "text1618": "Typ práce",
  "text1619": "Popis práce",
  "text1620": "Pozice vhodná pro",
  "text1621": "Nižší platový práh v €",
  "text1622": "Horní hranice platu v €",
  "text1623": "Průmysl",
  "text1624": "Zaměstnanecké výhody",
  "text1625": "Pracovní doba",
  "text1626": "Požadovaný minimální věk",
  "text1627": "Ukončené vzdělání",
  "text1628": "Požadované vzdělání v oboru",
  "text1629": "Jazykové dovednosti",
  "text1630": "Předchozí zkušenosti jsou vyžadovány",
  "text1631": "Potřebná kvalifikace",
  "text1632": "Osobnostní předpoklady",
  "text1633": "Informace pro žadatele",
  "text1634": "Diplom",
  "text1635": "Vyberte si typ práce",
  "text1636": "Jakou školu studujete",
  "text1637": "Zvolte si vhodnou pracovní dobu",
  "text1638": "Přidání dovednosti",
  "text1639": "Vyberte oddělení",
  "text1640": "Vyberte si typ práce",
  "text1641": "Tvůrčí práce",
  "text1642": "Konference a semináře",
  "text1643": "Koníčky a zájmy",
  "text1644": "Vyznamenání a ocenění",
  "text1645": "Sítě a členství",
  "text1646": "Projekty",
  "text1647": "Publikace",
  "text1648": "Odkazy",
  "text1649": "Dobrovolnické aktivity",
  "text1650": "Vyberte typ dovednosti",
  "text1651": "Úroveň dovedností",
  "text1652": "Název tvůrčího díla",
  "text1653": "Popis tvůrčí práce",
  "text1654": "Nahrát soubor",
  "text1655": "Název konference",
  "text1656": "Odkaz na seminář/konferenci",
  "text1657": "Popis semináře/konference",
  "text1658": "Název koníčku/zájmu",
  "text1659": "Popis koníčků/zájmů",
  "text1660": "Název ceny/udělení",
  "text1661": "Popis vyznamenání/udělení",
  "text1662": "Převádějící instituce",
  "text1663": "Datum předání",
  "text1664": "Název členství",
  "text1665": "Popis členství",
  "text1666": "Název projektu",
  "text1667": "Popis projektu",
  "text1668": "Název publikace",
  "text1669": "Datum zveřejnění",
  "text1670": "Popis publikace",
  "text1671": "Název reference",
  "text1672": "Nahrát referenční list",
  "text1673": "Pozice (referendum)",
  "text1674": "E-mail (referenda)",
  "text1675": "Telefonní číslo (referendum)",
  "text1676": "Umístění",
  "text1677": "Název dobrovolnické činnosti",
  "text1678": "Popis dobrovolnické činnosti",
  "text1679": "Odkaz na soubor/video",
  "text1680": "Další",
  "text1681": "Nemáte žádné přidané dovednosti",
  "text1682": "Váš profil byl úspěšně aktualizován",
  "text1683": "Nahrání profilového obrázku",
  "text1684": "Přidání inzerátu",
  "text1685": "Vytvoření inzerátu",
  "text1686": "Typ mzdy",
  "text1687": "Umístění",
  "text1688": "Moje zprávy",
  "text1689": "Nesprávný token, zkuste to znovu",
  "text1690": "Vyhledávání podle názvu nabídky, odvětví, místa",
  "text1691": "Dnes je to",
  "text1692": "Kontakty",
  "text1693": "Promluva",
  "text1694": "Jak vybrat aktivní sezení",
  "text1695": "Stažitelný dokument a přístupové heslo budou dostupné až po potvrzení platby.",
  "text1696": "Obnovení hesla",
  "text1697": "Zobrazit detail realizace",
  "text1698": "Realizace",
  "text1699": "Místo",
  "text1700": "Všechny vizualizace realizace",
  "text1701": "Zpět na všechny realizace",
  "text1702": "Detail produktu",
  "text1703": "Žádní uživatelé",
  "text1704": "Vyhledej uživatele",
  "text1705": "Komu",
  "text1706": "Kontaktní formulář z webu",
  "text1707": "Registrace studentů",
  "text1708": "Navigovat do prodejny",
  "text1709": "Pokud chcete být informováni o nejnovějších zprávách, termínech dokončení a možnostech přihlaste se k odběru našeho newsletteru a dostávajte aktuální informace přímo do vaší schránky.",
  "text1710": "Pon - Sob: 8:00 - 19:00 hodin.",
  "text1711": "Odpovíme Vám do 24 hodin. během pracovní doby.",
  "text1712": "Vzorková prodejna",
  "text1713": "Osobní setkání je třeba předem dohodnout.",
  "text1714": "Vyplňte formulář a my vám v co nejkratší době odpovíme na vaši otázku.",
  "text1715": "Zobrazit další",
  "text1716": "Seřazení",
  "text1717": "Prax pro studenty",
  "text1718": "Spolupráce se školami",
  "text1719": "Stáří",
  "text1720": "Vymazat chat",
  "text1721": "Žádné zprávy",
  "text1722": "\nTento produkt pro Vás připravujeme",
  "text1723": "Adresa společnosti",
  "text1724": "Kontaktní osoba",
  "text1725": "www adresa",
  "text1726": "Titul před jménem",
  "text1727": "Charakteristika společnosti",
  "text1728": "Vyberte oblast",
  "text1729": "Dokončit nabídku",
  "text1730": "Požadovaná znalost jazyků",
  "text1731": "Požadované vzdělání",
  "text1732": "Požadované pracovní zkušenosti",
  "text1733": "Typ nabídky práce",
  "text1734": "Můj účet",
  "text1735": "Můj životopis",
  "text1736": "Moje pracovní nabídky",
  "text1737": "Moje kurzy",
  "text1738": "Moje firma",
  "text1739": "Životopisy",
  "text1740": "Životopis a certifikáty",
  "text1741": "Fotografie a video",
  "text1742": "Dovednosti a znalosti",
  "text1743": "Kategorie odvětví",
  "text1744": "Nahrajte svůj životopis ke stažení pro zaměstnavatele.",
  "text1745": "Certifikát",
  "text1746": "Nahrajte certifikáty které máte k dispozici.",
  "text1747": "Motivační dopis",
  "text1748": "Nahrajte motivační dopis.",
  "text1749": "Fotografie není povinná, ale životopis s fotkou působí osobněji a personalisty zaujme více.",
  "text1750": "Nahrajte svůj video životopis který vás posune o krok blíže k vytoužené pracovní pozici.",
  "text1751": "Věděli jste, že personalistovi stačí v průměru 7 vteřin na první proskenování životopisu? Vzpomeňte proto jen relevantní zkušenosti a popište je v odrážkách nebo v krátkých odstavcích.",
  "text1752": "Dejte zaměstnavatelům vědět, jaké je vaše vzdělání.",
  "text1753": "Zadejte, jaké dovednosti a znalosti ovládáte, a na jaké úrovni.",
  "text1754": "Přidejte si do životopisu další sekce, které jsou pro vás důležité.",
  "text1755": "Titul za jménem",
  "text1756": "Ze seznamu vyberte kategorie odvětví, o které se chcete ucházet",
  "text1757": "Naše sociální sítě",
  "text1758": "Naše reference",
  "text1759": "Další reference",
  "text1760": "Náš tým",
  "text1761": "Aktuální nabídka",
  "text1762": "Neplatný klíč",
  "text1763": "Realizovali jsme",
  "text1764": "Ekologicky šetrné průmyslové chemikálie",
  "text1765": "Jak vyrábíme produkty?",
  "text1766": "Možnost pracovat z domova?",
  "text1767": "Den nástupu",
  "text1768": "Popis pracovní nabídky",
  "text1769": "Kontaktní údaje pro reakci na nabídku",
  "text1770": "Přidejte požadované pracovní zkušenosti a jejich úroveň, které jsou vyžadovány od uchazeče.",
  "text1771": "Přidejte požadované vzdělání, které jsou vyžadovány od uchazeče.",
  "text1772": "Přidejte požadovanou znalost jazyků pro tuto pracovní pozici",
  "text1773": "Přidejte si do nabídky další části, které jsou od uchazeče požadovány.",
  "text1774": "Název pracovní zkušenosti",
  "text1775": "Úroveň pracovní zkušenosti",
  "text1776": "Přidat novou",
  "text1777": "Středoškolské vzdělání",
  "text1778": "Vysokoškolské vzdělání I. stupně",
  "text1779": "Vysokoškolské vzdělání II. stupně",
  "text1780": "Vysokoškolské vzdělání III. stupně",
  "text1781": "Úroveň",
  "text1782": "Vyberte kategorie řidičského průkazu, které vyžadujete od uchazeče.",
  "text1783": "Váš životopis byl úspěšně aktualizován",
  "text1784": "Dokončit životopis",
  "text1785": "Nová odpověď v poradně",
  "text1786": "Přibyla vám nová odpověď v poradně",
  "text1787": "Otázka byla úspěšně přidána",
  "text1788": "Přidáno",
  "text1789": "Reakce na inzerát",
  "text1790": "let",
  "text1791": "Stáhnout CV",
  "text1792": "Balení",
  "text1793": "Najděte svůj lokální obchod",
  "text1794": "Katalogové číslo",
  "text1795": "Dodání 7 - 10 dní",
  "text1796": "Zaregistrovat",
  "text1797": "Nemáte žádné pracovní nabídky",
  "text1798": "Vyhledané životopisy",
  "text1799": "Nezáleží",
  "text1800": "Hledejte výrobce, název, sérii, kód výrobku...",
  "text1801": "Vyberte si kvalitu a krásu - nakupujte u nás!",
  "text1802": "Jsme přímým dovozcem těchto výrobců",
  "text1803": "Běžná cena za",
  "text1804": "Naše cena za",
  "text1805": "Cena za 1 balení",
  "text1806": "Zadejte obsah plochy pro výpočet množství balení",
  "text1807": "Zadejte obsah plochy",
  "text1808": "balení",
  "text1809": "Vyberte softskill",
  "text1810": "Vyberte úroveň",
  "text1811": "Sledovat video",
  "text1812": "Žádné nové oznámení",
  "text1813": "Prodávejte s námi",
  "text1814": "Spolupracujeme s těmito přepravci",
  "text1815": "Upravit inzerát",
  "text1816": "Doporučené pracovní pozice",
  "text1817": "Otevřená pozice",
  "text1818": "Obraťte se na nás",
  "text1819": "Podobné pozice",
  "text1820": "Vyhradzujeme si právo neodpovědět uchazečům, kteří nesplňují uvedené požadavky.",
  "text1821": "O firmě",
  "text1822": "Portfólio firem",
  "text1823": "Zamítnout všechny",
  "text1824": "Webová stránka",
  "text1825": "Kolik máte položek?",
  "text1826": "Kolik máte objednávek za měsíc?",
  "text1827": "shoda",
  "text1828": "Přijatý",
  "text1829": "Ano, chci dostávat příležitostné novinky a tipy na e-commerce služby.",
  "text1830": "Zamítnuto",
  "text1831": "Čeká",
  "text1832": "Reagoval",
  "text1833": "Měkké dovednosti",
  "text1834": "Vyberte si z více než 60 značek v našem portfoliu a najděte přesně to, co hledáte! Vše je plně přizpůsobitelné – od čalounění až po barvy. Kontaktujte nás a společně vytvoříme design na míru podle vašich představ.",
  "text1835": "Zobrazit produkty",
  "text1836": "Kam to bude?",
  "text1837": "dítě",
  "text1838": "děti",
  "text1839": "dětí",
  "text1840": "dospělý",
  "text1841": "dospělí",
  "text1842": "dospělých",
  "text1843": "1 až 3 noci",
  "text1844": "4 až 6 nocí",
  "text1845": "7 až 15 nocí",
  "text1846": "16+ nocí",
  "text1847": "Vyberte počet nocí",
  "text1848": "Více možností",
  "text1849": "Nová otázka",
  "text1850": "Místo, lokalita, hotel",
  "text1851": "Datum od - do",
  "text1852": "Počet cestujících",
  "text1853": "Délka pobytu",
  "text1854": "Strava",
  "text1855": "Zavřít",
  "text1856": "Ukázat další možnosti",
  "text1857": "Maximální cena za osobu",
  "text1858": "Více",
  "text1859": "Typ kvalifikace",
  "text1860": "Žádné zájezdy nevyhovují zadaným kritériím.",
  "text1861": "Dozvědět se více",
  "text1862": "Další články z posledního týdne",
  "text1863": "Prodejce",
  "text1864": "Ceník životopisů",
  "text1865": "Nová registrace velkoobchodu",
  "text1866": "Vůbec",
  "text1867": "Málo",
  "text1868": "Neutrální",
  "text1869": "Trochu více",
  "text1870": "Velmi",
  "text1871": "Zdá se ti to zajímavé?",
  "text1872": "Úspěšně dokončil test",
  "text1873": "Hotovo",
  "text1874": "Nejvíce se hodíš na",
  "text1875": "Ukázat volné pozice",
  "text1876": "Nejsem plátce DPH",
  "text1877": "Zobrazit všechny oznámení",
  "text1878": "Notifikace",
  "text1879": "Nepřečteno",
  "text1880": "Označit všechny jako přečtené",
  "text1881": "Žádné oznámení",
  "text1882": "Počet záznamů k zobrazení",
  "text1883": "Máte",
  "text1884": "novou zprávu",
  "text1885": "nové zprávy",
  "text1886": "nových zpráv",
  "text1887": "Odpověď na přihlášku na inzerát",
  "text1888": "Reakce na inzerát",
  "text1889": "Dokončete svůj profil",
  "text1890": "Nová nabídka práce",
  "text1891": "Nabídka brzy expiruje",
  "text1892": "Firma projevila zájem",
  "text1893": "Nový zájemce",
  "text1894": "Aktualizujte svůj profil",
  "text1895": "Systémové oznámení",
  "text1896": "Máte nového kandidáta pro pracovní nabídku",
  "text1897": "přidala novou pracovní nabídku",
  "text1898": "o tebe projevila zájem",
  "text1899": "sleva",
  "text1900": "Nejnovější blogy",
  "text1901": "Doporučené produkty",
  "text1902": "Novinky a slevy",
  "text1903": "Detail kategorie",
  "text1904": "Pro pokračování vyplňte všechny otázky",
  "text1905": "Odeslat test",
  "text1906": "Speciálni akce",
  "text1907": "Chci prodávat přes Loft.cz",
  "text1908": "Zadejte email a nezmeškejte jedinečné nabídky",
  "text1909": "Servis",
  "text1910": "Infolinka",
  "text1911": "Vhodné pracovní oblasti",
  "text1912": "Vhodné pracovní prostředí",
  "text1913": "Přidejte se k nám",
  "text1914": "Očekávaný plat",
  "text1915": "Oblíbené firmy",
  "text1916": "Přejít na všechny školy",
  "text1917": "Předplatné",
  "text1918": "Naposledy viděno",
  "text1919": "Moje události",
  "text1920": "Další článek",
  "text1921": "Předchozí článek",
  "text1922": "Pokračujte na nákup předplatného.",
  "text1923": "Země dodání",
  "text1924": "Potřebujete nás kontaktovat? Napište nám na",
  "text1925": "VOC",
  "text1926": "MOC",
  "text1927": "Aktivní předplatné",
  "text1928": "V případě zrušení předplatného zůstává Vaše předplatné aktivní do uplynutí předplaceného období.",
  "text1929": "Historie předplatného",
  "text1930": "Stáhnout fakturu",
  "text1931": "Předplatné aktivováno",
  "text1932": "Dovednosti",
  "text1933": "Máte již zakoupené předplatné?",
  "text1934": "Přihlaste se do svého účtu.",
  "text1935": "Předplatné obsahuje přístup ke všem dance classes, Workouts a dalším informacím, 10% slevu na všechny eventy Danceana OZ pro registrované.",
  "text1936": "Vytvořte si přihlašovací údaje.",
  "text1937": "Začátek",
  "text1938": "Konec",
  "text1939": "Partneři",
  "text1940": "Koupit předplatné",
  "text1941": "Všechny události",
  "text1942": "Méně",
  "text1943": "Všechna alba",
  "text1944": "Viz galerii",
  "text1945": "Co získáte?",
  "text1946": "Chci se stát partnerem",
  "text1947": "Všechny",
  "text1948": "Lektoři",
  "text1949": "Další kurzy které by Vás mohly zajímat",
  "text1950": "Obchodní podmínky",
  "text1951": "V této kategorii nemáme k dispozici žádné kurzy.",
  "text1952": "Uložit změnu údajů",
  "text1953": "Prosíme o ověření vaší emailové adresy",
  "text1954": "Ověřit",
  "text1955": "O mně",
  "text1956": "Dosud",
  "text1957": "Hodnoty",
  "text1958": "K dokončení registrace je třeba potvrdit emailovou adresu",
  "text1959": "Znovu poslat potvrzovací email",
  "text1960": "Potvrzovací email byl znovu odeslán",
  "text1961": "Při odesílání potvrzovacího emailu nastala chyba",
  "text1962": "Emailová adresa byla úspěšně ověřena",
  "text1963": "Vyhledej školy",
  "text1964": "Žádné školy",
  "text1965": "Vyberte web",
  "text1966": "Přihlaste se na obder novinek a dostávejte vždy ty nejaktuálnější informace z naší nabídky",
  "text1967": "Klienti o nás řekli",
  "text1968": "Zvolenému filtru nevyhovují žádné nemovitosti",
  "text1969": "Nejvíce byste se hodili na pozice",
  "text1970": "Vhodné pracovní pozice",
  "text1971": "Pracovní benefity",
  "text1972": "Kvalifikace",
  "text1973": "Emailovou adresu se nepodařilo ověřit",
  "text1974": "Spustit test",
  "text1975": "Opravdu chcete vymazat inzerát",
  "text1976": "den",
  "text1977": "dny",
  "text1978": "dnů",
  "text1979": "Skrýt seznam dodavatelů",
  "text1980": "Zobrazit seznam dodavatelů",
  "text1981": "Ověřit dostupnost u prodejce",
  "text1982": "Vybrat prodejce",
  "text1983": "Vyberte prodejce",
  "text1984": "Skrýt seznam prodejců",
  "text1985": "Zobrazit seznam prodejců",
  "text1986": "Děkujeme, Vaši poptávku jsme zaevidovali, do pár hodin Vás budeme kontaktovat",
  "text1987": "Oblíbené školy",
  "text1988": "Pokud u nás ještě nemáte účet",
  "text1989": "Tato škola zatím nemá ověřený profil",
  "text1990": "Uložit životopis PDF",
  "text1991": "Kontaktovat zájemce",
  "text1992": "Řidičská oprávnění",
  "text1993": "Prohlížet produkty",
  "text1994": "Hodnota musí být z intervalu",
  "text1995": "Zadejte",
  "text1996": "Základní úroveň",
  "text1997": "Vyberte délku členství",
  "text1998": "Cena za 1 měsíc předplatného",
  "text1999": "Vyberte počet životopisů",
  "text2000": "Všechny články",
  "text2001": "Přihlaste se k odběru novinek a dostávajte jako první ty nejžhavější informace o slevách, novinkách a událostech.",
  "text2002": "Odesláním přihlášení do newslletera souhlasíte se",
  "text2003": "Nenašli jste odpověď\nna otázku?",
  "text2004": "Ozvěte se nám a zeptejte se",
  "text2005": "Naše prodejna s půjčovnou",
  "text2006": "Půjčovna",
  "text2007": "Potřebujete poradit nebo máte otázku ohledně produktu? Kontakujte nás a my se Vám ozveme.",
  "text2008": "Napište nám",
  "text2009": "Požadované vzdělání/praxe v oboru",
  "text2010": "Zaslat zájem o pracovní nabídku",
  "text2011": "Zájem o pracovní nabídku byl zaslán",
  "text2012": "Viz firmy",
  "text2013": "Potřebujete poradit? Ozvěte se nám",
  "text2014": "Ukázat všechny",
  "text2015": "Nesouhlasím se zasláním dotazníku spokojenosti v rámci programu Heureka Ověřeno zákazníky a Zboží.cz",
  "text2016": "Přidat sociální sítě",
  "text2017": "Cena včetně 23% DPH",
  "text2018": "Podmínky půjčovny ZDE",
  "text2019": "Zaregistrujte se",
  "text2020": "Už máte svůj účet?",
  "text2021": "Vyberte si motocykl",
  "text2022": "Vyhledejte podle názvu motocyklu...",
  "text2023": "Nebyly nalezeny žádné produkty pro",
  "text2024": "V této kategorii nejsou dostupné žádné produkty",
  "text2025": "Vymazat všechny",
  "text2026": "Smí obsahovat pouze čísla",
  "text2027": "Typ školy",
  "text2028": "Zpět pro výběr motocyklu",
  "text2029": "Děkujeme, zájem o testovací\njízdu byl odeslán.",
  "text2030": "V co nejkratším čase Vás budeme kontaktovat a dohodneme termín Vaší testovací jízdy",
  "text2031": "Zpět na hlavní stránku",
  "text2032": "Odborové zaměření",
  "text2033": "Nejlépe ukončené vzdělání",
  "text2034": "Adresa místa výkonu práce",
  "text2035": "Mám vlastní vzor",
  "text2036": "Prostřednictvím tohoto formuláře nám zašlete vlastní design / vzor a my Vám naceníme\n              výrobu.",
  "text2037": "Termíny kurzů",
  "text2038": "Přidat softskill",
  "text2039": "Zájem byl úspěšně odeslán",
  "text2040": "Zájem o pracovní nabídku již byl realizován.",
  "text2041": "Opravdu chcete zaslat zájem o tuto pracovní nabídku?",
  "text2042": "Potvrdit zájem",
  "text2043": "Potvrdit nákup",
  "text2044": "Opravdu chcete zakoupit předplatné?",
  "text2045": "Období",
  "text2046": "měsíců",
  "text2047": "Zapnout oznámení",
  "text2048": "Nová nabídka u zaměstnavatele",
  "text2049": "Nová odpověď na zájem o nabídku",
  "text2050": "Upozornění na vypršení platnosti oblíbeného inzerátu",
  "text2051": "Nový zájem firmy",
  "text2052": "škol",
  "text2053": "Zobrazeno",
  "text2054": "Odbory",
  "text2055": "Místo hledané práce",
  "text2056": "Očekávaná mzda",
  "text2057": "Vzdálenost do práce",
  "text2058": "Pracovní hodiny",
  "text2059": "Datum vytvoření profilu",
  "text2060": "Doporučená rozlišení",
  "text2061": "Produkt bude stažitelný po zaplacení objednávky",
  "text2062": "Nemáte plně vyplněný profil",
  "text2063": "Je třeba mít vyplněné jméno, příjmení a alespoň 1 měkkou zručnost",
  "text2064": "Aspoň 1 měkká dovednost",
  "text2065": "Vytvoření profilu bude sloužit i jako tvůj životopis. Vyplň prosím jednotlivé kroky a odpověz na následující otázky.",
  "text2066": "Zrušit přijetí uchazeče",
  "text2067": "Chcete potvrdit zájem uchazeče",
  "text2068": "Přijmout uchazeče",
  "text2069": "Probíhá potvrzování zájmu uchazeče",
  "text2070": "Potvrdit",
  "text2071": "Přijmout zájem",
  "text2072": "Odmítnout zájem",
  "text2073": "Kandidát obdrží zprávu o tom, že jste jej přijali",
  "text2074": "Prax pro studenty",
  "text2075": "Žádné nabídky",
  "text2076": "Zobrazit",
  "text2077": "nabídku",
  "text2078": "nabídky",
  "text2079": "Přijmout všechny",
  "text2080": "Potvrdit všechny nabídky",
  "text2081": "Tato akce potvrdí zájem o práci všech kandidátů, jejichž žádost má status \"Čeká\"",
  "text2082": "Kandidáti obdrží zprávu o tom, že jste je přijali",
  "text2083": "Potvrzují se všechny nabídky...",
  "text2084": "Koncept",
  "text2085": "Aktivní",
  "text2086": "Archivované",
  "text2087": "Uložit koncept",
  "text2088": "Přidat měkkou dovednost",
  "text2089": "Účet se vymaže za",
  "text2090": "Opravdu chcete vymazat účet?",
  "text2091": "Zobrazit můj životopis v databázi životopisů",
  "text2092": "odemknutí životopisu",
  "text2093": "Nejste Jobiis Partner",
  "text2094": "Chcete-li nakupovat odemknutí životopisů za zvýhodněnou cenu, nejprve je potřeba aktivovat \"Jobiis Partner\" předplatné",
  "text2095": "Formulář není vyplněn",
  "text2096": "Zobrazit reakce",
  "text2097": "Odstranit inzerát",
  "text2098": "Archivovat",
  "text2099": "Aktivovat",
  "text2100": "Archivovaná",
  "text2101": "Aktivní",
  "text2102": "Chybně vyplněný formulář",
  "text2103": "Formulář není vyplněn správně. Zkontrolujte formuláře pošlete znovu.",
  "text2104": "Tento životopis nemáte odemčen",
  "text2105": "Odemknout životopis",
  "text2106": "Chcete-li zpřístupnit informace na tomto životopisu, je třeba životopis odemknout.",
  "text2107": "Odemknout",
  "text2108": "Zbývající volná odemknutí",
  "text2109": "Zbývající zakoupené odemknutí",
  "text2110": "Životopis byl odemčen",
  "text2111": "Zobrazit životopis",
  "text2112": "Nezaplacená",
  "text2113": "Zaplatit",
  "text2114": "Topovat",
  "text2115": "Žádné produkty v košíku",
  "text2116": "Nemáte dostatek kreditu",
  "text2117": "Firemní benefity",
  "text2118": "Nabídka vhodná pro cizince",
  "text2119": "Nabídka vhodná pro absolventa",
  "text2120": "Vzdělávací kurzy",
  "text2121": "Vytvoř spojení se svým budoucím zaměstnáním",
  "text2122": "Jsem zaměstnavatel",
  "text2123": "Jsem uchazeč",
  "text2124": "Zaplatit nabídku",
  "text2125": "Odemknout nabídku zdarma",
  "text2126": "Volné nabídky",
  "text2127": "odemknutí nabídky",
  "text2128": "Člen",
  "text2129": "Partner",
  "text2130": "Využít volné nabídky",
  "text2131": "zůstává",
  "text2132": "Využít volného topování",
  "text2133": "Mé životopisy",
  "text2134": "Topováno",
  "text2135": "Celkově k úhradě",
  "text2136": "Shrnutí objednávky",
  "text2137": "Pokračovat na shrnutí",
  "text2138": "Produkty k nákupu",
  "text2139": "Doručovací adresa",
  "text2140": "Zpět na dodací a fakturační údaje",
  "text2141": "pro účely zpracování objednávek a marketingové účely.",
  "text2142": "Souhlasím se zasíláním informací o novinkách, slevách a cenových akcích.",
  "text2143": "maximálně 600 znaků",
  "text2144": "Doplnit údaje firmy podle IČO",
  "text2145": "Doplnit údaje",
  "text2146": "Nemáte vyplněné údaje",
  "text2147": "Váš profil nemá kompletně vyplněné fakturační údaje.",
  "text2148": "Platí do",
  "text2149": "maximálně 600 znaků",
  "text2150": "Povinné",
  "text2151": "Chcete uložit změny, které jste provedli?",
  "text2152": "Neuložit",
  "text2153": "Topováno do",
  "text2154": "Žádné reakce na nabídku",
  "text2155": "Koupit životopisy",
  "text2156": "Vyhledávání podle města",
  "text2157": "měsíce",
  "text2158": "Odborná praxe pro studenty",
  "text2159": "Titul kvalifikace/vzdělání",
  "text2160": "Dosažené vzdělání",
  "text2161": "Organizace poskytující vzdělání/kvalifikaci",
  "text2162": "Zadaný email již existuje",
  "text2163": "Velikost podniku",
  "text2164": "Vyberte velikost podniku",
  "text2165": "Zobrazit výhody",
  "text2166": "Základní",
  "text2167": "Obsah není platný XML",
  "text2168": "Obsah není platný JSON",
  "text2169": "Nákup na splátky",
  "text2170": "Měsíc",
  "text2171": "Nemáte přidáno žádné vzdělání/kvalifikaci",
  "text2172": "Nahlásit chybu",
  "text2173": "Odemčení životopisů",
  "text2174": "Odemčení nabídek",
  "text2175": "Topování",
  "text2176": "Popis chyby",
  "text2177": "Chyba byla nahlášena",
  "text2178": "Nahlásit další chybu",
  "text2179": "Chyba se odesílá",
  "text2180": "Nabídka uložená jako koncept musí mít jméno",
  "text2181": "Ověření dostupnosti zboží",
  "text2182": "Adresa prodejce",
  "text2183": "Dobrý den, v eshopu",
  "text2184": "jsme zaevidovali poptávku zákazníka na následující zboží:",
  "text2185": "Prosím informujte nás, zda poptávané zboží máte na prodejně, abychom mohli informovat zákazníka.",
  "text2186": "S pozdravem obchodní oddělení",
  "text2187": "Váš profil zatím není vyplněn",
  "text2188": "Aby firmy mohly vidět Váš profil, je třeba ještě vyplnit následující údaje",
  "text2189": "Vyplnit profil",
  "text2190": "Chcete-li, aby firmy viděli váš profil v databázi životopisů, je třeba vyplnit ještě následující údaje:",
  "text2191": "Dokončit profil",
  "text2192": "Admin",
  "text2193": "Aktualizovat",
  "text2194": "Profil zájemce",
  "text2195": "Vybrat lektora",
  "text2196": "Další classes lektora",
  "text2197": "Průběh campu",
  "text2198": "Lektorský tým",
  "text2199": "Jednotlivé kurzy",
  "text2200": "Přihlášení",
  "text2201": "Všechny sály",
  "text2202": "Celý rozvrh",
  "text2203": "Galerie události",
  "text2204": "Média",
  "text2205": "Nenašli jste odpověď na Váš dotaz? Kontaktujte nás.",
  "text2206": "Instruktor",
  "text2207": "O lektorovi",
  "text2208": "Jaké typy tance vyučuji?",
  "text2209": "Úrovně tanečních zkušeností",
  "text2210": "Galerie lektora",
  "text2211": "Tanečník",
  "text2212": "Pedagog",
  "text2213": "Zařazení (vyberte z možností) *",
  "text2214": "Zadejte název taneční skupiny / ZUŠ a kde působí",
  "text2215": "Vyberte školu",
  "text2216": "V případě problémů nás kontaktujte",
  "text2217": "Tento e-mail bude sloužit jako přihlašovací jméno.",
  "text2218": "Po registraci obdržíte ověřovací e-mail.",
  "text2219": "podmínkami předplatného",
  "text2220": "Podmínky předplatného",
  "text2221": "Nabídka není plně vyplněna. Chcete-li nabídku zveřejnit, upravte nabídku tak, aby byla vyplněna všechna povinná pole.",
  "text2222": "Chcete-li uložit nabídku jako koncept, je třeba vyplnit název nabídky.",
  "text2223": "Zaplacení nabídky",
  "text2224": "Nabídka bude zveřejněna až po zaplacení",
  "text2225": "Zaplatit nabídku můžete na profilu v sekci",
  "text2226": "Pracovní nabídka",
  "text2227": "Souhlasím s opakovanými platbami",
  "text2228": "Ceník",
  "text2229": "Vytvoření profilu školy vám bude sloužit jako vizitka školy.",
  "text2230": "Gratulujeme! Vaše přihláška na inzerát byla schválena. Klepnutím otevřete chat s firmou.",
  "text2231": "Bohužel, vaše přihláška k inzerátu byla zamítnuta.",
  "text2232": "Kurz byl úspěšně přidán do košíku",
  "text2233": "Položky v košíku",
  "text2234": "Fyzická osoba",
  "text2235": "Právnická osoba (firma)",
  "text2236": "Zařazení",
  "text2237": "Vyberte z možností",
  "text2238": "Zadejte email",
  "text2239": "Zadejte telefonní číslo",
  "text2240": "Zadejte jméno",
  "text2241": "Zadejte příjmení",
  "text2242": "Upravit nabídku",
  "text2243": "Před zakoupením předplatného je třeba být přihlášen",
  "text2244": "Ještě nemáte účet?",
  "text2245": "Vytvořte si ho zde",
  "text2246": "Galerie",
  "text2247": "Zaujměte",
  "text2248": "s profesním",
  "text2249": "videoživotopisem",
  "text2250": "Recept",
  "text2251": "Vytvořit profesní životopis",
  "text2252": "Číslo karty",
  "text2253": "Platnost karty",
  "text2254": "CVC",
  "text2255": "MM / RR",
  "text2256": "Lektor",
  "text2257": "Zpřístupněte si obsah kurzu prostřednictvím",
  "text2258": "předplatného.",
  "text2259": "Pokud máte předplatné zakoupené,",
  "text2260": "přihlásit se.",
  "text2261": "Nemáte žádné oblíbené kurzy",
  "text2262": "Odebrat kartu",
  "text2263": "Servis kol",
  "text2264": "Zaplatit a zveřejnit",
  "text2265": "Zaplatit později",
  "text2266": "Odkaz pro reakci na nabídku",
  "text2267": "Pole nechte prázdné ak reakce na nabídku chcete spravovat v našem systému",
  "text2268": "Zaslat zájem přímo",
  "text2269": "Zaplacená",
  "text2270": "Zrušit odběr",
  "text2271": "Pokud si nepřejete dostávat emaily, klikněte na odkaz",
  "text2272": "Naše adresa",
  "text2273": "Navštivte nás",
  "text2274": "Jméno držitele karty",
  "text2275": "Nesprávný formát privátního klíče",
  "text2276": "Doporučujeme objednat",
  "text2277": "Přidejte ke zprávě DXF soubor, v případě více souborů je zabalte do .rar nebo .zip",
  "text2278": "Zeptat se na cenu",
  "text2279": "Zadejte množství",
  "text2280": "Vaše poptávka na cenu byla odeslána. Budeme Vás kontaktovat prostřednictvím vaší e-mailové adresy.",
  "text2281": "Nemám zájem",
  "text2282": "Nakoupili u nás",
  "text2283": "Více než 2,789 spokojených zákazníků",
  "text2284": "Vybrané kategorie",
  "text2285": "300m2 prodejna",
  "text2286": "Po-pá: 8:30 - 17:00",
  "text2287": "Bonus klub",
  "text2288": "Opravdu se chcete odhlásit?",
  "text2289": "Ano, odhlásit se",
  "text2290": "Uložit změny",
  "text2291": "vytvořte si jej zde.",
  "text2292": "Pokud ještě nemáte svůj účet,",
  "text2293": "Ne, zrušit",
  "text2294": "Spokojený zákazník",
  "text2295": "Osoba",
  "text2296": "Firma",
  "text2297": "Skladem",
  "text2298": "na vaší adrese",
  "text2299": "Prozkoumat",
  "text2300": "Nejprodávanější produkty",
  "text2301": "Načíst více",
  "text2302": "Třídit",
  "text2303": "Posíláme ihned",
  "text2304": "Porovnat",
  "text2305": "Technické parametry",
  "text2306": "Přidat hodnocení",
  "text2307": "Nastala chyba při aktualizování vašeho profilu.",
  "text2308": "Všeobecná ustanovení",
  "text2309": "Hlavní nabídka",
  "text2310": "Informace o Vaší objednávce",
  "text2311": "Objednávka byla zaplacena",
  "text2312": "Objednávka byla zaplacena",
  "text2313": "Pokračujte dolů",
  "text2314": "TOP výběr",
  "text2315": "Prozkoumejte TOP výběry pro každou zahradu",
  "text2316": "Milované majiteli domů\npo celém Slovensku",
  "text2317": "Nejoblíbenější dřevěné konstrukce a doplňky pro vaši zahradu",
  "text2318": "Prozkoumejte naše nejprodávanější kategorie dřevěných altánků, domků, přístřešků a doplňků. Kvalita a rychlé doručení po celém Slovensku.",
  "text2319": "Všechny kategorie",
  "text2320": "Čím sa vyznačujú naše produkty?",
  "text2321": "Technické detaily",
  "text2322": "Naše poslední reference",
  "text2323": "Kvalifikace",
  "text2324": "Proč si vybrat dřevěné altány a domečky?",
  "text2325": "Chcete i vy svůj vysněný zahradní domek nebo altán?",
  "text2326": "Objevte nabídku",
  "text2327": "Benefity",
  "text2328": "Co získáte s našimi produkty?",
  "text2329": "Mám zájem o konzultaci",
  "text2330": "Realizace",
  "text2331": "Příběhy spokojených zákazníků",
  "text2332": "Více realizací",
  "text2333": "Zajímavé články na přečtení",
  "text2334": "Nenašli jste odpověď na otázku? Neváhejte nás kontaktovat.",
  "text2335": "Přehrát video",
  "text2336": "Jste připraveni přeměnit svoji zahradu?",
  "text2337": "Potřebujete poradit? Neváhejte nás kontaktovat ať už přes kontaktní formulář nebo přímo přes kontaktní údaje níže.",
  "text2338": "Vyplňte formulář.",
  "text2339": "O co máte zájem?",
  "text2340": "Vaše zpráva",
  "text2341": "Odesláním formuláře souhlasíte se",
  "text2342": "zpracováním osobních údajů.",
  "text2343": "Odeslat zprávu",
  "text2344": "Přihlaste se k odběru newsletteru a získávejte ty nejaktuálnější informace o naší nabídce.",
  "text2345": "Nepamatujete si své heslo?",
  "text2346": "Prosím vyplňte číslo objednávky a e-mail.",
  "text2347": "Objednávka pro zadanou kombinaci čísla objednávky a emailu neexistuje.",
  "text2348": "Jste přihlášen. Všechny Vaše objednávky umíte najít ve svém profilu.",
  "text2349": "Heslo musí obsahovat minimálně 6 až 64 znaků, jedno velké písmeno a jedno číslo.",
  "text2350": "Osobní / firemní údaje",
  "text2351": "Soupisné číslo",
  "text2352": "Vaše registrace proběhla úspěšně. Do Vaší e-mailové schránky jsme Vám zaslali potvrzovací link pro aktivaci účtu.",
  "text2353": "Vyberte si kategorii podle preference a najděte produkt který hledáte.",
  "text2354": "Zobrazit více kategorii",
  "text2355": "Řadit podle",
  "text2356": "O kategorii",
  "text2357": "Kalkulačka",
  "text2358": "Kontaktujte nás a rádi vám pomůžeme.",
  "text2359": "Tento produkt zatím nemá žádné recenze. Buďte první a podělte se o Vaši zkušenost!",
  "text2360": "recenzí",
  "text2361": "Historie objednávek",
  "text2362": "Nakupuji na firmu",
  "text2363": "Potvrdit změnu hesla",
  "text2364": "Vyskytla se chyba.",
  "text2365": "Místo reference",
  "text2366": "O projektu",
  "text2367": "Galerie projektu",
  "text2368": "Zkušenost klienta",
  "text2369": "Podobné realizace",
  "text2370": "Pokračujte na článek",
  "text2371": "Obsah článku",
  "text2372": "Po - Pá",
  "text2373": "So - Ne",
  "text2374": "Zavřeno",
  "text2375": "Navigovat k provozu",
  "text2376": "Nenašli jsme obsah který vyhovuje hledaným požadavkům",
  "text2377": "Děkujeme za Váš zájem",
  "text2378": "Co nejdříve Vás budeme kontaktovat zpátky.",
  "text2379": "Domovská stránka",
  "text2380": "Inspirace",
  "text2381": "Inspirace pro vaši zahradu",
  "text2382": "Prohlédněte si proces výroby zahradního domku a altánku",
  "text2383": "My vs konkurence",
  "text2384": "V čem jsme lepší než konkurence?",
  "text2385": "Konkurence",
  "text2386": "Dřevěné zahradní altány a domečky pro vaši zahradu",
  "text2387": "Kvalita a dostupné ceny s doručením po Slovensku",
  "text2388": "Vytvořte si dokonalý prostor pro relaxaci, skladování nebo ochranu auta s našimi dřevěnými altánky, domky, pergolami a přístřeškami. Objednejte ještě dnes!",
  "text2389": "Cena za kus",
  "text2390": "Platba a doprava",
  "text2391": "K jedné API integraci je povolena pouze jedna aktivní kategorie.",
  "text2392": "Pokud u nás máte svůj účet, přihlaste se a údaje vyplníme na základě údajů z Vašeho účtu.",
  "text2393": "Podívejte se, co si naši zákazníci neumí vynachválit. Tyto top hodnocené produkty kombinují styl, funkčnost a dostupnost.",
  "text2394": "Podívejte se na naše nejoblíbenější dřevěné konstrukce, vyrobené z kvalitního smrku nebo borovice pro odolnost a šarm. Ideální pro jakýkoli venkovní prostor.",
  "text2395": "Přihláška",
  "text2396": "Užitečné linky",
  "text2397": "Stát se členem",
  "text2398": "Členská zóna",
  "text2399": "Jméno příjmení / Název společnosti",
  "text2400": "Pracoviště (např. biochemická laboratoř)",
  "text2401": "Instituce (např. NsP Bratislava)",
  "text2402": "pro účely marketingu a kontaktování",
  "text2403": "Zpracování osobních údajů",
  "text2404": "Zjistěte více",
  "text2405": "Vítejte v členské zóně",
  "text2406": "Dokumenty",
  "text2407": "Stanovy",
  "text2408": "Etický kodex",
  "text2409": "Předsednictvo",
  "text2410": "Zápisnice a dokumenty",
  "text2411": "Seznam zástupců členů sdružení",
  "text2412": "Statistika IVD trhu",
  "text2413": "Pohledávky",
  "text2414": "Souhlasím se zasláním dotazníku spokojenosti v rámci programu Heureka Ověřeno zákazníky a Zboží.cz, který pomáhá zlepšovať naše služby.",
  "text2415": "Poznej svého lektora",
  "text2416": "Vyhledávejte podle názvu firmy nebo IČO",
  "text2417": "Nenašely se žádné firmy",
  "text2418": "Neznámá platební brána",
  "text2419": "Nemáte žádné aktivní předplatné.",
  "text2420": "Zakupte si jej zde.",
  "text2421": "Typ plátce",
  "text2422": "Jedn. cena",
  "text2423": "Metráž",
  "text2424": "Zakoupené kurzy",
  "text2425": "Nemáte zakoupené žádné kurzy.",
  "text2426": "Přehled kurzů.",
  "text2427": "Krok zpět",
  "text2428": "Stav své objednávky si můžete kdykoli zkontrolovat kliknutím na tlačítko níže",
  "text2429": "Vaši rezervaci e-receptu jsme obdrželi. Zkontrolujte si e-mailovou schránku.",
  "text2430": "Nevyplněno",
  "text2431": "Děkujeme za zaslání rezervace!",
  "text2432": "Vaše rezervace byla úspěšně odeslána.",
  "text2433": "Odeslané údaje",
  "text2434": "Nahrajte fotografii receptu",
  "text2435": "Vybrané fotografie",
  "text2436": "Odfotit",
  "text2437": "Obrázek e-receptu",
  "text2438": "Jako uchazeč",
  "text2439": "Už mám účet, chci se",
  "text2440": "Jako zaměstnavatel",
  "text2441": "Identifikační číslo (IČ)",
  "text2442": "Adresa a sídlo společnosti",
  "text2443": "Upravit životopis",
  "text2444": "Úpravy v profilu byly úspěšně uloženy",
  "text2445": "Zeptej se našeho odborníka",
  "text2446": "Preferované místo",
  "text2447": "Práce o víkendech",
  "text2448": "Práce během noci",
  "text2449": "Dodatečné informace",
  "text2450": "Pracovní preference",
  "text2451": "Vybraným filtrům nevyhovují žádné životopisy",
  "text2452": "Pro přidání nové pracovní nabídky je třeba vyplnit všechna povinná pole.",
  "text2453": "Základní informace o pozici",
  "text2454": "Požadavky na uchazeče",
  "text2455": "Typ úvazku",
  "text2456": "Vyberte požadovaný typ řidičského průkazu",
  "text2457": "Přidat další jazyk",
  "text2458": "Předpokládaný den nástupu",
  "text2459": "Uveďte informace o místě výkonu práce.",
  "text2460": "Mzdové podmínky",
  "text2461": "Uveďte platební podmínky pro uchazeče",
  "text2462": "Odstranit nabídku",
  "text2463": "Aktuální nabídky",
  "text2464": "Tato firma nemá žádné aktivní nabídky",
  "text2465": "Popište svou firmu",
  "text2466": "Poskytujeme praxi studentům",
  "text2467": "Spolupracujeme se školami",
  "text2468": "Obsah blogu",
  "text2469": "Podobné články",
  "text2470": "Přečtěte si užitečné články.",
  "text2471": "Registrovat",
  "text2472": "Vložit do košíku",
  "text2473": "Pokročilé vyhledávání",
  "text2474": "Vyhledávat v",
  "text2475": "Prosím počkejte na email a SMS",
  "text2476": "Vymazat filtr",
  "text2477": "Částečná shoda s názvem produktu",
  "text2478": "Krátký popis produktu",
  "text2479": "EAN kód produktu",
  "text2480": "Externí kód produktu",
  "text2481": "Kód produktu",
  "text2482": "Začněte psát adresu",
  "text2483": "Kandidáti",
  "text2484": "Nejstarší kandidáti",
  "text2485": "Nejmladší kandidáti",
  "text2486": "Nejnovější reakce",
  "text2487": "Nejstarší reakce",
  "text2488": "Přijatý",
  "text2489": "Nepřijatý",
  "text2490": "Termín již brzy",
  "text2491": "Nebyly nalezeny žádné kurzy",
  "text2492": "prodejna",
  "text2493": "Tréninkový proces",
  "text2494": "Chybějící nastavení mailové šablony ve stavu objednávky",
  "text2495": "Balíkovo samoobslužné boxy",
  "text2496": "Balíkovo obchodní provozovna",
  "text2497": "Podej",
  "text2498": "Vybrat",
  "text2499": "Vybrané místo",
  "text2500": "Dobírka",
  "text2501": "Celková částka objednávky",
  "text2502": "Zakoupit",
  "text2503": "Využít volného topování",
  "text2504": "kredit",
  "text2505": "kredity",
  "text2506": "kreditů",
  "text2507": "Platba kredity",
  "text2508": "Expedice pro objednávku není připravena",
  "text2509": "Objednávka již byla expedována",
  "text2510": "Dopravce nenabízí automatizovanou expedici",
  "text2511": "Příště nezobrazovat",
  "text2512": "Počet osob",
  "text2513": "Pro platební metodu není povolen opakovaný pokus o zaplacení",
  "text2514": "Platební brána momentálně nepodporuje vrácení peněz přes API",
  "text2515": "Vytvoření připomínky",
  "text2516": "Upravení připomínky",
  "text2517": "Vymazání připomínky",
  "text2518": "Vytvoření produktu",
  "text2519": "Upravení produktu",
  "text2520": "Vymazání produktu",
  "text2521": "Vytvoření ceny",
  "text2522": "Upravení ceny",
  "text2523": "Vymazání ceny",
  "text2524": "Vytvoření typu nemovitosti",
  "text2525": "Upravení typu nemovitosti",
  "text2526": "Vymazání typu nemovitosti",
  "text2527": "Vytvoření typu nabídky nemovitosti",
  "text2528": "Upravení typu nabídky nemovitosti",
  "text2529": "Vymazání typu nabídky nemovitosti",
  "text2530": "Vytvoření místnosti",
  "text2531": "Upravení místnosti",
  "text2532": "Vymazání místnosti",
  "text2533": "Vytvoření štítku nemovitosti",
  "text2534": "Upravení štítku nemovitosti",
  "text2535": "Vymazání štítku nemovitosti",
  "text2536": "Vytvoření doplňkové informace nemovitosti",
  "text2537": "Upravení doplňkové informace nemovitosti",
  "text2538": "Vymazání doplňkové informace nemovitosti",
  "text2539": "Vytvoření hodnoty doplňkové informace nemovitosti",
  "text2540": "Upravení hodnoty doplňkové informace nemovitosti",
  "text2541": "Vymazání hodnoty doplňkové informace nemovitosti",
  "text2542": "Vytvoření města",
  "text2543": "Upravení města",
  "text2544": "Vymazání města",
  "text2545": "Vytvoření obce",
  "text2546": "Upravení obce",
  "text2547": "Vymazání obce",
  "text2548": "Vytvoření textového pole nemovitosti",
  "text2549": "Upravení textového pole nemovitosti",
  "text2550": "Vymazání textového pole nemovitosti",
  "text2551": "Vytvoření kategorie nemovitosti",
  "text2552": "Upravení kategorie nemovitosti",
  "text2553": "Vymazání kategorie nemovitosti",
  "text2554": "Vytvoření pravidla nemovitosti",
  "text2555": "Upravení pravidla nemovitosti",
  "text2556": "Vymazání pravidla nemovitosti",
  "text2557": "Vytvoření odpovědi pravidla nemovitosti",
  "text2558": "Upravení odpovědi pravidla nemovitosti",
  "text2559": "Vymazání odpovědi pravidla nemovitosti",
  "text2560": "Vytvoření rezervace nemovitosti",
  "text2561": "Upravení rezervace nemovitosti",
  "text2562": "Vymazání rezervace nemovitosti",
  "text2563": "Vytvoření destinace nemovitosti",
  "text2564": "Upravení destinace nemovitosti",
  "text2565": "Vymazání destinace nemovitosti",
  "text2566": "Vytvoření pozice nemovitosti",
  "text2567": "Upravení pozice nemovitosti",
  "text2568": "Vymazání pozice nemovitosti",
  "text2569": "Vytvoření agentury nemovitosti",
  "text2570": "Upravení agentury nemovitosti",
  "text2571": "Vymazání agentury nemovitosti",
  "text2572": "Vytvoření makléře nemovitosti",
  "text2573": "Upravení makléře nemovitosti",
  "text2574": "Vymazání makléře nemovitosti",
  "text2575": "Vytvoření developera nemovitosti",
  "text2576": "Upravení developera nemovitosti",
  "text2577": "Vymazání developera nemovitosti",
  "text2578": "Vytvoření nemovitosti",
  "text2579": "Upravení nemovitosti",
  "text2580": "Vymazání nemovitosti",
  "text2581": "Vytvoření ceny nemovitosti",
  "text2582": "Upravení ceny nemovitosti",
  "text2583": "Vymazání ceny nemovitosti",
  "text2584": "Vytvoření vlastního pravidla nemovitosti",
  "text2585": "Upravení vlastního pravidla nemovitosti",
  "text2586": "Vymazání vlastního pravidla nemovitosti",
  "text2587": "Vytvoření rezervovatelného dne nemovitosti",
  "text2588": "Upravení rezervovatelného dne nemovitosti",
  "text2589": "Vymazání rezervovatelného dne nemovitosti",
  "text2590": "Vytvoření typu kurzu",
  "text2591": "Upravení typu kurzu",
  "text2592": "Vymazání typu kurzu",
  "text2593": "Vytvoření kategorie kurzu",
  "text2594": "Upravení kategorie kurzu",
  "text2595": "Vymazání kategorie kurzu",
  "text2596": "Vytvoření textového pole kurzu",
  "text2597": "Upravení textového pole kurzu",
  "text2598": "Vymazání textového pole kurzu",
  "text2599": "Vytvoření kurzu",
  "text2600": "Upravení kurzu",
  "text2601": "Vymazání kurzu",
  "text2602": "Vytvoření kategorie poradny",
  "text2603": "Upravení kategorie poradny",
  "text2604": "Vymazání kategorie poradny",
  "text2605": "Vytvoření ceny kurzu",
  "text2606": "Upravení ceny kurzu",
  "text2607": "Vymazání ceny kurzu",
  "text2608": "Vytvoření kapitoly kurzu",
  "text2609": "Upravení kapitoly kurzu",
  "text2610": "Vymazání kapitoly kurzu",
  "text2611": "Vytvoření lektora kurzu",
  "text2612": "Upravení lektora kurzu",
  "text2613": "Vymazání lektora kurzu",
  "text2614": "Vytvoření úrovně kurzu",
  "text2615": "Upravení úrovně kurzu",
  "text2616": "Vymazání úrovně kurzu",
  "text2617": "Vytvoření místnosti kurzu",
  "text2618": "Upravení místnosti kurzu",
  "text2619": "Vymazání místnosti kurzu",
  "text2620": "Vytvoření události kurzu",
  "text2621": "Upravení události kurzu",
  "text2622": "Vymazání události kurzu",
  "text2623": "Vytvoření harmonogramu kurzu",
  "text2624": "Upravení harmonogramu kurzu",
  "text2625": "Vymazání harmonogramu kurzu",
  "text2626": "Vytvoření typu pracovního úvazku",
  "text2627": "Upravení typu pracovního úvazku",
  "text2628": "Vymazání typu pracovního úvazku",
  "text2629": "Vytvoření štítku pracovního portálu",
  "text2630": "Upravení štítku pracovního portálu",
  "text2631": "Vymazání štítku pracovního portálu",
  "text2632": "Vytvoření textového pole pracovního portálu",
  "text2633": "Upravení textového pole pracovního portálu",
  "text2634": "Vymazání textového pole pracovního portálu",
  "text2635": "Vytvoření kategorie pracovního portálu",
  "text2636": "Upravení kategorie pracovního portálu",
  "text2637": "Vymazání kategorie pracovního portálu",
  "text2638": "Vytvoření typu platby pracovního portálu",
  "text2639": "Upravení typu platby pracovního portálu",
  "text2640": "Vymazání typu platby pracovního portálu",
  "text2641": "Vytvoření velikosti firmy pracovního portálu",
  "text2642": "Upravení velikosti firmy pracovního portálu",
  "text2643": "Vymazání velikosti firmy pracovního portálu",
  "text2644": "Vytvoření firmy pracovního portálu",
  "text2645": "Upravení firmy pracovního portálu",
  "text2646": "Vymazání firmy pracovního portálu",
  "text2647": "Vytvoření stavu pracovního portálu",
  "text2648": "Upravení stavu pracovního portálu",
  "text2649": "Vymazání stavu pracovního portálu",
  "text2650": "Vytvoření hodnoty atributu pracovního portálu",
  "text2651": "Upravení hodnoty atributu pracovního portálu",
  "text2652": "Vymazání hodnoty atributu pracovního portálu",
  "text2653": "Vytvoření atributu pracovního portálu",
  "text2654": "Upravení atributu pracovního portálu",
  "text2655": "Vymazání atributu pracovního portálu",
  "text2656": "Vytvoření času práce pracovního portálu",
  "text2657": "Upravení času práce pracovního portálu",
  "text2658": "Vymazání času práce pracovního portálu",
  "text2659": "Vytvoření místa výkonu práce pracovního portálu",
  "text2660": "Upravení místa výkonu práce pracovního portálu",
  "text2661": "Vymazání místa výkonu práce pracovního portálu",
  "text2662": "Vytvoření věkového rozpětí pracovního portálu",
  "text2663": "Upravení věkového rozpětí pracovního portálu",
  "text2664": "Vymazání věkového rozpětí pracovního portálu",
  "text2665": "Vytvoření požadované předešlé praxe pracovního portálu",
  "text2666": "Upravení požadované předešlé praxe pracovního portálu",
  "text2667": "Vymazání požadované předešlé praxe pracovního portálu",
  "text2668": "Vytvoření vhodnoti pro pozici pracovního portálu",
  "text2669": "Upravení vhodnoti pro pozici pracovního portálu",
  "text2670": "Vymazání vhodnoti pro pozici pracovního portálu",
  "text2671": "Vytvoření ukončeného vzdělání pracovního portálu",
  "text2672": "Upravení ukončeného vzdělání pracovního portálu",
  "text2673": "Vymazání ukončeného vzdělání pracovního portálu",
  "text2674": "Vytvoření řidičského průkazu pracovního portálu",
  "text2675": "Upravení řidičského průkazu pracovního portálu",
  "text2676": "Vymazání řidičského průkazu pracovního portálu",
  "text2677": "Vytvoření typu školy pracovního portálu",
  "text2678": "Upravení typu školy pracovního portálu",
  "text2679": "Vymazání typu školy pracovního portálu",
  "text2680": "Vytvoření školního oboru pracovního portálu",
  "text2681": "Upravení školního oboru pracovního portálu",
  "text2682": "Vymazání školního oboru pracovního portálu",
  "text2683": "Vytvoření školy pracovního portálu",
  "text2684": "Upravení školy pracovního portálu",
  "text2685": "Vymazání školy pracovního portálu",
  "text2686": "Vytvoření projektu školy pracovního portálu",
  "text2687": "Upravení projektu školy pracovního portálu",
  "text2688": "Vymazání projektu školy pracovního portálu",
  "text2689": "Vytvoření spolupráce školy pracovního portálu",
  "text2690": "Upravení spolupráce školy pracovního portálu",
  "text2691": "Vymazání spolupráce školy pracovního portálu",
  "text2692": "Vytvoření pracovní nabídky pracovního portálu",
  "text2693": "Upravení pracovní nabídky pracovního portálu",
  "text2694": "Vymazání pracovní nabídky pracovního portálu",
  "text2695": "Vytvoření dovednosti pracovní nabídky pracovního portálu",
  "text2696": "Upravení dovednosti pracovní nabídky pracovního portálu",
  "text2697": "Vymazání dovednosti pracovní nabídky pracovního portálu",
  "text2698": "Vytvoření mzdy pracovní nabídky pracovního portálu",
  "text2699": "Upravení mzdy pracovní nabídky pracovního portálu",
  "text2700": "Vymazání mzdy pracovní nabídky pracovního portálu",
  "text2701": "Vytvoření životopisu pracovního portálu",
  "text2702": "Upravení životopisu pracovního portálu",
  "text2703": "Vymazání životopisu pracovního portálu",
  "text2704": "Vytvoření dovednosti životopisu pracovního portálu",
  "text2705": "Upravení dovednosti životopisu pracovního portálu",
  "text2706": "Vymazání dovednosti životopisu pracovního portálu",
  "text2707": "Vytvoření pracovní zkušenosti životopisu pracovního portálu",
  "text2708": "Upravení pracovní zkušenosti životopisu pracovního portálu",
  "text2709": "Vymazání pracovní zkušenosti životopisu pracovního portálu",
  "text2710": "Vytvoření vzdělání životopisu pracovního portálu",
  "text2711": "Upravení vzdělání životopisu pracovního portálu",
  "text2712": "Vymazání vzdělání životopisu pracovního portálu",
  "text2713": "Vytvoření mzdy životopisu pracovního portálu",
  "text2714": "Upravení mzdy životopisu pracovního portálu",
  "text2715": "Vymazání mzdy životopisu pracovního portálu",
  "text2716": "Vytvoření stavu cestovní kanceláře",
  "text2717": "Upravení stavu cestovní kanceláře",
  "text2718": "Vymazání stavu cestovní kanceláře",
  "text2719": "Vytvoření štítku cestovní kanceláře",
  "text2720": "Upravení štítku cestovní kanceláře",
  "text2721": "Vymazání štítku cestovní kanceláře",
  "text2722": "Vytvoření textového pole cestovní kanceláře",
  "text2723": "Upravení textového pole cestovní kanceláře",
  "text2724": "Vymazání textového pole cestovní kanceláře",
  "text2725": "Vytvoření hodnoty atributu cestovní kanceláře",
  "text2726": "Upravení hodnoty atributu cestovní kanceláře",
  "text2727": "Vymazání hodnoty atributu cestovní kanceláře",
  "text2728": "Vytvoření atributu cestovní kanceláře",
  "text2729": "Upravení atributu cestovní kanceláře",
  "text2730": "Vymazání atributu cestovní kanceláře",
  "text2731": "Vytvoření kategorie cestovní kanceláře",
  "text2732": "Upravení kategorie cestovní kanceláře",
  "text2733": "Vymazání kategorie cestovní kanceláře",
  "text2734": "Vytvoření zájezdu cestovní kanceláře",
  "text2735": "Upravení zájezdu cestovní kanceláře",
  "text2736": "Vymazání zájezdu cestovní kanceláře",
  "text2737": "Vytvoření termínu zájezdu cestovní kanceláře",
  "text2738": "Upravení termínu zájezdu cestovní kanceláře",
  "text2739": "Vymazání termínu zájezdu cestovní kanceláře",
  "text2740": "Vytvoření rezervace zájezdu cestovní kanceláře",
  "text2741": "Upravení rezervace zájezdu cestovní kanceláře",
  "text2742": "Vymazání rezervace zájezdu cestovní kanceláře",
  "text2743": "Vytvoření účastníka zájezdu cestovní kanceláře",
  "text2744": "Upravení účastníka zájezdu cestovní kanceláře",
  "text2745": "Vymazání účastníka zájezdu cestovní kanceláře",
  "text2746": "Vytvoření typu zákazníka",
  "text2747": "Upravení typu zákazníka",
  "text2748": "Vymazání typu zákazníka",
  "text2749": "Vytvoření zákazníka",
  "text2750": "Upravení zákazníka",
  "text2751": "Vymazání zákazníka",
  "text2752": "Vytvoření zákazníka v zákaznické skupině",
  "text2753": "Upravení zákazníka v zákaznické skupině",
  "text2754": "Vymazání zákazníka ze zákaznické skupiny",
  "text2755": "Vytvoření zákaznické skupiny",
  "text2756": "Upravení zákaznické skupiny",
  "text2757": "Vymazání zákaznické skupiny",
  "text2758": "Vytvoření uživatelské role",
  "text2759": "Upravení uživatelské role",
  "text2760": "Vymazání uživatelské role",
  "text2761": "Vytvoření uživatele",
  "text2762": "Upravení uživatele",
  "text2763": "Vymazání uživatele",
  "text2764": "Vytvoření kuponu k produktu",
  "text2765": "Upravení kuponu k produktu",
  "text2766": "Vymazání kuponu k produktu",
  "text2767": "Vytvoření kuponu",
  "text2768": "Upravení kuponu",
  "text2769": "Vymazání kuponu",
  "text2770": "Vytvoření slevy kuponu",
  "text2771": "Upravení slevy kuponu",
  "text2772": "Vymazání slevy kuponu",
  "text2773": "Vytvoření dárku k produktu",
  "text2774": "Upravení dárku k produktu",
  "text2775": "Vymazání dárku k produktu",
  "text2776": "Vytvoření příslušenství k produktu",
  "text2777": "Upravení příslušenství k produktu",
  "text2778": "Vymazání příslušenství k produktu",
  "text2779": "Vytvoření balíčku k produktu",
  "text2780": "Upravení balíčku k produktu",
  "text2781": "Vymazání balíčku k produktu",
  "text2782": "Vytvoření otázky k produktu",
  "text2783": "Upravení otázky k produktu",
  "text2784": "Vymazání otázky k produktu",
  "text2785": "Vytvoření virtuálního produktu k produktu",
  "text2786": "Upravení virtuálního produktu k produktu",
  "text2787": "Vymazání virtuálního produktu k produktu",
  "text2788": "Vytvoření služby k produktu",
  "text2789": "Upravení služby k produktu",
  "text2790": "Vymazání služby produktu",
  "text2791": "Vytvoření recenze produktu",
  "text2792": "Upravení recenze produktu",
  "text2793": "Vymazání recenze produktu",
  "text2794": "Vytvoření varianty produktu",
  "text2795": "Upravení varianty produktu",
  "text2796": "Vymazání varianty produktu",
  "text2797": "Vytvoření ceny varianty produktu",
  "text2798": "Upravení ceny varianty produktu",
  "text2799": "Vymazání ceny varianty produktu",
  "text2800": "Vytvoření marže kategorie",
  "text2801": "Upravení marže kategorie",
  "text2802": "Vymazání marže kategorie",
  "text2803": "Vytvoření slevy kategorie",
  "text2804": "Upravení slevy kategorie",
  "text2805": "Vymazání slevy kategorie",
  "text2806": "Vytvoření kategorie",
  "text2807": "Upravení kategorie",
  "text2808": "Vymazání kategorie",
  "text2809": "Vytvoření hodnoty atributu",
  "text2810": "Upravení hodnoty atributu",
  "text2811": "Vymazání hodnoty atributu",
  "text2812": "Vytvoření atributu",
  "text2813": "Upravení atributu",
  "text2814": "Vymazání atributu",
  "text2815": "Vytvoření marže dodavatele",
  "text2816": "Upravení marže dodavatele",
  "text2817": "Vymazání marže dodavatele",
  "text2818": "Vytvoření slevy dodavatele",
  "text2819": "Upravení slevy dodavatele",
  "text2820": "Vymazání slevy dodavatele",
  "text2821": "Vytvoření dodavatele",
  "text2822": "Upravení dodavatele",
  "text2823": "Vymazání dodavatele",
  "text2824": "Vytvoření výrobce",
  "text2825": "Upravení výrobce",
  "text2826": "Vymazání výrobce",
  "text2827": "Vytvoření textového pole",
  "text2828": "Upravení textového pole",
  "text2829": "Vymazání textového pole",
  "text2830": "Vytvoření stavu produktu",
  "text2831": "Upravení stavu produktu",
  "text2832": "Vymazání stavu produktu",
  "text2833": "Vytvoření štítku produktu",
  "text2834": "Upravení štítku produktu",
  "text2835": "Vymazání štítku produktu",
  "text2836": "Vytvoření dárku k produktu",
  "text2837": "Upravení dárku k produktu",
  "text2838": "Vymazání dárku k produktu",
  "text2839": "Vytvoření dárku",
  "text2840": "Upravení dárku",
  "text2841": "Vymazání dárku",
  "text2842": "Vytvoření produktu k akci",
  "text2843": "Upravení produktu k akci",
  "text2844": "Vymazání produktu k akci",
  "text2845": "Vytvoření akce",
  "text2846": "Upravení akce",
  "text2847": "Vymazání akce",
  "text2848": "Vytvoření ceny akce",
  "text2849": "Upravení ceny akce",
  "text2850": "Vymazání ceny akce",
  "text2851": "Vytvoření možnosti služby",
  "text2852": "Upravení možnosti služby",
  "text2853": "Vymazání možnosti služby",
  "text2854": "Vytvoření ceny možnosti služby",
  "text2855": "Upravení ceny možnosti služby",
  "text2856": "Vymazání ceny možnosti služby",
  "text2857": "Vytvoření způsobu platby",
  "text2858": "Upravení způsobu platby",
  "text2859": "Vymazání způsobu platby",
  "text2860": "Vytvoření ceny způsobu platby",
  "text2861": "Upravení ceny způsobu platby",
  "text2862": "Vymazání ceny způsobu platby",
  "text2863": "Vytvoření slevy způsobu platby",
  "text2864": "Upravení slevy způsobu platby",
  "text2865": "Vymazání slevy způsobu platby",
  "text2866": "Vytvoření způsobu dopravy",
  "text2867": "Upravení způsobu dopravy",
  "text2868": "Vymazání způsobu dopravy",
  "text2869": "Vytvoření ceny způsobu dopravy",
  "text2870": "Upravení ceny způsobu dopravy",
  "text2871": "Vymazání ceny způsobu dopravy",
  "text2872": "Vytvoření výdejního místa",
  "text2873": "Upravení výdejního místa",
  "text2874": "Vymazání výdejního místa",
  "text2875": "Vytvoření multiprojektu",
  "text2876": "Upravení multiprojektu",
  "text2877": "Vymazání multiprojektu",
  "text2878": "Vytvoření regionu",
  "text2879": "Upravení regionu",
  "text2880": "Vymazání regionu",
  "text2881": "Vytvoření jazyka",
  "text2882": "Upravení jazyka",
  "text2883": "Vymazání jazyka",
  "text2884": "Vytvoření měny",
  "text2885": "Upravení měny",
  "text2886": "Vymazání měny",
  "text2887": "Vytvoření země",
  "text2888": "Upravení země",
  "text2889": "Vymazání země",
  "text2890": "Vytvoření menu",
  "text2891": "Upravení menu",
  "text2892": "Vymazání menu",
  "text2893": "Vytvoření položky menu",
  "text2894": "Upravení položky menu",
  "text2895": "Vymazání položky menu",
  "text2896": "Vytvoření emailové šablony",
  "text2897": "Upravení emailové šablony",
  "text2898": "Vymazání emailové šablony",
  "text2899": "Vytvoření DPH",
  "text2900": "Upravení DPH",
  "text2901": "Vymazání DPH",
  "text2902": "Vytvoření typu velkoobchodu",
  "text2903": "Upravení typu velkoobchodu",
  "text2904": "Vymazání typu velkoobchodu",
  "text2905": "Vytvoření velkoobchodu",
  "text2906": "Upravení velkoobchodu",
  "text2907": "Vymazání velkoobchodu",
  "text2908": "Vytvoření adresy velkoobchodu",
  "text2909": "Upravení adresy velkoobchodu",
  "text2910": "Vymazání adresy velkoobchodu",
  "text2911": "Vytvoření domény velkoobchodu",
  "text2912": "Upravení domény velkoobchodu",
  "text2913": "Vymazání domény velkoobchodu",
  "text2914": "Vytvoření reklamace",
  "text2915": "Upravení reklamace",
  "text2916": "Vymazání reklamace",
  "text2917": "Vytvoření důvodu reklamace",
  "text2918": "Upravení důvodu reklamace",
  "text2919": "Vymazání důvodu reklamace",
  "text2920": "Vytvoření stavu reklamace",
  "text2921": "Upravení stavu reklamace",
  "text2922": "Vymazání stavu reklamace",
  "text2923": "Vytvoření stránky",
  "text2924": "Upravení stránky",
  "text2925": "Vymazání stránky",
  "text2926": "Vytvoření banneru",
  "text2927": "Upravení banneru",
  "text2928": "Vymazání banneru",
  "text2929": "Vytvoření pohlaví",
  "text2930": "Upravení pohlaví",
  "text2931": "Vymazání pohlaví",
  "text2932": "Vytvoření produktu k blogu",
  "text2933": "Upravení produktu k blogu",
  "text2934": "Vymazání produktu k blogu",
  "text2935": "Vytvoření blogu",
  "text2936": "Upravení blogu",
  "text2937": "Vymazání blogu",
  "text2938": "Vytvoření kategorie blogu",
  "text2939": "Upravení kategorie blogu",
  "text2940": "Vymazání kategorie blogu",
  "text2941": "Vytvoření příspěvku na sociální síť",
  "text2942": "Upravení příspěvku na sociální síť",
  "text2943": "Vymazání příspěvku na sociální síť",
  "text2944": "Vytvoření sociální sítě",
  "text2945": "Upravení sociální sítě",
  "text2946": "Vymazání sociální sítě",
  "text2947": "Vytvoření newsletteru",
  "text2948": "Upravení newsletteru",
  "text2949": "Vymazání newsletteru",
  "text2950": "Vytvoření hromadného mailu",
  "text2951": "Upravení hromadného mailu",
  "text2952": "Vymazání hromadného mailu",
  "text2953": "Vytvoření štítku newsletteru",
  "text2954": "Upravení štítku newsletteru",
  "text2955": "Vymazání štítku newsletteru",
  "text2956": "Vytvoření emailu newsletteru",
  "text2957": "Upravení emailu newsletteru",
  "text2958": "Vymazání emailu newsletteru",
  "text2959": "Vytvoření věrnostních bodů",
  "text2960": "Upravení věrnostních bodů",
  "text2961": "Vymazání věrnostních bodů",
  "text2962": "Vytvoření odpovědi poradny",
  "text2963": "Upravení odpovědi poradny",
  "text2964": "Vymazání odpovědi poradny",
  "text2965": "Vytvoření poradny",
  "text2966": "Upravení poradny",
  "text2967": "Vymazání poradny",
  "text2968": "Vytvoření kategorie reference",
  "text2969": "Upravení kategorie reference",
  "text2970": "Vymazání kategorie reference",
  "text2971": "Vytvoření reference",
  "text2972": "Upravení reference",
  "text2973": "Vymazání reference",
  "text2974": "Vytvoření služby",
  "text2975": "Upravení služby",
  "text2976": "Vymazání služby",
  "text2977": "Vytvoření ceny služby",
  "text2978": "Upravení ceny služby",
  "text2979": "Vymazání ceny služby",
  "text2980": "Vytvoření kariéry",
  "text2981": "Upravení kariéry",
  "text2982": "Vymazání kariéry",
  "text2983": "Vytvoření povinného zveřejňování",
  "text2984": "Upravení povinného zveřejňování",
  "text2985": "Vymazání povinného zveřejňování",
  "text2986": "Vytvoření galerie",
  "text2987": "Upravení galerie",
  "text2988": "Vymazání galerie",
  "text2989": "Vytvoření člena týmu",
  "text2990": "Upravení člena týmu",
  "text2991": "Vymazání člena týmu",
  "text2992": "Vytvoření zákazníka k předplatnému",
  "text2993": "Upravení zákazníka k předplatnému",
  "text2994": "Vymazání zákazníka k předplatnému",
  "text2995": "Vytvoření kategorie předplatného",
  "text2996": "Upravení kategorie předplatného",
  "text2997": "Vymazání kategorie předplatného",
  "text2998": "Vytvoření typu předplatného",
  "text2999": "Upravení typu předplatného",
  "text3000": "Vymazání typu předplatného",
  "text3001": "Vytvoření ceny typu předplatného",
  "text3002": "Upravení ceny typu předplatného",
  "text3003": "Vymazání ceny typu předplatného",
  "text3004": "Vytvoření předplatného",
  "text3005": "Upravení předplatného",
  "text3006": "Vymazání předplatného",
  "text3007": "Upravení API konfigurace",
  "text3008": "Vytvoření stavu objednávky",
  "text3009": "Upravení stavu objednávky",
  "text3010": "Vymazání stavu objednávky",
  "text3011": "Vytvoření nastavení stavu objednávky",
  "text3012": "Upravení nastavení stavu objednávky",
  "text3013": "Vymazání nastavení stavu objednávky",
  "text3014": "Vytvoření objednávky",
  "text3015": "Upravení objednávky",
  "text3016": "Vymazání objednávky",
  "text3017": "Vytvoření expedice objednávky",
  "text3018": "Upravení expedice objednávky",
  "text3019": "Vymazání expedice objednávky",
  "text3020": "Vytvoření ikony",
  "text3021": "Upravení ikony",
  "text3022": "Vymazání ikony",
  "text3023": "Vytvoření útulku",
  "text3024": "Upravení útulku",
  "text3025": "Vymazání útulku",
  "text3026": "Vytvoření typu recenze",
  "text3027": "Upravení typu recenze",
  "text3028": "Vymazání typu recenze",
  "text3029": "Vytvoření recenze",
  "text3030": "Upravení recenze",
  "text3031": "Vymazání recenze",
  "text3032": "Vytvoření konfigurací",
  "text3033": "Upravení konfigurací",
  "text3034": "Vymazání konfigurací",
  "text3035": "Vytvoření seo",
  "text3036": "Upravení seo",
  "text3037": "Vymazání seo",
  "text3038": "Vytvoření přesměrování",
  "text3039": "Upravení přesměrování",
  "text3040": "Vymazání přesměrování",
  "text3041": "Vytvoření služby kalkulačky",
  "text3042": "Upravení služby kalkulačky",
  "text3043": "Vymazání služby kalkulačky",
  "text3044": "Vytvoření ceny služby kalkulačky",
  "text3045": "Upravení ceny služby kalkulačky",
  "text3046": "Vymazání ceny služby kalkulačky",
  "text3047": "Vytvoření doplňkové informace kalkulačky",
  "text3048": "Upravení doplňkové informace kalkulačky",
  "text3049": "Vymazání doplňkové informace kalkulačky",
  "text3050": "Vytvoření hodnoty doplňkové informace kalkulačky",
  "text3051": "Upravení hodnoty doplňkové informace kalkulačky",
  "text3052": "Vymazání hodnoty doplňkové informace kalkulačky",
  "text3053": "Vytvoření ceny hodnoty doplňkové informace kalkulačky",
  "text3054": "Upravení ceny hodnoty doplňkové informace kalkulačky",
  "text3055": "Vymazání ceny hodnoty doplňkové informace kalkulačky",
  "text3056": "Vytvoření produktu kalkulačky",
  "text3057": "Upravení produktu kalkulačky",
  "text3058": "Vymazání produktu kalkulačky",
  "text3059": "Vytvoření ceny produktu kalkulačky",
  "text3060": "Upravení ceny produktu kalkulačky",
  "text3061": "Vymazání ceny produktu kalkulačky",
  "text3062": "Vytvoření objednávky kalkulačky",
  "text3063": "Upravení objednávky kalkulačky",
  "text3064": "Vymazání objednávky kalkulačky",
  "text3065": "Vytvoření hodnoty objednávky kalkulačky",
  "text3066": "Upravení hodnoty objednávky kalkulačky",
  "text3067": "Vymazání hodnoty objednávky kalkulačky",
  "text3068": "Vytvoření služby objednávky kalkulačky",
  "text3069": "Upravení služby objednávky kalkulačky",
  "text3070": "Vymazání služby objednávky kalkulačky",
  "text3071": "Upravení konfigurace cestovní kanceláře",
  "text3072": "Upravení konfigurace newsletteru",
  "text3073": "Upravení konfigurace hromadného mailu",
  "text3074": "Upravení konfigurace věrnostního programu",
  "text3075": "Upravení konfigurace opuštěných nákupních košíků",
  "text3076": "Upravení konfigurace SEO",
  "text3077": "Vytvoření stavu e-receptu",
  "text3078": "Upravení stavu e-receptu",
  "text3079": "Vymazání stavu e-receptu",
  "text3080": "Vytvoření e-receptu",
  "text3081": "Upravení e-receptu",
  "text3082": "Vymazání e-receptu",
  "text3083": "Vytvoření stavu rezervace léků",
  "text3084": "Upravení stavu rezervace léků",
  "text3085": "Vymazání stavu rezervace léků",
  "text3086": "Vytvoření produktu rezervace léků",
  "text3087": "Upravení produktu rezervace léků",
  "text3088": "Vymazání produktu rezervace léků",
  "text3089": "Vytvoření rezervace léků",
  "text3090": "Upravení rezervace léků",
  "text3091": "Vymazání rezervace léků",
  "text3092": "Vytvoření služby rezervace",
  "text3093": "Upravení služby rezervace",
  "text3094": "Vymazání služby rezervace",
  "text3095": "Vytvoření ceny služby rezervace",
  "text3096": "Upravení ceny služby rezervace",
  "text3097": "Vymazání ceny služby rezervace",
  "text3098": "Vytvoření automatického rozvrhu rezervace",
  "text3099": "Upravení automatického rozvrhu rezervace",
  "text3100": "Vymazání automatického rozvrhu rezervace",
  "text3101": "Vytvoření času rezervace",
  "text3102": "Upravení času rezervace",
  "text3103": "Vymazání času rezervace",
  "text3104": "Vytvoření osoby rezervace",
  "text3105": "Upravení osoby rezervace",
  "text3106": "Vymazání osoby rezervace",
  "text3107": "Vytvoření rezervace",
  "text3108": "Upravení rezervace",
  "text3109": "Vymazání rezervace",
  "text3110": "Upravení konfigurace obecných nastavení",
  "text3111": "Přihlášení proběhlo úspěšně",
  "text3112": "Váš účet byl úspěšně propojen.",
  "text3113": "Teď můžete toto okno bezpečně zavřít — výsledek byl odeslán do aplikace.",
  "text3114": "Zavřít okno",
  "text3115": "Zavřete toto okno ručně.",
  "text3116": "Sledujte nás na Instagramu",
  "text3117": "Odkaz byl úspěšně zkopírován do schránky",
  "text3118": "Předplatné vyprší",
  "text3119": "Změny v profilu byly úspěšně uloženy",
  "text3120": "Profil byl úspěšně vytvořen",
  "text3121": "Připravujeme",
  "text3122": "Nemáte aktivní předplatné",
  "text3123": "Zakupte si předplatné na 1 rok a získejte neomezený přístup ke všem online kurzům a slevu ve výši 10% na eventy!",
  "text3124": "Zakoupit předplatné",
  "text3125": "Moje produkty",
  "text3126": "Předsednictvo sdružení SEDMA",
  "text3127": "Předplatné již máte zakoupeno.",
  "text3128": "Přejít na kurzy",
  "text3129": "Dokumenty k objednávce naleznete ve svém profilu",
  "text3130": "Tento produkt na našem eshopu nemáme k dispozici",
  "text3131": "Vyhledávám informace o produktu...",
  "text3132": "Tento produkt na našem eshopu nemáme k dispozici",
  "text3133": "Vytvoření dárku kategorie",
  "text3134": "Upravení dárku kategorie",
  "text3135": "Vymazání dárku kategorie",
  "text3136": "Dárek byl již přiřazen",
  "text3137": "Dárek není povolen pro tento produkt",
  "text3138": "Zakupte si kurzy v našich eventech.",
  "text3139": "Potvrzovací e-mail byl úspěšně odeslán",
  "text3140": "Odkaz na obnovení hesla je neplatný",
  "text3141": "Vyhledávat v polích",
  "text3142": "Exaktní vyhledávání",
  "text3143": "Objednávka byla zrušena",
  "text3144": "Platební příkaz byl zrušen a nebyl proveden.",
  "text3145": "Byli jste odhlášen",
  "text3146": "Na váš účet se někdo přihlásil z jiného zařízení.",
  "text3147": "Upravení konfigurace poradny",
  "text3148": "Vytvoření naskladnění",
  "text3149": "Upravení naskladnění",
  "text3150": "Vymazání naskladnění",
  "text3151": "Vytvoření položky naskladnění",
  "text3152": "Upravení položky naskladnění",
  "text3153": "Vymazání položky naskladnění",
  "text3154": "Soubor již byl v minulosti zpracován",
  "text3155": "Vytvoření nákupu dne",
  "text3156": "Upravení nákupu dne",
  "text3157": "Vymazání nákupu dne",
  "text3158": "Vytvoření položky nákupu dne",
  "text3159": "Upravení položky nákupu dne",
  "text3160": "Vymazání položky nákupu dne",
  "text3161": "Zobrazit vše",
  "text3162": "Vytvoření slevy položky nákupu dne",
  "text3163": "Upravení slevy položky nákupu dne",
  "text3164": "Vymazání slevy položky nákupu dne",
  "text3165": "Vytvoření skupiny produktů",
  "text3166": "Upravení skupiny produktů",
  "text3167": "Vymazání skupiny produktů",
  "text3168": "Vytvoření slevy skupiny produktů",
  "text3169": "Upravení slevy skupiny produktů",
  "text3170": "Vymazání slevy skupiny produktů",
  "text3171": "Dárek byl přidán k objednávce",
  "text3172": "Dárek již byl přidán k objednávce",
  "text3173": "Vytvoření dopravy kategorie",
  "text3174": "Upravení dopravy kategorie",
  "text3175": "Vymazání dopravy kategorie",
  "text3176": "Vytvoření ceny dopravy kategorie",
  "text3177": "Upravení ceny dopravy kategorie",
  "text3178": "Vymazání ceny dopravy kategorie",
  "text3179": "Jméno / Název společnosti",
  "text3180": "Parametry produktu",
  "text3181": "Zadejte prosím svou e-mailovou adresu a my Vám odešleme odkaz na obnovení hesla.",
  "text3182": "Vytvoření účtu",
  "text3183": "Heslo znovu",
  "text3184": "Orientační číslo",
  "text3185": "Zpět na přihlášení",
  "text3186": "Produkty ve slevě",
  "text3187": "Celý výprodej",
  "text3188": "Nákup dne",
  "text3189": "minuta",
  "text3190": "hodina",
  "text3191": "hodiny",
  "text3192": "hodin",
  "text3193": "sekunda",
  "text3194": "sekundy",
  "text3195": "sekund",
  "text3196": "Akce vyprší o",
  "text3197": "minuty",
  "text3198": "Koupit tento produkt",
  "text3199": "Odebírejte pro novinky a slevy.",
  "text3200": "Newsletter jste začali úspěšně odebírat",
  "text3201": "Jste přihlášen. Všechny Vaše objednávky umíte najít ve svém profilu.",
  "text3202": "Stáhnout ceník",
  "text3203": "Pošlete nám fax",
  "text3204": "Oprava",
  "text3205": "Bankovní spojení (EUR)",
  "text3206": "Naši distributoři",
  "text3207": "spokojených zákazníků",
  "text3208": "Váš účet byl úspěšně vytvořen",
  "text3209": "Načíst více článků",
  "text3210": "Potřebujete poradit? Neváhejte nás kontaktovat ať už přes kontaktní formulář nebo přímo telefonicky a emailem.",
  "text3211": "Spojte se s námi, rádi vám poradíme",
  "text3212": "Fakturační a dodací údaje",
  "text3213": "Vytvoření ceny dopravy produktu",
  "text3214": "Upravení ceny dopravy produktu",
  "text3215": "Vymazání ceny dopravy produktu",
  "text3216": "Zadaný kupón neexistuje",
  "text3217": "Mám slevový kupón",
  "text3218": "Děkujeme za Vaši objednávku číslo",
  "text3219": "Potvrzení objednávky jsme Vám zaslali na Vámi zadanou e-mailovou adresu.",
  "text3220": "Nebyly nalezeny žádné produkty",
  "text3221": "Zajímavé články",
  "text3222": "Odebírané",
  "text3223": "Zrušit odběr",
  "text3224": "Opravdu si přejete zrušit odebírání newsletteru?",
  "text3225": "Odebírání newsletteru bylo zrušeno",
  "text3226": "Zrušit odběr newsletteru",
  "text3227": "Ke každé objednávce",
  "text3228": "V ceně",
  "text3229": "Objednávka od",
  "text3230": "Ke každé objednávce",
  "text3231": "Co říkají naši spokojení zákazníci?",
  "text3232": "Expirována",
  "text3233": "Pro vstup do členské zóny musíte být",
  "text3234": "přihlášen",
  "text3235": "V případě, že nejste zaregistrováni, klikněte na odkaz",
  "text3236": "Registrace.",
  "text3237": "Zapomenuté heslo? ",
  "text3238": "Prohlížet kategorii",
  "text3239": "Akční produkty",
  "text3240": "Aktuální nabídka zájezdů",
  "text3241": "Menu",
  "text3242": "Produkt byl přidán do košíku",
  "text3243": "Vytvoření dodavatele varianty",
  "text3244": "Upravení dodavatele varianty",
  "text3245": "Vymazání dodavatele varianty",
  "text3246": "Vytvoření ceny dodavatele varianty",
  "text3247": "Upravení ceny dodavatele varianty",
  "text3248": "Vymazání ceny dodavatele varianty",
  "text3249": "Kupón je neplatný",
  "text3250": "Informace o možnostech vrácení a reklamace zboží najde na stránce",
  "text3251": "Vrácení a reklamace",
  "text3252": "Provozní doba zákaznické linky",
  "text3253": "Po-pá: 8:30 - 17:00",
  "text3254": "Více než",
  "text3255": "Zobrazit všechny služby",
  "text3256": "Skrýt",
  "text3257": "Dárky k produktu",
  "text3258": "Dárek k nákupu",
  "text3259": "Vypočítat splátky",
  "text3260": "ověřených recenzí",
  "text3261": "Důvod kontaktování",
  "text3262": "Neplatná autentifikace. Zkuste to prosím znovu",
  "text3263": "Telefonní číslo je povinné",
  "text3264": "Přihlášením k odběru souhlasíte se",
  "text3265": "Akce",
  "text3266": "Rychlé doručení",
  "text3267": "Rychlé a bezpečné doručení zdarma pro objednávky nad 100 €.",
  "text3268": "Možnosti doručení",
  "text3269": "30 dní na vrácení",
  "text3270": "Nejste spokojeni s produktem? Máte 30 dní na vrácení zboží a vrácení peněz.",
  "text3271": "Možnosti platby",
  "text3272": "Klient",
  "text3273": "Sazba klienta",
  "text3274": "Zbývá hodin",
  "text3275": "Stav předplatného",
  "text3276": "Předplatné je aktivováno",
  "text3277": "Předplatné není aktivováno",
  "text3278": "Vyprší",
  "text3279": "Fakturační email",
  "text3280": "Odpovědný vedoucí (jednatel)",
  "text3281": "Navigovat na adresu",
  "text3282": "Bankovní spojení",
  "text3283": "Reklamace č.:",
  "text3284": "Datum reklamace",
  "text3285": "Datum koupě",
  "text3286": "Podpis zákazníka",
  "text3287": "Podpis prodejce",
  "text3288": "dne",
  "text3289": "Podrobný popis závady a stav zboží",
  "text3290": "Dodané příslušenství",
  "text3291": "Předmět reklamace",
  "text3292": "Doklad o koupi",
  "text3293": "Původní obal",
  "text3294": "Vyřízení reklamace č.:",
  "text3295": "Datum ukončení",
  "text3296": "Bližší specifikace provedené opravy",
  "text3297": "Vytvoření záznamu o nehodě",
  "text3298": "Upravení záznamu o nehodě",
  "text3299": "Vymazání záznamu o nehodě",
  "text3300": "Provozní doba zákaznické linky",
  "text3301": "Google Recenze",
  "text3302": "Přihlaste se k odběru novinek",
  "text3303": "Buďte informováni o našich sleva a akcích včas.",
  "text3304": "Hledat zájezd",
  "text3305": "Vyhledat zájezd",
  "text3306": "Zobrazit všechny zájezdy",
  "text3307": "Mám zájem o zájezd na míru",
  "text3308": "Co pro vás můžeme zajistit",
  "text3309": "Destinace",
  "text3310": "Kolik by Vás chtělo vycestovat",
  "text3311": "Jaký termín by Vám nejvíce vyhovoval",
  "text3312": "Preferovaný termín",
  "text3313": "Váš zájem o zájezd na míru byl úspěšně odeslán",
  "text3314": "Funkcionalitu aktuálně nepodporujeme",
  "text3315": "Soubory nebyly nalezeny",
  "text3316": "Katalog produktů",
  "text3317": "Hodnotilo",
  "text3318": "více než 1000 klientů",
  "text3319": "Přejít do e-shopu",
  "text3320": "Stáhnout e-book zdarma",
  "text3321": "Upravení konfigurace dárků",
  "text3322": "Napište nám e-mail",
  "text3323": "Naše zajímavé články",
  "text3324": "Ještě nejste zaregistrováni?",
  "text3325": "Tady je, o co přicházíte:",
  "text3326": "Zaregistrovat se",
  "text3327": "Dokumenty ZDARMA",
  "text3328": "Placené dokumenty",
  "text3329": "Nenašli jste odpověď na otázku? Spojte se s námi přímo prostřednictvím kontaktu.",
  "text3330": "Evidence nemocí z povolání, nebezpečných událostí, pracovních úrazů",
  "text3331": "Zákony a zákoníky o zdraví a bezpečnosti",
  "text3332": "První pomoc při život ohrožujících stavech",
  "text3333": "Traumatologický plán",
  "text3334": "Protokoly, kontroly a hlášení",
  "text3335": "Směrnice a zákony",
  "text3336": "Lhůty technického zařízení",
  "text3337": "Protokol o školení zaměstnanců",
  "text3338": "Vzory dokumentů",
  "text3339": "Kontrola a postupy",
  "text3340": "Osvědčení",
  "text3341": "Upravení konfigurace marketingu",
  "text3342": "Vytvoření kategorie rezervace",
  "text3343": "Upravení kategorie rezervace",
  "text3344": "Vymazání kategorie rezervace",
  "text3345": "Máte účet? Přihlaste se a údaje vyplníme za vás.",
  "text3346": "Jste úspěšně přihlášen",
  "text3347": "Součástí členství máte tyto výhody",
  "text3348": "Použít kupón",
  "text3349": "Kompletní ochrana",
  "text3350": "toho, na čem Vám nejvíc záleží",
  "text3351": "Vyplňte formulář a my se vám ozveme.",
  "text3352": "Vaše zpráva / zájem",
  "text3353": "Odesláním zprávy souhlasíte se",
  "text3354": "pro účely kontaktování.",
  "text3355": "Pokračujte ve čtení",
  "text3356": "Reklamace",
  "text3357": "Odstoupení od smlouvy",
  "text3358": "Odstoupení od smlouvy a reklamace zboží",
  "text3359": "zobrazit vše",
  "text3360": "min čtení",
  "text3361": "Nenašli jste odpověď na vaši otázku? Kontaktujte nás telefonicky nebo emailem a rádi vám odpovíme.",
  "text3362": "Zjistit více o Sonicube",
  "text3363": "Stát se partnerem",
  "text3364": "Upravení konfigurace upomínek",
  "text3365": "Upravení konfigurace plánování upomínek",
  "text3366": "Vytvoření upomínky",
  "text3367": "Upravení upomínky",
  "text3368": "Vymazání upomínky",
  "text3369": "Přihlášením k odběru novinek souhlasíte se",
  "text3370": "pro účely marketingu a zasílání novinek.",
  "text3371": "Vyplňte formulář a my se vám ozveme\ndo 24 hodin.",
  "text3372": "Počet dní po splatnosti",
  "text3373": "Datum přidělení na vymáhání",
  "text3374": "Dárek k produktu",
  "text3375": "Potřebujete informace o produktech nebo vaší objednávce?",
  "text3376": "Poznámka již byla odeslána zákazníkovi",
  "text3377": "Vyhledejte",
  "text3378": "Více fotografií",
  "text3379": "Operace selhala",
  "text3380": "Způsob doručení",
  "text3381": "Popis závady",
  "text3382": "Váš účet byl úspěšně vytvořen",
  "text3383": "Na zadanou e-mailovou adresu jsme vám zaslali",
  "text3384": "Resetovat filtr",
  "text3385": "Objednávka byla úspěšně odeslána",
  "text3386": "Vaši objednávku jsme úspěšně zaevidovali. Potvrzení obdržíte na vaši e-mailovou adresu zadanou při objednávce.",
  "text3387": "Přihlas se k odběru a dostávaj tipy, jak podpořit regeneraci a zdraví.",
  "text3388": "Reklamace",
  "text3389": "pro účely marketingu.",
  "text3390": "Firemní zákazník",
  "text3391": "Číst článek",
  "text3392": "Mám otázku",
  "text3393": "EAN produktu",
  "text3394": "Vytvoření typu skupin produktů",
  "text3395": "Upravení typu skupin produktů",
  "text3396": "Vymazání typu skupin produktů",
  "text3397": "Přidat recenzi",
  "text3398": "Daňová povinnost",
  "text3399": "Hodnocení produktu",
  "text3400": "Ohodnoťte tento produkt",
  "text3401": "Registrace proběhla úspěšně",
  "text3402": "Na zadanou e-mailovou adresu jsme vám zaslali ověřovací e-mail.",
  "text3403": "Textový popis",
  "text3404": "pro účely zpracování hodnocení produktu.",
  "text3405": "Váš kód",
  "text3406": "Na úhradu",
  "text3407": "Zpět na doprava a platba",
  "text3408": "Objednávka s povinností platby",
  "text3409": "Super! Objednávka je na cestě",
  "text3410": "Děkujeme, že jste si vybrali právě nás.",
  "text3411": "Potvrzení objednávky naleznete ve svém e-mailu ao jejím stavu vás budeme průběžně informovat",
  "text3412": "Máte u nás účet?",
  "text3413": "Přihlaste se a údaje vyplníme za vás.",
  "text3414": "Objednávka",
  "text3415": "Aktuální heslo",
  "text3416": "Na zadanou e-mailovou adresu jsme vám zaslali potvrzení o změně hesla.",
  "text3417": "Vyhledat produkt",
  "text3418": "Certifikáty",
  "text3419": "Moje projekty",
  "text3420": "Žádná SMS integrace není aktivní",
  "text3421": "Chyba při validaci SMS limitů",
  "text3422": "Nepodařilo se ověřit stav SMS kreditu. Zkontrolujte konfiguraci",
  "text3423": "Nedostatek SMS kreditu",
  "text3424": "Souhrn odeslaných upomínek",
  "text3425": "byly odeslány následující upomínky zákazníkům",
  "text3426": "Extrakce dokumentu byla spuštěna. Po dokončení budete oznámeni",
  "text3427": "Dohodni si konzultaci",
  "text3428": "I s tímto Vám umíme pomoci",
  "text3429": "Pro studenty",
  "text3430": "nabídka",
  "text3431": "Naleznete nás",
  "text3432": "Nabídka byla přidána do oblíbených",
  "text3433": "Upravení konfigurace dokumentů",
  "text3434": "Počet nabídek",
  "text3435": "Další nabídky",
  "text3436": "Nabídka byla upravena",
  "text3437": "Nabídka byla vytvořena",
  "text3438": "Pomoc při objednávce",
  "text3439": "Zobrazit všechny",
  "text3440": "otevřených pozic",
  "text3441": "Pozice",
  "text3442": "Objednávka již byla uhrazena",
  "text3443": "Faktura je zároveň i dodacím listem.",
  "text3444": "produktů",
  "text3445": "Vygenerováno pomocí AI",
  "text3446": "měsíčně",
  "text3447": "Zobrazit kompletní životopis",
  "text3448": "Proč označit AI obrázek?",
  "text3449": "Zaškrtnutím potvrzujete, že obrázek byl vytvořen umělou inteligencí.\n        Pomáháte nám tak dodržovat zákon o AI a zvyšovat transparentnost pro uchazeče.",
  "text3450": "Zodpovědnost za správné označení AI generovaného obsahu nese inzerent.",
  "text3451": "Neoznačený AI obsah může být moderátorem dodatečně upraven nebo odstraněn.",
  "text3452": "Nenašli jste odpověď na otázku?",
  "text3453": "Kontaktujte nás a my vám co nejdříve odpovíme.",
  "text3454": "Rok narození",
  "text3455": "Údaj o roce narození slouží výhradně k ověření zletilosti uživatele a zajištění souladu s právními požadavky. Tento údaj se nepoužívá pro jiné účely",
  "text3456": "Vybrat soubory",
  "text3457": "Maximální počet souborů je",
  "text3458": "Maximální velikost souboru je 2MB",
  "text3459": "Chyba při nahrávání souboru",
  "text3460": "Způsoby platby",
  "text3461": "Formy doručení",
  "text3462": "Nezmeškejte žádné novinky a aktuální výprodej!",
  "text3463": "Odebírejte novinky přihlášením do našeho newsletteru",
  "text3464": "Váš e-mail",
  "text3465": "Počet hodnocení",
  "text3466": "Tento produkt nemá žádné recenze.",
  "text3467": "Doručovací údaje",
  "text3468": "Vyplňte e-mail pro zaslání linku pro obnovení hesla.",
  "text3469": "Naše články",
  "text3470": "Výprodej",
  "text3471": "Nemáte přístup k životopisům",
  "text3472": "Tato sekce je dostupná pro firemní účty s předplaceným přístupem k životopisům.",
  "text3473": "Zobrazit ceník",
  "text3474": "Přístup k životopisům je dostupný pouze pro firemní účty.",
  "text3475": "Celá kategorie",
  "text3476": "Skrýt telefon",
  "text3477": "Seznam pozic",
  "text3478": "Zvolená sekvence není použitelná pro typ dokumentu",
  "text3479": "Otevřít košík",
  "text3480": "Množstevní slevy",
  "text3481": "Zakoupit přístup k životopisům",
  "text3482": "Přístup k životopisům",
  "text3483": "Pro firmy",
  "text3484": "Zveřejnění pracovní nabídky",
  "text3485": "Topování nabídky",
  "text3486": "Časově omezená nabídka",
  "text3487": "Kupon vyprší o",
  "text3488": "Přihlaste se k odběru novinek a získejte slevu!",
  "text3489": "Novinky, aktuální trendy a akce přímo do e-mailu. Součástí odběru je slevový kupón. Odhlášení kdykoli zdarma.",
  "text3490": "Ne, děkuji, nechci slevu",
  "text3491": "Získejte kupón",
  "text3492": "Při objednávce nad",
  "text3493": "Pro všechny objednávky",
  "text3494": "Kupon byl zaslán na váš e-mail",
  "text3495": "Získat kupón",
  "text3496": "Získejte informace o nových produktech a slevách mezi prvními.",
  "text3497": "Doručení",
  "text3498": "Objevit koncept",
  "text3499": "Staňte se partnerem",
  "text3500": "Zjistit možnosti spolupráce",
  "text3501": "bodů",
  "text3502": "Počet bodů získaných za 1 Kč nákupu",
  "text3503": "Hodnota jednoho bodu",
  "text3504": "Maximální zlevnění v procentech na objednávku",
  "text3505": "Chcete-li využít věrnostní program, přihlaste se",
  "text3506": "Uplatnit všechny body",
  "text3507": "Věrnostní body byly aplikovány",
  "text3508": "Uplatnit",
  "text3509": "Přihlašovací e-mail",
  "text3510": "Žádné přílohy",
  "text3511": "hodnocení",
  "text3512": "hodnocení",
  "text3513": "hodnocení",
  "text3514": "Zvolit hodnocení",
  "text3515": "Zjistěte více zde",
  "text3516": "Zobrazit všechny parametry",
  "text3517": "Zbývající odemknutí",
  "text3518": "Všechny údaje budou dostupné po odemknutí životopisu.",
  "text3519": "Uzamčený profil",
  "text3520": "Profil kandidáta",
  "text3521": "Vyberte 1 až 3 kategorie/pozice",
  "text3522": "Zobrazit všechny blogy",
  "text3523": "Nezávazná cenová nabídka",
  "text3524": "Hlavní banner",
  "text3525": "Předešlí snímek",
  "text3526": "Další snímek",
  "text3527": "Otevřít popup",
  "text3528": "Zobrazit na mapě referenci",
  "text3529": "Předchozí stránka",
  "text3530": "Další stránka",
  "text3531": "Jít na stránku",
  "text3532": "Jít na snímek",
  "text3533": "Předchozí náhledy",
  "text3534": "Zobrazit více obrázků",
  "text3535": "Další náhledy",
  "text3536": "Požádat o partnerskou konzultaci",
  "text3537": "Toto označení mohou naši partneři využívat",
  "text3538": "Vytvoření FAQ",
  "text3539": "Upravení FAQ",
  "text3540": "Vymazání FAQ",
  "text3541": "Vytvoření Schema.org",
  "text3542": "Upravení Schema.org",
  "text3543": "Vymazání Schema.org",
  "text3544": "Vyplňte formulář a domluvte si úvodní partnerskou konzultaci.",
  "text3545": "Vytvoření hlídacího psa",
  "text3546": "Upravení hlídacího psa",
  "text3547": "Vymazání hlídacího psa",
  "text3548": "HASQO balíček",
  "text3549": "Více informací",
  "text3550": "Balíček",
  "text3551": "Balíček obsahuje",
  "text3552": "Vhodné pro",
  "text3553": "Konzultace",
  "text3554": "Název provozu",
  "text3555": "Město provozu",
  "text3556": "Typ provozu",
  "text3557": "Velikost (m²)",
  "text3558": "Planovaný čas",
  "text3559": "Tel. číslo",
  "text3560": "Vaše údaje",
  "text3561": "Životopis je zamčený",
  "text3562": "Životopis je dostupný až po zakoupení. Po odemčení se zobrazí plný profil uchazeče.",
  "text3563": "Hlídací pes",
  "text3564": "Hlídací pes byl úspěšně vytvořen",
  "text3565": "Dáme Vám vědět, až bude tento produkt opět dostupný",
  "text3566": "Nepodařilo se vytvořit hlídacího psa",
  "text3567": "Zadejte svůj e-mail a obdržíte upozornění, až bude tento produkt opět dostupný",
  "text3568": "Strážní psi",
  "text3569": "Hlídací pes byl odstraněn",
  "text3570": "Nepodařilo se odstranit hlídacího psa",
  "text3571": "Nemáte nastaveno žádné hlídací psy",
  "text3572": "Volná topování",
  "text3573": "Quatro kalkulačka",
  "text3574": "Vyberte výdejní místo GLS",
  "text3575": "Popis projektu",
  "text3576": "O jakou realizaci máte zájem?",
  "text3577": "Vyberte",
  "text3578": "Lokalita realizace",
  "text3579": "Vyplňte adresu",
  "text3580": "Orientační datum realizace",
  "text3581": "Jméno / Společnost",
  "text3582": "Vyplňte jméno / název společnosti",
  "text3583": "Vyplňte email",
  "text3584": "Vyplňte telefon",
  "text3585": "Vaše poznámka",
  "text3586": "Poznámka",
  "text3587": "Odesláním souhlasíte se",
  "text3588": "Poznejte naše služby",
  "text3589": "Zobrazit více realizací",
  "text3590": "Máte další otázky?",
  "text3591": "Máte ještě jinou otázku nebo jste nenašli svou odpověď?",
  "text3592": "Pracovní doba",
  "text3593": "Výroba na míru",
  "text3594": "Kvalitní materiály",
  "text3595": "Detail provedení",
  "text3596": "Proces realizace",
  "text3597": "k odběru novinek",
  "text3598": "Získejte nejnovější informace společnosti KAUFMANN.",
  "text3599": "Váš email",
  "text3600": "Odběrem novinek souhlasíte se",
  "text3601": "Ukázat na mapě",
  "text3602": "nebo",
  "text3603": "Naši pracovníci jsou vám k dispozici v",
  "text3604": "pracovní dny od 8:00 do 16:00",
  "text3605": "Sklad",
  "text3606": "Načíst více realizaci",
  "text3607": "V této kategorii jsme nenašli žádné výsledky",
  "text3608": "Vytvoření nejprodávanějšího produktu",
  "text3609": "Upravení nejprodávanějšího produktu",
  "text3610": "Vymazání nejprodávanějšího produktu",
  "text3611": "Nahlásit",
  "text3612": "Důvod nahlášení",
  "text3613": "Maturita",
  "text3614": "nocí",
  "text3615": "Termín zajezdu",
  "text3616": "Délka zájezdu",
  "text3617": "Cena od",
  "text3618": "Na vyžádání",
  "text3619": "Zobrazit detail zájezdu",
  "text3620": "Volná místa",
  "text3621": "Aktualizuji termíny",
  "text3622": "Všechny zájezdy jsou skryty",
  "text3623": "Pro vybrané období nejsou dostupné žádné zájezdy",
  "text3624": "Zmenšit",
  "text3625": "Na celou obrazovku",
  "text3626": "Termíny se nepodařilo načíst",
  "text3627": "podkategorií",
  "text3628": "Odstranit výběr",
  "text3629": "Nahlášení nabídky",
  "text3630": "Nahlášení firmy",
  "text3631": "Nahlášení životopisu",
  "text3632": "Nahlášení se nepodařilo odeslat",
  "text3633": "Nahlášení bylo odesláno",
  "text3634": "životopisů",
  "text3635": "životopisy",
  "text3636": "Objednávka v procesu",
  "text3637": "Domů",
  "text3638": "Vytvoření platby objednávky",
  "text3639": "Upravení platby objednávky",
  "text3640": "Vymazání platby objednávky",
  "text3641": "Staňte se naším jedinečným partnerem.",
  "text3642": "Přihlaste se k odběru novinek a informací o\npřidaných nových vlastnostech.",
  "text3643": "Nové nemovitosti",
  "text3644": "Nemovitosti za špičkovou cenu",
  "text3645": "Reference spokojených klientů",
  "text3646": "Podívejte se, co si o nás myslí naši klienti.",
  "text3647": "Přečtěte si články o atrakcích na Kypru",
  "text3648": "Všechny fotografie",
  "text3649": "Sdílet",
  "text3650": "Datum dokončení",
  "text3651": "Popis nemovitosti",
  "text3652": "Prohlídka resortu",
  "text3653": "Vygenerovat PDF",
  "text3654": "Rezervace prohlídky",
  "text3655": "Výběr termínu online konzultace",
  "text3656": "Nemovitosti na severním Kypru",
  "text3657": "Počet pokojů",
  "text3658": "Realitní kancelář",
  "text3659": "Nemovitosti",
  "text3660": "Resale / Placená interce",
  "text3661": "Objednejte se ke konzultaci",
  "text3662": "Zoom hovor trvá maximálně 1 hodinu a my vám odpovíme na všechny vaše dotazy + získáte\n              bezplatnou prezentaci všech dostupných projektů, které na Kypru máme.",
  "text3663": "Nabídky",
  "text3664": "Máte další otázky? Rádi vám představíme koncept HASQO v praxi.",
  "text3665": "Požádat o konzultaci",
  "text3666": "Zákaznická zóna",
  "text3667": "Zásilka",
  "text3668": "Úspěšnost doručení",
  "text3669": "Zákaznická linka",
  "text3670": "Chci získat cenovou nabídku",
  "text3671": "Přihlášením do newsletteru souhlasíte se",
  "text3672": "Vyberte z novinek",
  "text3673": "Nakupujte podle kategorie",
  "text3674": "TOP výběr produktů",
  "text3675": "Přihlaste se k odběru novinek a dostávejte vždy aktuální informace o akcích a novinkách.",
  "text3676": "Vaše e-mailová adresa...",
  "text3677": "Záruka bezpečného nákupu",
  "text3678": "Způsoby dopravy",
  "text3679": "Naše realizace",
  "text3680": "Kolekce",
  "text3681": "Zobrazit všechny kolekce",
  "text3682": "Důvěřují nám",
  "text3683": "Ověřeno a získáno prostřednictvím Google",
  "text3684": "Všechny recenze",
  "text3685": "Ověřeno",
  "text3686": "Všechny filtry",
  "text3687": "Žádné produkty nebyly nalezeny",
  "text3688": "Hloubka",
  "text3689": "Získejte cenovou nabídku pro vaši přepravu",
  "text3690": "Web vytvořili",
  "text3691": "od 9:00 do 17:00",
  "text3692": "O službě",
  "text3693": "Co služba zahrnuje?",
  "text3694": "Pro jaké zásilky je služba vhodná?",
  "text3695": "Jak to probíhá?",
  "text3696": "Prohlédněte si další službu",
  "text3697": "Co říkají naši spokojení klienti",
  "text3698": "Registrační e-mail",
  "text3699": "Vyplňte formulář a získejte nabídku",
  "text3700": "Vyhledejte zásilku",
  "text3701": "Napište nám zprávu",
  "text3702": "Získat nabídku",
  "text3703": "Ukončit",
  "text3704": "Věrnostní systém",
  "text3705": "Adresa doručení je stejná jako fakturační",
  "text3706": "Jméno kontaktní osoby",
  "text3707": "Příjmení kontaktní osoby",
  "text3708": "E-mailovou adresu nelze změnit, kontaktuje prosím naši podporu.",
  "text3709": "Rady, trendy a praktické články",
  "text3710": "Další články které by vás mohly zajímat",
  "text3711": "Provozovatel",
  "text3712": "Potřebujete poradit?\nOzvěte se nám a rádi vám pomůžeme.",
  "text3713": "Kontaktujte naši zákaznickou podporu nebo nám napište prostřednictvím kontaktního formuláře a naši pracovníci vám poradí.",
  "text3714": "Váš požadavek",
  "text3715": "Odeslat žádost o změnu hesla",
  "text3716": "Položky v objednávce",
  "text3717": "Částka objednávky",
  "text3718": "byla zaznamenána. Čekáme na úhradu, a po jejím připsání na náš účet následně dáme na realizaci. Prosím zkontrolujte si Váš email",
  "text3719": "Viz volné pozice",
  "text3720": "Nejnovější nabídka",
  "text3721": "Staňte se součástí našeho týmu",
  "text3722": "Vyplňte formulář a pošlete nám životopis. Pokud nás váš profil zaujme a bude splňovat vaše požadavky, ozveme se vám.",
  "text3723": "Pošlete nám životopis",
  "text3724": "Místo naložení",
  "text3725": "Cílová destinace",
  "text3726": "Typ zboží",
  "text3727": "Váha (cca)",
  "text3728": "Objem (m3)",
  "text3729": "Ukázat trasu",
  "text3730": "Dokončit objednávku",
  "text3731": "Varianta",
  "text3732": "Vložte slevový kód",
  "text3733": "Použít body",
  "text3734": "Počet bodů (vložte celé číslo)",
  "text3735": "Upozornění: Dodatečná změna odběratele na faktuře není možná.",
  "text3736": "Chci nakoupit na firmu",
  "text3737": "Doručovací adresa je jiná než fakturační",
  "text3738": "Fakturační a doručovací údaje",
  "text3739": "Vaše objednávka byla odeslána",
  "text3740": "Vaši objednávku jsme zaevidovali pod číslem",
  "text3741": "potvrzení objednávky vám doručíme na zadanou e-mailovou adresu při vytváření objednávky.",
  "text3742": "Zpět na hlavní stránku",
  "text3743": "Vyhledané produkty",
  "text3744": "položek",
  "text3745": "Zobrazit všechny vyhledané",
  "text3746": "Srovnání produktů",
  "text3747": "Žádné produkty k porovnání. Přidejte produkty kliknutím na ikonu srovnání.",
  "text3748": "Hmotnost",
  "text3749": "Barevné varianty",
  "text3750": "Váš účet byl úspěšně vytvořen",
  "text3751": "Registrace zde",
  "text3752": "1 kurz = 5 tréninků",
  "text3753": "Přihlášením k odběru novinek souhlasíte se",
  "text3754": "Přečtěte si naše praktické články nebo se inspirujte trendy s teakovým nábytkem.",
  "text3755": "Prohlížet nabídku",
  "text3756": "Akční produkty",
  "text3757": "Vytvoření typu nákladu",
  "text3758": "Upravení typu nákladu",
  "text3759": "Vymazání typu nákladu",
  "text3760": "Vytvoření nákladu",
  "text3761": "Upravení nákladu",
  "text3762": "Vymazání nákladu",
  "text3763": "Vytvoření platby rezervace",
  "text3764": "Upravení platby rezervace",
  "text3765": "Vymazání platby rezervace",
  "text3766": "O ubytování",
  "text3767": "Vaše údaje jsou zabezpečeny",
  "text3768": "Připojte se k více než",
  "text3769": "spokojeným klientům",
  "text3770": "Ověřeno a získáno prostřednictvím Google",
  "text3771": "Otevírací hodiny showroomu",
  "text3772": "Zakoupením tohoto produktu získáte.",
  "text3773": "bodů",
  "text3774": "Na účtu máte",
  "text3775": "Popište produkt",
  "text3776": "(+) Pozitivum",
  "text3777": "(-) Negativum",
  "text3778": "Přidat pozitivum",
  "text3779": "Přidat negativum",
  "text3780": "Nadřazená položka nemůže být tato položka ani její podřazená položka.",
  "text3781": "IČ DPH je neplatné",
  "text3782": "Zadané DIČ je neplatné",
  "text3783": "Máte {{param}} bodů",
  "text3784": "Rezervační systém",
  "text3785": "Uplatnit můžete maximálně.",
  "text3786": "Uplatněné body",
  "text3787": "Pronájem studia",
  "text3788": "Počet bodů",
  "text3789": "Prodej skončil",
  "text3790": "Tento produkt zatím připravujeme",
  "text3791": "Chci cenovou nabídku",
  "text3792": "Cenová nabídka do 24h",
  "text3793": "Potřebujete cenovou nabídku pro váš projekt? Odpovídáme do 24hodin",
  "text3794": "Odborné svařování a kovovýroba na profesionální úrovni",
  "text3795": "Náš tým je připraven nastoupit na projekt okamžitě. Kontaktujte nás ještě dnes.",
  "text3796": "nebo nám zavolejte",
  "text3797": "Vyplňte poptávkový formulář a my vás kontaktujeme zpět v co nejkratší době kde detailu probereme váš projekt.",
  "text3798": "Naše poslední realizace",
  "text3799": "Působíme napříč celou evropou",
  "text3800": "Co umíme nabídnout našim partnerům?",
  "text3801": "Viz pracovní pozice",
  "text3802": "O jakou službu máte zájem?",
  "text3803": "Vyberte službu ze seznamu",
  "text3804": "Požadované datum dodání",
  "text3805": "Projektová dokumentace",
  "text3806": "Přiložit soubor",
  "text3807": "Odesláním zprávy souhlasíte se zpracováním osobních údajů pro účely kontaktování.",
  "text3808": "V tento moment nenabízíme žádné volné pozice",
  "text3809": "V této kategorii nebyly nalezeny žádné reference.",
  "text3810": "Odstranit soubor",
  "text3811": "Na základě vyplněného formuláře cenové nabídky vás co nejdříve kontaktuji s návrhem cenové nabídky. Děkujeme za trpělivost.",
  "text3812": "Mám zájem o pracovní nabídku",
  "text3813": "Použité služby",
  "text3814": "Krok",
  "text3815": "Realizujeme projekty v rámci EU - zejména v Německu, Rakousku, Česku a na Slovensku, ale iv dalších zemích podle potřeb klienta.",
  "text3816": "Získejte cenovou nabídku pro váš projekt ještě dnes!",
  "text3817": "Nástup do práce",
  "text3818": "Typ pracovního poměru",
  "text3819": "Mzda (brutto)",
  "text3820": "O realizaci",
  "text3821": "Další realizace",
  "text3822": "Zpět na všechny články",
  "text3823": "Další články",
  "text3824": "Obsah",
  "text3825": "Pokračovat přes",
  "text3826": "nebo",
  "text3827": "Přihlášení se nezdařilo",
  "text3828": "Pro registraci přes sociální konto je nutný souhlas se zpracováním osobních údajů.",
  "text3829": "Přihlášení bylo úspěšné",
  "text3830": "E-mail ze sociálního účtu není ověřen.",
  "text3831": "Uživatelský účet nelze přihlásit.",
  "text3832": "Platnost přihlášení přes sociální konto vypršela.",
  "text3833": "Přihlášení přes sociální konto se nezdařilo.",
  "text3834": "Vyhledejte léky, vitamíny, kosmetiku...",
  "text3835": "Odkaz zkopírován do schránky",
  "text3836": "Číslo balíku / sledovací číslo...",
  "text3837": "Odstoupit od smlouvy zde",
  "text3838": "Mohlo by vás ještě zajímat.",
  "text3839": "Více o kategorii",
  "text3840": "Registrovaný účet",
  "text3841": "Vrácení zboží - odstoupení od smlouvy",
  "text3842": "Oprava zboží",
  "text3843": "",
  "text3844": "Filtrovat produkty",
  "text3845": "Souhrn podání",
  "text3846": "Přijetí",
  "text3847": "Ukončení",
  "text3848": "Nová reklamace č.:",
  "text3849": "Bezpečný nákup",
  "text3850": "Resetovat",
  "text3851": "Číst celý popis",
  "text3852": "Obsah balení",
  "text3853": "K registraci nyní získáte:",
  "text3854": "Nabídky zdarma",
  "text3855": "Topování nabídek zdarma",
  "text3856": "Kurzy zdarma",
  "text3857": "Topování kurzů zdarma",
  "text3858": "Přístupy k životopisům zdarma",
  "text3859": "pro vaše předplatné",
  "text3860": "byl vytvořen fleet přístupový kód:",
  "text3861": "Tento kód můžete sdílet s uživateli, kteří se mají připojit k vašemu předplatnému.",
  "text3862": "Maximální počet členů:",
  "text3863": "Fleet kód pro předplatné",
  "text3864": "K odeslání další zprávy o nehodě je třeba aktivně předplatné.",
  "text3865": "Potvrdit odstoupení od smlouvy",
  "text3866": "odstoupení od smlouvy č.:",
  "text3867": "výměna zboží č.:",
  "text3868": "reklamace č.:",
  "text3869": "výměnu zboží",
  "text3870": "odstoupení od smlouvy",
  "text3871": "reklamaci",
  "text3872": "1750+ originálních dílů skladem",
  "text3873": "Jaký díl hledáte?",
  "text3874": "Najít nejbližší prodejnu",
  "text3875": "Otevřít katalog",
  "text3876": "Zobrazit vše",
  "text3877": "Náhradní díly",
  "text3878": "Recenze zákazníků",
  "text3879": "Pro přidání recenze produktu je třeba přihlášení",
  "text3880": "Slevový kód",
  "text3881": "Zadejte kód",
  "text3882": "Souhrn objednávky",
  "text3883": "Pokračovat na Dopravu a platbu",
  "text3884": "Pokračovat na Doručovací údaje",
  "text3885": "Pokračovat na Shrnutí objednávky",
  "text3886": "Poznámka k objednávce",
  "text3887": "Objednávka potvrzena!",
  "text3888": "Děkujeme za Váš nákup",
  "text3889": "Potvrzení jsme odeslali na",
  "text3890": "Co bude následovat dál?",
  "text3891": "Objednávka zpracována",
  "text3892": "Váš platba proběhla úspěšně.",
  "text3893": "Příprava balíčku",
  "text3894": "Sklad připravuje vaši objednávku.",
  "text3895": "Předání dopravci",
  "text3896": "Dopravce převezme balík na doručení.",
  "text3897": "Doručení",
  "text3898": "Budete kontaktován",
  "text3899": "Otevírací doba",
  "text3900": "Expedice a sklad",
  "text3901": "Přepravci",
  "text3902": "Produkty v kolekci",
  "text3903": "V této kolekci nemáme žádné produkty",
  "text3904": "Zobrazit další články",
  "text3905": "Cenová kalkulačka",
  "text3906": "Mám zájem o revizi",
  "text3907": "Mám zájem o nabídku",
  "text3908": "Objednat bezplatnou konzultaci",
  "text3909": "Odeslat žádost o nabídku",
  "text3910": "Zobrazit podrobnosti",
  "text3911": "Zobrazit dalších 5 otázek",
  "text3912": "Začněte ještě dnes",
  "text3913": "Získejte nezávaznou cenovou nabídku na čističku odpadních vod",
  "text3914": "Raději zavolejte?",
  "text3915": "Po až Pá, 8:00 do 17:00",
  "text3916": "Jsem v blízkosti potoka",
  "text3917": "Kolik lidí bude čističku využívat?",
  "text3918": "Mám svahovitý pozemek",
  "text3919": "Porovnání nákladů",
  "text3920": "Proč se kořenová čistička odpadních vod vyplatí více než žumpa a aktivační čistička",
  "text3921": "Roční provozní náklady",
  "text3922": "Celkové náklady za 10 let",
  "text3923": "Provoz bez starostí",
  "text3924": "Od objednávky po spuštění",
  "text3925": "Jak probíhá instalace čističky odpadních vod",
  "text3926": "Mechanické předčištění v septiku",
  "text3927": "Biologické čištění bakteriemi",
  "text3928": "Kořenová filtrace rostlinami",
  "text3929": "Přírodní proces ve 4 krocích",
  "text3930": "Jak funguje kořenová čistička odpadních vod",
  "text3931": "Detailní průvodce",
  "text3932": "Čističky odpadních vod pro rodinné domy na Slovensku",
  "text3933": "Proč si vybrat ECOPLANET CZECH",
  "text3934": "Kompletní průvodce",
  "text3935": "Čistička odpadních vod ECOKOCKA",
  "text3936": "na vyžádání",
  "text3937": "individuální kalkulace",
  "text3938": "Odpovědi na vaše dotazy",
  "text3939": "Často kladené otázky o čističkách odpadních vod",
  "text3940": "Vaše jistota",
  "text3941": "Proč důvěřovat ECOPLANET CZECH",
  "text3942": "Praktické informace",
  "text3943": "Co byste měli vědět před koupí čističky odpadních vod",
  "text3944": "Reálné zkušenosti",
  "text3945": "Co říkají naši zákazníci",
  "text3946": "Google recenze",
  "text3947": "Posouvejte šipkami pro další recenze",
  "text3948": "Celé Slovensko",
  "text3949": "Čističky odpadních vod montujeme po celém Slovensku",
  "text3950": "domácností",
  "text3951": "po celém Slovensku",
  "text3952": "obcí a penzionů",
  "text3953": "Nejčastěji se ptáte",
  "text3954": "Název stránky",
  "text3955": "Kontaktní osoby",
  "text3956": "Kontaktní adresa",
  "text3957": "Termíny a ceny",
  "text3958": "Popis zájezdu",
  "text3959": "Videa",
  "text3960": "Turnus",
  "text3961": "Počet dní/nocí",
  "text3962": "Rezervováno",
  "text3963": "Neznámý stav",
  "text3964": "Cena zahrnuje",
  "text3965": "Cena nezahrnuje",
  "text3966": "Všechny zájezdy",
  "text3967": "Rezervovat schůzku",
  "text3968": "Rezervace setkání",
  "text3969": "Přihlaste se do newsletteru",
  "text3970": "Buďte první kdo se dozví o hovinkách, termínech a slevách.",
  "text3971": "Odesláním souhlasíte se zpracováním osobních údajů.",
  "text3972": "Přehled termínů",
  "text3973": "Prohlédnout program",
  "text3974": "Podobné zájezdy",
  "text3975": "Uskutečněno",
  "text3976": "Všechny termíny se již uskutečnily",
  "text3977": "Přečtěte články o Madeiře!",
  "text3978": "Nezávazně rezervovat",
  "text3979": "Nezávazná rezervace zájezdu",
  "text3980": "Nezávazná rezervace",
  "text3981": "Zadejte Vaše tel. číslo",
  "text3982": "Přidat dalšího účastníka",
  "text3983": "Vymazat účastníka",
  "text3984": "Typ setkání",
  "text3985": "Město setkání",
  "text3986": "Datum a čas",
  "text3987": "Dále",
  "text3988": "Odesílání...",
  "text3989": "Potvrdit rezervaci",
  "text3990": "Vyberte místo setkání",
  "text3991": "Místo setkání",
  "text3992": "Přihlaste se k odběru novinek a dostávejte vždy ty nejaktuálnější informace z naší nabídky.",
  "text3993": "Kde nás najdete?",
  "text3994": "V čem je naše cestovní kancelář OBJEVUJ SVĚT výjimečná?",
  "text3995": "Kancelář (provoz)",
  "text3996": "Budova INFORMATIKA ve 2. patře",
  "text3997": "Děkujeme za vaši rezervaci!",
  "text3998": "Nejbližší zájezdy",
  "text3999": "Vyplňte kontaktní údaje a přibližný rozpočet.",
  "text4000": "Žádám jako",
  "text4001": "6 000 a více",
  "text4002": "Co pro vás máme připravit?",
  "text4003": "Žádost byla odeslána",
  "text4004": "Děkujeme. Po zpracování vám cenovou nabídku pošleme e-mailem.",
  "text4005": "Číslo žádosti",
  "text4006": "Odeslat další žádost",
  "text4007": "Maximální rozpočet musí být vyšší než minimální.",
  "text4008": "Zkontrolujte označená pole.",
  "text4009": "Odeslali jste příliš mnoho žádostí. Zkuste to znovu za chvíli.",
  "text4010": "Prohlédněte si připravenou nabídku a rozhodněte se, zda ji přijmete.",
  "text4011": "Cenová nabídka se připravuje.",
  "text4012": "Cenová nabídka zatím není finální.",
  "text4013": "Nabídku jste si otevřeli. Můžete ji přijmout nebo odmítnout.",
  "text4014": "Tuto cenovou nabídku jste přijali.",
  "text4015": "Tuto cenovou nabídku jste odmítli.",
  "text4016": "Platnost této cenové nabídky vypršela.",
  "text4017": "Cenová nabídka byla převedena na objednávku.",
  "text4018": "Platná do",
  "text4019": "Bez omezení",
  "text4020": "Položky cenové nabídky",
  "text4021": "Produkty celkem",
  "text4022": "Poznámka k nabídce",
  "text4023": "Přijmout nabídku",
  "text4024": "Odmítnout nabídku",
  "text4025": "Přijmout cenovou nabídku?",
  "text4026": "Potvrzením oznámíte prodejci, že s cenovou nabídkou souhlasíte.",
  "text4027": "Odmítnout cenovou nabídku?",
  "text4028": "Potvrzením oznámíte prodejci, že cenovou nabídku nepřijímáte.",
  "text4029": "Ano, přijmout",
  "text4030": "Ano, odmítnout",
  "text4031": "O této cenové nabídce již není možné rozhodnout.",
  "text4032": "Rozhodnutí se nepodařilo uložit. Obnovte stránku a zkuste to znovu.",
  "text4033": "Dokument se nepodařilo stáhnout. Zkuste to znovu.",
  "text4034": "Cenová nabídka nebyla nalezena",
  "text4035": "Odkaz je neplatný, nabídka ještě nebyla odeslána nebo již není dostupná.",
  "text4036": "Cenovou nabídku se nepodařilo načíst",
  "text4037": "Zkuste stránku obnovit nebo se obraťte na prodejce.",
  "text4038": "Vytvořit novou žádost",
  "text4039": "Nabídka neobsahuje žádné položky.",
  "text4040": "Zobrazit produkt",
  "text4041": "Koncept",
  "text4042": "Odeslaná",
  "text4043": "Zobrazená",
  "text4044": "Přijatá",
  "text4045": "Expirovaná",
  "text4046": "Převedená na objednávku",
  "text4047": "Vyprázdnit košík?",
  "text4048": "Opravdu chcete odstranit všechny položky z košíku? Tuto akci nelze vrátit zpět.",
  "text4049": "Ano, vyprázdnit",
  "text4050": "Poprosíme uvést cenové rozpětí, protože to má vliv na nacenění.",
  "text4051": "Cenové rozpětí",
  "text4052": "Jsou toto vaše firemní údaje?",
  "text4053": "Jednotková cena s DPH",
  "text4054": "Odebrat kupón",
  "text4055": "Neaktivní",
  "text4056": "Pojištěno",
  "text4057": "Bez pojištění",
  "text4058": "Přidat vozidlo",
  "text4059": "Upravit vozidlo",
  "text4060": "Vymazat vozidlo?",
  "text4061": "Moje garáž",
  "text4062": "Datum STK a emisní kontroly",
  "text4063": "Export se nezdařil. Zkuste to prosím znovu.",
  "text4064": "Pozastavit video",
  "text4065": "Materiál",
  "text4066": "Nová konfigurace",
  "text4067": "Kroky konfigurace",
  "text4068": "Nahrajte soubor",
  "text4069": "Objednat se",
  "text4070": "Odkaz se nepodařilo zkopírovat",
  "text4071": "Údaje byly úspěšně aktualizovány",
  "text4072": "Přidat k porovnání",
  "text4073": "Odebrat z porovnání",
  "text4074": "Zpět na seznam",
  "text4075": "Region",
  "text4076": "Katalogy",
  "text4077": "Moje flotila",
  "text4078": "Přehled škod",
  "text4079": "SPZ",
  "text4080": "Datum a čas odletu",
  "text4081": "Datum a čas příletu",
  "text4082": "Číslo letenky",
  "text4083": "Číslo pasu",
  "text4084": "Zpět k parametrům",
  "text4085": "Souhrn a kontakt",
  "text4086": "Konfigurace byla odeslána",
  "text4087": "Nejnižší mzda",
  "text4088": "Nejvyšší mzda",
  "text4089": "Souhrn konfigurace",
  "text4090": "Aktualizováno:",
  "text4091": "Kontaktní e-mail *",
  "text4092": "Načítám konfigurace...",
  "text4093": "Použít kód",
  "text4094": "Poznámka (volitelné)...",
  "text4095": "Rozpracované konfigurace",
  "text4096": "Zatím zde nejsou žádné produkty",
  "text4097": "Konfiguraci se nepodařilo načíst",
  "text4098": "Konfiguraci se nepodařilo odeslat",
  "text4099": "Konfiguraci se nepodařilo otevřít",
  "text4100": "Konfiguraci se nepodařilo uložit",
  "text4101": "Načíst z registru",
  "text4102": "Odhadovaná cena",
  "text4103": "Odesláno",
  "text4104": "Odeslané cenové nabídky",
  "text4105": "Cenovou nabídku zašleme e-mailem",
  "text4106": "pro účely vystavení cenové nabídky v souladu s GDPR.",
  "text4107": "Přidat dotaz k produktu",
  "text4108": "",
  "text4109": "",
  "text4110": "",
  "text4111": "",
  "text4112": "",
  "text4113": "",
  "text4114": "",
  "text4115": "",
  "text4116": "",
  "text4117": "",
  "text4118": "",
  "text4119": "",
  "text4120": "",
  "text4121": "",
  "text4122": "",
  "text4123": "",
  "text4124": "",
  "text4125": "",
  "text4126": "",
  "text4127": "",
  "text4128": "",
  "text4129": "",
  "text4130": "",
  "text4131": "",
  "text4132": "",
  "text4133": "",
  "text4134": "",
  "text4135": "",
  "text4136": "",
  "text4137": "",
  "text4138": "",
  "text4139": "",
  "text4140": "",
  "text4141": "",
  "text4142": "",
  "text4143": "",
  "text4144": "",
  "text4145": "",
  "text4146": "",
  "text4147": "",
  "text4148": "",
  "text4149": "",
  "text4150": ""
}) satisfies TranslationDictionary;
